import { configService } from './config';

// 支持的语言类型
export type LanguageType = 'zh' | 'zh-TW' | 'en';

// 语言文本映射
const translations: Record<LanguageType, Record<string, string>> = {
  zh: {
    // App 扫码登录：状态保存翻译键，切换语言不重建扫码会话。
    authAppQrTab: "App 扫码",
    authAppQrRegion: "App 扫码登录",
    authAppQrTitle: "使用 App 扫码登录",
    authAppQrCreating: "正在生成二维码…",
    authAppQrPlatformChanged: "平台已切换，请重新生成二维码",
    authAppQrExpired: "二维码已过期",
    authAppQrLogging: "正在登录…",
    authAppQrSuccess: "登录成功",
    authAppQrInitFailed: "登录初始化失败，请重新登录",
    authAppQrCancelled: "二维码已取消或已使用",
    authAppQrPending: "等待手机扫码",
    authAppQrScanned: "已扫码",
    authAppQrVerifying: "等待两步验证",
    authAppQrDeciding: "正在验证授权…",
    authAppQrUnconfirmed: "登录结果未确认，请重新生成二维码",
    authAppQrInvalid: "二维码已失效，请重新生成",
    authAppQrRetrying: "连接暂时中断，正在重试…",
    authAppQrDisabled: "App 扫码登录已关闭，请使用其他方式登录",
    authAppQrUnavailable: "二维码暂不可用，请稍后重试",
    authAppQrInstructions: "打开 App → 设置 → 扫一扫登录",
    authAppQrExpiryHint: "二维码仅可使用一次，将在 {minutes} 分钟内过期",
    authAppQrConfirmHint: "请在手机上确认登录",
    authAppQrVerifyHint: "请在手机上输入两步验证码",
    authAppQrLoggingHint: "手机已授权，正在建立会话",
    authAppQrSuccessHint: "正在进入 {app}…",
    authAppQrDecidingHint: "请稍候，正在校验手机授权",
    authAppQrCheckCode: "核对码 {code}",
    authAppQrBack: "返回其他登录方式",
    authAppQrRefresh: "刷新二维码",
    authAppQrRegenerate: "重新生成二维码",

    loginPhoneRegion: "手机区号",
    loginPhoneMainland: "中国大陆",
    loginPhoneHongKong: "中国香港",
    loginSwitchPhone: "手机号",
    loginSwitchPassword: "账号密码",
    loginSwitchWechat: "微信扫码",
    loginSmsLabel: "短信验证码",

    loginSmsFrequent: "发送过于频繁，请稍后再试",
    loginSmsDailyLimit: "今日验证码发送次数已达上限",
    loginSmsInvalid: "验证码错误，请重新输入",
    loginSmsExpired: "验证码已过期，请重新获取",
    loginSmsInvalidOrExpired: "验证码错误或已过期，请重新获取",

    loginOtherMethods: "其他方式",
    loginPasswordMethod: "账号密码登录",
    loginWeChatMethod: "微信扫码登录",
    loginRegister: "登录 / 注册",
    loginForgot: "忘记密码？",
    loginShowPassword: "显示密码",
    loginHidePassword: "隐藏密码",
    loginResend: "重新获取",
    loginCountdown: "{seconds}s 后重发",
    loginCodeInvalid: "请输入 6 位验证码",
    loginPasswordInvalid: "账号或密码错误",
    loginAccountRequired: "请输入账号",
    loginPasswordRequired: "请输入密码",
    loginPhoneUnavailable: "手机号登录暂未开放，请使用账号密码登录",
    loginWeChatUnavailable: "微信登录暂未开放，请使用其他方式登录",
    loginLoadingMethods: "正在加载登录方式…",
    loginConsentQr: "请先阅读并同意下方协议，再加载二维码",
    loginScan: "打开微信 · 扫一扫",
    loginScanRegister: "首次扫码需绑定手机号后登录",
    loginRetryQr: "点击刷新",
    loginSending: "发送中…",
    loginAccount: "账号",
    loginPassword: "密码",
    loginAssistant: "AI 智能助手",

    settingsBasicGroup: '基础设置',
    settingsCapabilityGroup: '协作能力',
    settingsSystemGroup: '系统',

    customAgentFixedModel: "Agent 指定模型",
    personalStorageTitle: "Web 文件与缓存",
    personalStorageRefresh: "刷新",
    personalStorageUnknown: "暂不可用",
    personalStorageFailed: "存储检查失败，请稍后重试",
    personalStorageScope: "统计当前账号在 Web 服务端保存的附件、产物、文档素材和会话缓存。这里不是沙箱磁盘管理，不统计或清理 Cube 挂载工作区，也不包含桌面客户端文件。",
    personalStorageChecking: "正在检查存储…",
    personalStorageTotal: "Web 会话文件占用",
    personalStorageIncomplete: "部分分类暂不可用，已知分类仍可查看，请稍后刷新。",
    personalStoragelegacy: "旧版会话文件与缓存",
    personalStoragedocuments: "文档修订与素材",
    personalStorageinputs: "会话附件",
    personalStorageartifacts: "生成产物与临时上传",
    personalStorageFiles: "项",
    personalStoragePolicy: "仅清理失败或过期的临时产物上传。已保存的会话附件、生成产物及正在上传的文件保留。确认时会再次检查文件状态；预览五分钟有效。",
    personalStoragePreview: "预览清理范围",
    personalStorageRemoved: "已清理",
    personalStorageSkipped: "状态变化已跳过",
    personalStorageFailedCount: "失败",
    personalStorageCancel: "取消",
    personalStorageConfirm: "确认清理",
    backgroundTasksTitle: "后台任务",
    backgroundTasksHint: "查看本会话的子代理与后台执行。关闭面板不会停止任务，子任务完成不代表整个对话完成。",
    backgroundTasksRefresh: "刷新任务",
    backgroundTasksClose: "关闭任务面板",
    backgroundTasksFailed: "任务检查失败，请稍后刷新",
    backgroundTasksunsupported: "当前沙箱或会话不支持任务控制。历史记录仅供查看。",
    backgroundTasksdisconnected: "执行连接暂不可用。以下为最后记录，活动任务状态需要重新确认。",
    backgroundTasksChecked: "最后检查",
    backgroundTasksLoading: "正在读取任务…",
    backgroundTasksEmpty: "当前没有已记录的后台任务",
    backgroundTasksrunning: "运行中",
    backgroundTaskscompleted: "已完成",
    backgroundTasksfailed: "失败",
    backgroundTasksstopped: "已停止",
    backgroundTaskspending: "等待中",
    backgroundTasksunknown: "待确认",
    backgroundTasksAgent: "子代理",
    backgroundTasksShell: "后台命令",
    backgroundTasksGeneric: "任务",
    backgroundTasksLocate: "定位对话",
    backgroundTasksStop: "停止任务",
    backgroundTasksTruncated: "仅展示最近保留的 200 项任务，较早记录可能已省略。",
    backgroundTasksStopHint: "仅停止这个子任务，不取消整个对话。已经产生的文件改动不会回滚；需要服务端确认后才显示停止结果。",
    backgroundTasksCancel: "取消",
    backgroundTasksConfirmStop: "确认停止",
    memoryCatalogScope: "记忆范围",
    memoryCatalogPersonal: "个人记忆文件",
    memoryCatalogLegacy: "旧全局记忆（兼容）",
    memoryCatalogRefresh: "刷新记忆目录",
    memoryCatalogNew: "新增记忆",
    memoryCatalogPersonalHint: "当前账号的个人记忆文件，供普通对话和秘书按问题召回。普通对话遵守记忆开关；归档后不再召回。SOUL 人设及会话内部记忆保持独立。",
    memoryCatalogLegacyHint: "保留旧客户端同步的全局文件，归属仅限当前账号。这里的内容不会自动合并或覆盖个人记忆。",
    memoryCatalogSearch: "搜索记忆名称或正文",
    memoryCatalogLoading: "正在读取记忆目录…",
    memoryCatalogEmpty: "没有匹配的记忆文件",
    memoryCatalogActive: "生效",
    memoryCatalogArchived: "已归档",
    memoryCatalogOther: "其他状态",
    memoryCatalogEdit: "编辑与历史",
    memoryCatalogArchive: "归档",
    memoryCatalogMore: "加载更多",
    memoryCatalogName: "文件名（不含扩展名）",
    memoryCatalogContent: "记忆内容",
    memoryCatalogFormatHint: "可以直接填写事实正文，或保留 Markdown 文件头；请勿把人设指令写入事实记忆。",
    memoryCatalogArchiveHint: "归档后退出后续事实召回，正文和修订保留，可从编辑器恢复历史版本。",
    memoryCatalogCancel: "取消",
    memoryCatalogCreate: "创建",
    memoryCatalogConfirmArchive: "确认归档",
    memoryCatalogUnavailable: "记忆服务暂不可用，请稍后重试",
    memoryCatalogOpen: "个人记忆",
    memoryCatalogClose: "关闭记忆管理",
    customAgentPolicy: "Agent 按账号独立保存，使用平台模型与每会话隔离的云端目录。配置修改只影响新会话，已有会话保留创建时版本。",
    customAgentLoadFailed: "Agent 列表加载失败",
    customAgentReload: "重新载入",
    customAgentSaveFailed: "保存失败，请重试",
    customAgentNew: "新建 Agent",
    customAgentEnabled: "已启用",
    customAgentDisabled: "已停用",
    customAgentname: "名称",
    customAgentdescription: "用途说明",
    customAgentrole: "角色",
    customAgentsystemPrompt: "指令",
    customAgentModel: "模型",
    customAgentCurrentModel: "使用新会话所选模型",
    customAgentModelUnavailable: "当前不可用",
    customAgentDelete: "删除",
    customAgentSave: "保存",
    customAgentSaving: "保存中…",
    customAgentDeleteHint: "仅删除 Agent 定义；已有会话、配置快照与文件会保留。",
    customAgentCancel: "取消",
    customAgentSelect: "选择 Agent",
    customAgentDefault: "默认助手",
    customAgentManage: "管理 Agent",
    customAgentClose: "关闭",
    customAgentSnapshot: "创建时 Agent 配置",

    conversationResultsTitle: "来源与产物",
    conversationResultsHint: "根据本轮工具与文件记录检查",
    conversationResultsFailed: "检查失败，请刷新重试",
    conversationResultsDownloadFailed: "下载失败，请刷新检查后重试",
    conversationResultsRefresh: "重新检查",
    conversationResultsChecking: "正在检查…",
    conversationResultsverified: "文件校验通过",
    conversationResultsinvalid: "内容校验未通过",
    conversationResultsunavailable: "暂不可用",
    conversationResultsunverified: "内容待检查",
    conversationResultsDownload: "下载",
    conversationResultsSources: "本轮来源",
    conversationResultsEmpty: "本轮暂无可核验的托管产物或结构化搜索来源；不代表任务已完整交付。",
    conversationResultsTruncated: "本次展示前 20 个产物，请在文件面板查看其余文件。",

    telegramTokenHint: "从 @BotFather 获取 Bot Token；令牌仅保存到当前账号的连接实例。",
    imInstancesTitle: "连接实例",
    imInstancesDefault: "默认连接",
    qq: 'QQ',
    wechat: '微信',
    imWechatWebHint: '使用微信扫描二维码并确认登录。凭据仅保存到当前连接，登录后请手动启用；重新扫码前先停用。',
    imWechatAccount: '微信账号',
    imPairingScan: '请扫码并在手机上确认',
    imPairingScanned: '已扫码，等待确认',
    imPairingSaved: '登录已保存，请启用连接',
    imPairingExpired: '二维码已过期，请重新获取',
    imPairingStart: '扫码登录',
    imPairingFailed: '扫码失败，请重试',
    imNotificationTitle: "任务通知",
    imNotificationHint: "为当前连接选择接收会话。只有定时任务勾选本平台后才会通知；新消息不会改变你的选择。",
    imNotificationTarget: "接收会话",
    imNotificationNone: "不接收通知",
    imNotificationDirect: "私聊",
    imNotificationGroup: "群聊",
    imNotificationEmpty: "请先让接收人在机器人会话中发一条消息，然后刷新列表。",
    imNotificationWechatHint: "微信通知需要有效会话上下文。服务重启或上下文过期后，请让接收人重新发一条消息。",
    imNotificationSent: "最近一次通知已被平台接收",
    imNotificationFailed: "最近一次通知未确认，请检查连接、接收会话和平台发送限制；不会自动重发。",
    imNotificationNotSelected: "未设置接收会话，通知未发送",
    imNotificationRequestFailed: "通知设置读取或保存失败，请刷新后重试。",
    scheduledTasksNotificationFailed: "任务通知未确认，请在聊天入口的对应连接中检查接收会话和发送状态。",
    scheduledTasksNotifyTargetHint: "请先在聊天入口中设置接收会话。所选平台下每个已设置目标的连接实例都会收到通知。",
    scheduledTasksFormNotifyQq: "QQ",
    scheduledTasksFormNotifyWechat: "微信",
    scheduledTasksFormNotifyWechatwork: "企业微信",
    scheduledTasksFormNotifyNim: "网易云信",
    imQQConnectMode: 'QQ连接方式',
    imQQManualMode: '手动配置',
    imQQPairingHint: '使用手机QQ扫描并完成官方机器人绑定。凭据仅保存到当前连接，完成后请手动启用。',
    imQQWebHint: '填写QQ开放平台的App ID与App Secret，保存后测试并启用。支持频道、群和私聊；修改凭据前先停用连接。',
    imInstancesHint: "配置并启用后，可在聊天软件中向机器人发任务并接收结果。仅打开本页不会建立连接；每个账号、每个机器人实例的配置独立保存。",
    imInstancesAdd: "添加实例",
    imInstancesDelete: "删除实例",
    imInstancesDeleteHint: "删除会停止此实例并移除配置。已有聊天、文件和积分账单会保留。",
    imInstancesName: "实例名称",
    imInstancesPlatform: "平台",
    imInstancesFailed: "操作失败，请重试",
    imInstancesUnsupported: "当前执行端不支持实例管理",

    coworkModelSaveFailed: "模型切换未保存，仍使用原模型。请稍后重试。",
    coworkContinueInstruction: "请基于此前已完成的结果继续当前任务。保留已有成果，不要重复已经成功执行的操作。",
    coworkRecoveryContinue: "继续任务",
    coworkRecoverySending: "正在提交…",
    coworkRecoverySubmitted: "已提交",
    coworkRecoveryFailed: "继续请求未确认，请检查连接后再试。",
    coworkRecoveryWait: "请稍后再试",

    turnDelete_title: "按轮次删除",
    turnDelete_hint: "每轮包含提问、回答及工具消息。删除不可撤销；文件、独立记忆和已扣积分保留。最多选择 200 轮。续聊时会重新构建模型上下文；旧沙箱可能需要更新。",
    turnDelete_busy: "会话正在执行或排队，请结束后再删除。",
    turnDelete_unsupported: "此旧会话暂不支持安全重置历史，请在新版会话中使用。",
    turnDelete_failed: "删除未确认，选择已保留。请刷新会话核对后重试。",
    turnDelete_attachment: "附件消息",
    turnDelete_count: "已选择 {count} 轮",
    turnDelete_confirm: "确认永久删除所选轮次？",
    turnDelete_confirmButton: "确认永久删除",
    turnDelete_delete: "删除所选轮次",
    turnDelete_deleting: "正在删除…",

    campaign_title: "活动福利",
    campaign_close: "关闭活动",
    campaign_details: "查看详情",
    campaign_claim: "领取",
    campaign_claimed: "今日已领取",
    campaign_success: "已领取 {credit} 积分",
    campaign_total: "累计领取 {credit} 积分",
    campaign_failed: "领取结果暂未确认，正在刷新资格。请查看积分余额后再操作。",

    memoryFile_title: "编辑记忆文件",
    memoryFile_hint: "保留文件头信息。保存会生成历史版本；其他设备修改后需重新加载。",
    memoryFile_history: "版本历史",
    memoryFile_current: "当前版本",
    memoryFile_preview: "历史内容（只读）",
    memoryFile_content: "文件内容",
    memoryFile_reload: "重新加载",
    memoryFile_restore: "恢复此版本",
    memoryFile_restoreConfirm: "恢复会生成新版本，并替换当前草稿。继续恢复？",
    memoryFile_discardConfirm: "有未保存的修改，确认放弃？",
    memoryFile_unavailable: "记忆文件暂不可用",
    memoryFile_manual: "手动编辑",
    memoryFile_restoreActor: "恢复版本",
    memoryFile_model: "模型更新",
    memoryFile_system: "系统更新",
    memoryFile_organizer: "记忆整理",
    memoryFile_fileName: "文件名（不含 .md）",
    memoryFile_rename: "重命名",
    memoryFile_renameConfirm: "重命名会保留内容和历史，并同步旧名称的删除。继续？",
    memoryFile_renameHint: "支持小写字母、数字、中文、下划线及连字符；文件名与正文名称独立。",
    memoryFile_saveBeforeRename: "请先保存或重新加载当前草稿，再重命名。",
    memoryFile_renameActor: "重命名文件",
    memoryFile_soulEditHistory: "编辑 Soul 与版本历史",
    memoryFile_soulHint: "身份与交互方式独立保存，不进入事实同步。恢复默认先生成草稿，保存后生效。",

    creditForbidden: "当前账号无权查询积分或已被禁用。",
    creditNoPlan: "暂无套餐或赠送额度",
    creditOtherSource: "其他来源",
    // 用户积分与账户：沿用平台计量单位，不混用实扣和模拟用量。
    creditTitle: "积分与用量",
    creditRefresh: "刷新",
    creditLoading: "正在读取积分…",
    creditUnsupported: "当前平台尚不支持此积分查询。",
    creditSignIn: "请重新登录后查看积分。",
    creditUnavailable: "积分数据暂时不可用，请稍后刷新。",
    creditStale: "以下为上次成功读取的数据，可能已过期。",
    creditNoExpiry: "未设置 / 不适用",
    creditUnit: "积分",
    creditShadow: "影子计费：用量为模拟应扣积分，不代表实际扣款。",
    creditOff: "当前未启用积分计费；余额为平台记录，不将用量展示为实扣积分。",
    creditDebt: "待结清欠款",
    creditWallet: "钱包余额",
    creditWalletHint: "不与套餐或企业共享池重复相加。",
    creditSubscription: "套餐与赠送剩余",
    creditUnlimited: "不限量",
    creditUsed: "已用",
    creditIssued: "本期额度",
    creditBase: "基础额度",
    creditBonus: "赠送额度",
    creditReset: "下次重置",
    creditPool: "企业共享池剩余",
    creditPoolHint: "这是共享额度，不是个人独占余额。",
    creditSimulatedUsage: "模拟用量（积分）",
    creditUsage: "积分用量",
    creditToday: "今日",
    creditWeek: "近 7 天",
    creditMonth: "近 30 天",
    creditPartial: "部分区间统计不可用；“—”表示未知，不是零消费。",
    creditDailyLimit: "每日额度已用 / 上限",
    creditInventory: "积分来源与到期明细",
    creditHistory: '收支记录',
    creditHistoryFilter: '记录类型',
    creditHistoryHint: '按平台记录展示领取、充值与消费。未提供的历史积分金额显示为 —，不由余额推算。',
    creditHistoryUsed: '消耗积分',
    creditHistorySimulated: '模拟费用',
    creditHistoryPrevious: '上一页',
    creditHistoryNext: '下一页',
    creditLogType0: '全部记录',
    creditLogType1: '充值',
    creditLogType2: '消费',
    creditLogType3: '账户变动',
    creditLogType4: '系统记录',
    creditLogType5: '错误记录',
    creditLogType6: '退款',
    creditInventoryHint: "按发放批次展示；钱包只显示当前余额，不推算历史充值或消耗。",
    creditEmpty: "暂无积分来源记录。",
    creditPlan: "套餐",
    creditReward: "奖励 / 赠送",
    creditExpired: "已失效",
    creditActive: "有效",
    creditRemaining: "剩余",
    creditExpiry: "到期时间",
    creditSource: "来源",
    creditUpdated: "最近更新",
    // 通用
    save: '保存',
    cancel: '取消',
    saving: '保存中...',
    create: '创建',
    user: '用户',
    login: '登录',
    loginWelcome: '登录你的账户',
    loginSubtitle: '欢迎回来，请输入你的登录信息',
    register: '注册',
    logout: '退出登录',
    inDevelopment: '正在开发中',
    all: '全部',
    assigned: '已分配',
    unassigned: '未分配',
    featured: '精选',
    personal: '个人',
    skillsEmpty: '暂无技能',
    skillCreatorPrompt: '帮我创建一个新技能。首先问我这个技能应该做什么。',
    retry: '重试',
    imagePreview: '预览图片',
    imageOriginalSize: '原始尺寸',
    imageFitWindow: '适应窗口',
    imageLoadFailed: '图片加载失败，请重试',
    retrying: '重试中...',
    platformOfflineMessage: '平台服务暂时不可用，已登录状态保留，本地功能可继续使用',
    builtinSkillsDescription: '管理员为您所属部门分配的精选技能，沙箱执行时自动挂载',
    categoryAnalysis: '数据分析',
    categoryEducation: '教育学习',
    categoryOther: '其他',
    categoryCollaboration: '通讯协作',
    createViaChat: '通过对话创建',
    createViaChatDescription: '描述你的需求，AI 帮你生成',
    skillDuplicateDisabled: '已选择同名技能的其他版本',
    skillCreatorBothDisabled: '个人技能和内置技能中都有 skill-creator 但均未启用，请先开启',
    skillCreatorBuiltinDisabled: '内置技能中 skill-creator 已关闭，请先在内置技能中开启',
    skillCreatorPersonalDisabled: 'skill-creator 技能未启用，请先在个人技能中开启',
    skillCreatorMissing: '您尚未拥有 skill-creator 技能，请联系管理员分配',
    authAccount: '账户',
    authAccountStatus: '账户状态',
    authAccountSettings: '账户设置',
    authSignIn: '登录',
    authUsername: '账号',
    authUsernamePlaceholder: '输入账号',
    authPhone: '手机号',
    authPhonePlaceholder: '输入手机号',
    authVerificationCode: '验证码',
    authVerificationCodePlaceholder: '输入手机验证码',
    authTwoFactorTitle: '二步验证',
    authTwoFactorCode: '2FA 验证码',
    authTwoFactorCodePlaceholder: '输入 2FA 验证码',
    authTwoFactorCodeRequired: '请输入 2FA 验证码',
    authTwoFactorRequired: '该账号需要 2FA 验证，请继续输入验证码',
    authBackToLogin: '返回登录',
    authUsernamePasswordRequired: '请输入账号和密码',
    authCaptchaRequired: '请输入验证码',
    authLoginTabPassword: '密码登录',
    authLoginTabPhone: '手机号登录',
    authLoginTabWeChat: '微信扫码',
    authSendSmsCode: '获取验证码',
    authSmsCountdownSecond: '{seconds}s',
    authSmsCodeSent: '验证码已发送',
    authInvalidPhone: '请输入正确的手机号',
    authPhoneCodeRequired: '请填写手机号和验证码',
    authWeChatScanHint: '请使用微信扫描二维码登录',
    authWeChatQrLoading: '二维码加载中...',
    authWeChatQrExpired: '二维码已过期，请刷新',
    authRefreshQrCode: '刷新二维码',
    authWeChatBindPhoneTitle: '绑定手机号',
    authWeChatBindPhoneHint: '请验证并绑定手机号，完成注册后即可登录；已有手机号账号将关联本次微信。',
    authRegisterRequired: '请完整填写注册所需字段',
    authLoginSuccess: '登录成功',
    authRegisterSuccess: '注册成功，请登录',
    authAgreePrefix: '我已阅读并同意',
    authUserAgreement: '用户协议',
    authAnd: '和',
    authPrivacyPolicy: '隐私政策',
    authPleaseAgree: '请先阅读并同意用户协议和隐私政策',
    authNoAccount: '还没有账户？',
    authGoToRegister: '前往注册',
    authLogoutSuccess: '已退出登录',
    authTokenExpired: '登录状态已失效，可能由于账号密码变更或被管理员下线，请重新登录',
    authSessionExpired: '登录状态已过期，请重新登录',
    // OAuth 授权页面
    oauthAuthorizeTitle: '授权 {orgCode} 客户端',
    oauthAuthorizeDesc: '客户端正在请求访问您的 {orgCode} 账户',
    oauthAuthorizeButton: '授权并继续',
    oauthLoginTitle: '登录以授权客户端',
    oauthLoginDesc: '请登录您的 BoCoder 账户以授权客户端访问',
    oauthLoginAndAuthorize: '登录并授权',
    oauthVerifyAndAuthorize: '验证并授权',
    oauthRedirecting: '授权成功',
    oauthSuccessDesc: '已完成身份验证，请返回 {orgCode} 客户端继续使用。\n您可以安全地关闭此页面。',
    oauthInvalidRedirect: '无效的回调地址',
    oauthClientHint: '应用 {clientId} 正在请求授权',
    authNotLoggedIn: '当前未登录 BoCoder 账户',
    authUserStatus: '状态',
    authUserStatusNormal: '正常',
    authUserStatusUnknown: '未知状态',
    authSession: '会话',
    authSessionEmpty: '登录后可在这里管理当前账户会话',

    // 设置
    help: '帮助',
    settings: '设置',
    edit: '编辑',
    delete: '删除',
    general: '通用',
    model: '模型',
    shortcuts: '快捷键',
    theme: '主题',
    accentColor: '主题色',
    appearance: '外观',
    language: '语言',
    useSystemProxy: '使用系统代理',
    useSystemProxyDescription: '开启后网络请求将跟随系统代理（保存后生效）',
    quickActionSuggestions: '对话辅助提示',
    quickActionSuggestionsDescription: '任务完成后自动推荐后续操作（由 LLM 生成，会消耗少量 Token）',
    light: '浅色',
    dark: '深色',
    system: '跟随系统',
    chinese: '简体中文',
    traditionalChinese: '繁体中文',
    english: 'English',
    
    // 提供商标签
    providerLabelCustom: '自定义',
    apiKeyGetHelp: '获取 API Key',

    // API设置
    apiKey: 'API Key',
    apiKeyPlaceholder: '输入你的 API Key',
    baseUrl: 'API Base URL',
    baseUrlPlaceholder: '输入 API 基础 URL',
    baseUrlHint1: '一般只需填写域名，系统自动补全路径',
    baseUrlHintExample1: 'https://ai.boclaw.ai',
    baseUrlHint2: '非标准路径可填写完整地址',
    baseUrlHintExample2: 'https://ai.boclaw.ai/api/v3/chat/completions',
    currentModel: '当前模型',
    availableModels: '可用模型列表',
    modelSwitchHint: '在聊天界面可以切换使用的模型',
    
    // 模型提供商设置
    enabled: '已启用',
    disabled: '已禁用',
    providerStatusOn: '已开启',
    providerStatusOff: '未开启',
    providerSettings: '提供商设置',
    modelProviders: '模型提供商',
    addModel: '添加模型',
    editModel: '编辑模型',
    addNewModel: '添加新模型',
    modelName: '模型名称',
    modelId: '模型ID',
    modelNameAndIdRequired: '请填写模型名称和模型ID',
    modelIdExists: '模型ID已存在，请使用不同的ID',
    supportsImageInput: '支持图像输入',
    imageInput: '图像',
    noModelsAvailable: '暂无可用模型',
    addFirstModel: '添加第一个模型',
    testConnection: '测试连接',
    testing: '测试中...',
    connectionSuccess: '连接成功',
    connectionFailed: '连接失败',
    testConnectionAuthError: 'API Key 无效或已过期',
    testConnectionModelNotFound: '连接正常，但该模型不存在或无权访问',
    testConnectionRateLimited: '连接正常，但请求频率超限，请稍后再试',
    testConnectionNetworkError: '网络连接失败，请检查网络或开启系统代理',
    noModelsConfigured: '请先添加模型',
    fetchModels: '刷新模型列表',
    fetchingModels: '刷新中...',
    fetchModelsSuccess: '已刷新 {count} 个模型',
    fetchModelsFailed: '刷新模型列表失败',
    apiFormat: 'API 格式',
    apiFormatNative: 'Anthropic 兼容',
    apiFormatOpenAI: 'OpenAI 兼容',
    apiFormatHint: '请选择 API 协议兼容格式：Anthropic 兼容或 OpenAI 兼容',
    zhipuCodingPlanHint: '启用后使用 GLM Coding Plan 专属 API 端点',
    zhipuCodingPlanEndpointHint: '使用 GLM Coding Plan 时，系统将自动切换到 Coding 专属端点',
    qwenCodingPlanHint: '启用后使用阿里云百炼 Coding Plan 专属 API 端点',
    qwenCodingPlanEndpointHint: '使用 Coding Plan 时，需要配置专属的 API Key（格式：sk-sp-xxxxx）',
    moonshotCodingPlanHint: '启用后使用 Moonshot Coding Plan 专属 API 端点',
    moonshotCodingPlanEndpointHint: '使用 Coding Plan 时，系统将自动切换到 Coding 专属端点',
    import: '导入',
    export: '导出',
    importProvidersFailed: '导入失败',
    exportProvidersFailed: '导出失败',
    invalidProvidersFile: '导入文件格式不正确',
    decryptProvidersFailed: '密钥解密失败，请确认文件由当前设备导出',
    decryptProvidersPartial: '部分密钥无法解密，已保留本地密钥或留空，请手动检查',

    // 密码相关
    password: '密码',
    confirmPassword: '确认密码',
    enterPassword: '请输入密码',
    enterPasswordAgain: '请再次输入密码',
    exportPasswordTitle: '设置导出密码',
    importPasswordTitle: '输入导入密码',
    exportPasswordHint: '此密码用于加密你的 API 密钥，导入时需要使用相同的密码',
    importPasswordHint: '请输入导出时设置的密码',
    passwordRequired: '请输入密码',
    passwordMismatch: '两次输入的密码不一致',
    passwordTooShort: '密码长度至少为4位',
    wrongPassword: '密码错误，请检查后重试',
    
    // 快捷键
    keyboardShortcuts: '键盘快捷键',
    // 产品分组（侧边栏入口）
    productGroup: '产品',
    codeProgramming: 'Code 编程',
    appDownloadEntry: 'App 下载',
    codeBetaBadge: '公测',
    // Code 编程页（走中继控制 desktop）
    codeDeviceUnconnected: '未连接设备',
    codeNoOnlineDesktop: '无在线桌面端。请在电脑上登录 BoCoder 桌面端并保持运行。',
    codeCloudEnv: '云端环境',
    codeCloudEnvTag: '云端',
    codeGitRepoLabel: '从 Git 仓库开始（必填）',
    codeGitRepoPlaceholder: '仓库地址（必填）',
    codeGitBranchPlaceholder: '分支',
    codeGitUsernamePlaceholder: '用户名',
    codeGitPasswordPlaceholder: '密码/Token',
    codeToastNoRepo: '请先填写仓库地址',
    codeExecutionMode: '执行模式',
    codePermModeAuto: '自动模式',
    codePermModeDefault: '默认',
    codePermModeAcceptEdits: '自动接受编辑',
    codePermModePlan: '计划模式',
    codePermModeBypassPermissions: '跳过所有权限',
    codeCloudEmptyHint: '描述你的需求，消息将在云端沙箱中执行，无需本地桌面端',
    codeToastCloudUnreachable: '无法连接云端环境，请稍后重试',
    codeNewSession: '新建会话',
    codeNoSessions: '暂无编程会话，发消息即可开始',
    codeSelectDeviceFirst: '请先选择一台在线桌面端',
    codeUntitledSession: '未命名会话',
    codeNewSessionCwd: '~ 新会话',
    codeCwdTitle: '工作目录',
    codeCwdUseDefault: '使用默认',
    codeCwdSelectThis: '选定此目录',
    codeCwdParent: '上级目录',
    codeCwdNoSub: '无子目录',
    codeCwdTruncated: '仅显示前 200 项',
    codeCwdDefaultLabel: '默认目录',
    codeCwdLoadFailed: '加载目录失败',
    codeRunning: '运行中',
    codeEmptyTitle: '开始编程',
    codeSelectDesktopToStart: '选择一台桌面端开始',
    codeEmptyHint: '消息会发送到你的桌面端，由本机的 Code 引擎执行',
    codePermissionTool: '请求执行工具',
    codeAllow: '允许',
    codeAllowAlways: '始终允许',
    codeDeny: '拒绝',
    codeComposerPlaceholder: '给 Code 发消息…（Enter 发送，Shift+Enter 换行）',
    codeComposerDisabled: '请先选择在线桌面端',
    codeStop: '停止',
    codeThinking: '思考中',
    codeJustNow: '刚刚',
    codeToastDeviceUnreachable: '无法连接所选设备，请确认桌面端在线',
    codeToastNoDesktop: '没有可用的桌面设备',
    codeToastLoadSessionFailed: '加载会话失败',
    codeToastSendFailed: '发送失败',
    codeToastStopFailed: '停止失败',
    codeToastPermissionFailed: '权限响应失败',
    codeToastModelFailed: '切换模型失败',
    codeToastModeFailed: '切换模式失败',
    codeSearchPlaceholder: '搜索会话',
    codeDeleteSession: '删除会话',
    codeDeleteConfirm: '确定删除该会话？此操作不可撤销。',
    codeToastDeleteFailed: '删除失败',
    codeNoSessionMatch: '没有匹配的会话',
    codeStatusIdle: '空闲',
    codeStatusRunning: '运行中',
    codeStatusStopped: '已停止',
    codeStatusError: '错误',
    codeCollapseSidebar: '收起侧栏',
    codeExpandSidebar: '展开侧栏',
    codeAgentWorking: '工具调用',
    codeThinkingProcess: '思考过程',
    codeClickExpand: '点击展开',
    codeNoOutput: '无输出',
    codeNavSessions: '编程会话',
    codeNavNewSession: '新建会话',
    codeNavSkills: '技能中心',
    codeNavTasks: '定时任务',
    codeManage: '管理',
    codeManageDone: '完成',
    codePin: '置顶',
    codeUnpin: '取消置顶',
    codeRename: '重命名',
    codeRenamePrompt: '输入新的会话名称',
    codeMore: '更多',
    codeSelectAll: '全选',
    codeBatchDelete: '删除选中',
    codeBatchDeleteConfirm: '确定删除选中的会话？此操作不可撤销。',
    codeToastRenameFailed: '重命名失败',
    newChat: '新建任务',
    search: '搜索任务',
    openSettings: '打开设置',
    close: '关闭',
    loginNotAvailable: '登录功能暂未开放',
    collapse: '收起',
    expand: '展开',
    downloadDesktopApp: '下载桌面应用',
    downloadMac: 'macOS',
    downloadWin: 'Windows',
    downloadLinuxArm64: 'Linux ARM64',
    downloadLinuxX64: 'Linux x64',
    featureInDevelopment: '正在开发中',
    
    // 错误信息
    failedToLoadSettings: '加载设置失败',
    failedToSaveSettings: '保存设置失败',
    settingsSaveSuccess: '设置已保存',
    
    // 加载状态
    loading: '加载中...',
    
    // 侧边栏
    conversations: '对话',
    noConversations: '暂无对话',
    createNewChat: '新建对话',
    deleteConversation: '删除对话',
    renameConversation: '重命名',
    moveToProject: '移至项目',
    pinConversation: '置顶聊天',
    unpinConversation: '取消置顶',
    noProject: '无项目',
    noProjects: '暂无项目',
    confirmDelete: '确认删除',
    confirmDeleteMessage: '确定要删除这个对话吗？此操作不可撤销。',
    searchChats: '搜索聊天',
    searchConversations: '搜索任务...',
    searchNoResults: '未找到匹配任务',
    projects: '项目',
    yourChats: '你的聊天',
    createProject: '新项目',
    projectNamePlaceholder: '项目名称',
    projectColorLabel: '颜色',
    projectIconLabel: '图标',
    project: '项目',
    projectHistory: '历史记录',
    projectPrompt: '提示词',
    projectPromptPlaceholder: '为该项目设置提示词',
    projectSettings: '项目设置',
    projectNameLabel: '项目名称',
    deleteProject: '删除项目',
    confirmDeleteProject: '确定要删除这个项目吗？项目内聊天将移回到聊天列表。此操作不可撤销。',
    folderIconDefault: '默认',
    folderIconHealth: '健康',
    folderIconStudy: '学习',
    folderIconMath: '数学',
    folderIconWork: '工作',
    folderIconCode: '代码',
    folderIconIdea: '灵感',
    
    // 聊天窗口
    sendMessage: '发送消息',
    typeMessage: '询问任何问题...',
    quickPrompt: '询问任何问题',
    regenerateResponse: '重新生成回复',
    copyToClipboard: '复制到剪贴板',
    coworkResultHelpful: '有帮助',
    coworkResultNotHelpful: '没有帮助',
    coworkOpinionTitle: '这条回答你觉得哪里不满意',
    coworkOpinionOther: '其他',
    coworkOpinionPlaceholder: '请描述这条回答的问题（可选）',
    coworkOpinionSubmit: '提交反馈',
    coworkOpinionCancelFailed: '取消点踩失败，请重试',
    coworkFeedbackFailed: '反馈提交失败，请重试',
    bobotCliInstall: 'BoBot CLI (终端)',
    bobotCliMacLinux: 'macOS / Linux',
    bobotCliWindows: 'Windows (PowerShell)',
    bobotCliNpm: '通用 (npm)',
    bobotCliCopied: '已复制',
    messageCopied: '消息已复制',
    clearConversation: '清空对话',
    confirmClearConversation: '确定要清空当前对话吗？此操作不可撤销。',
    today: '今天',
    yesterday: '昨天',
    daysAgo: '天前',
    justNow: '刚刚',
    minutesAgo: '分钟前',
    hoursAgo: '小时前',
    welcomeMessage: '我能帮你做什么呢？',
    thinking: '思考中...',
    reasoning: '思考过程',
    editMessage: '编辑消息',
    emptyMessage: '空消息',
    artifactOpen: '打开',
    artifactView: '查看',
    artifactViewing: '预览中',
    artifactPreview: '预览',
    artifactCode: '代码',
    imageLimitReached: '最多上传 10 张图片',
    imageReadError: '读取图片失败',
    imageInputNotSupported: '当前模型不支持图像输入',
    
    // 模型选择
    selectModel: '选择模型',
    
    // 错误提示
    errorOccurred: '发生错误',
    tryAgain: '请重试',
    networkError: '网络错误',
    apiKeyRequired: '需要设置API密钥',
    configureApiKey: '请在设置中配置您的API密钥',
    
    // 初始化
    initializationError: '初始化应用程序失败。请检查您的配置。',
    apiKeyNotConfigured: 'API密钥未配置。请在设置中设置您的API密钥。',
    initTitle: '初始化配置',
    initSubtitle: '请填写 BoCoder 管理后台地址',
    initUrlPlaceholder: 'http://192.168.1.100:9000',
    initVerifyBtn: '验证连接',
    initVerifying: '正在验证...',
    initSuccess: '连接成功',
    initFailed: '连接失败，请检查地址',
    initContinue: '继续',

    // BoCoder
    cowork: 'BoCoder',
    coworkSandbox: '沙箱设置',
    sandboxManagement: '沙箱管理',
    coworkSettings: 'BoCoder 设置',
    coworkHistory: '历史会话',
    coworkNoSessions: '暂无任务记录',
    coworkPinSession: '置顶任务',
    coworkUnpinSession: '取消置顶',
    coworkSessionActions: '更多操作',
    coworkPlaceholder: '快给我安排一个任务吧！如需指定技能请在技能选项中进行选择...',
    coworkInterruptAndSend: '当前任务结束后发送',
    coworkQueuedSummary: '等待发送 {count} 条',
    coworkQueuedCancel: '取消这条排队消息',
    coworkQueuedEdit: '编辑消息',
    coworkQueuedSteer: '引导当前任务',
    coworkQueuedCheck: '确认状态',
    coworkQueuedSteerUnavailable: '当前执行环境暂不支持引导，消息将在本轮结束后发送',
    coworkQueuedSteerAttachments: '带附件的消息需在下一轮上传后发送，仍可编辑正文',
    coworkQueuedSteeringPending: '等待当前任务接收；未消费的消息将在本轮结束后继续排队发送',
    coworkQueuedSteeringUnknown: '送达状态待确认，请勿重复发送。可点击确认状态继续查询',
    coworkQueuedUpdateFailed: '操作未完成，可能已被其他页面修改或运行状态已变化；草稿已保留，请重试',
    coworkInterruptSystemInstruction: '【重要：用户在你执行任务的过程中发送了新的消息】\n请根据上下文判断用户意图：\n- 可能是对当前任务的补充说明或修正（如调整细节、追加要求），此时继续原有目标并融入新要求\n- 也可能是要求停下当前任务、转向做别的事情，此时按用户新指示执行\n- 如果无法判断用户意图，请先询问确认再继续',
    coworkWorkingDirectory: '工作目录',
    coworkWorkingDirectoryPlaceholder: '输入工作区路径',
    coworkWorkingDirectoryHint: 'BoCoder 将在此目录下执行命令',
    coworkSystemPrompt: '系统提示词',
    coworkSystemPromptPlaceholder: '为 BoCoder 设置自定义指令...',
    coworkSystemPromptHint: '可选的系统提示词，用于自定义 BoCoder 的行为',
    coworkLoginRequired: '请先登录账户使用服务。没有账户可点击注册。不登录也可前往「模型」标签页自定义配置。',
    coworkModelSettingsRequired: '当前没有可用模型，请联系管理员配置。',
    coworkModelSettingsTitle: '模型设置',
    coworkModelSettingsHint: 'BoCoder 使用模型设置中的当前模型与提供商配置。',
    coworkModelSettingsAction: '前往模型设置',
    coworkApiConfigTitle: 'API 配置',
    coworkApiConfigHint: '支持 Anthropic 兼容与 OpenAI 兼容协议（OpenAI 兼容通过本地转换服务接入）。',
    coworkExecutionMode: '运行模式',
    coworkExecutionModeAuto: '自动模式',
    coworkExecutionModeLocal: '本地模式',
    coworkExecutionModeSandbox: '沙箱模式',
    coworkExecutionModeAutoHint: '自动选择最佳运行环境，优先使用沙箱隔离执行，沙箱不可用时自动回退到本地运行。',
    coworkExecutionModeLocalHint: '所有操作直接在本机运行，适合需要访问本地文件和开发工具的场景。',
    coworkExecutionModeSandboxHint: '强制在隔离的虚拟机中运行，提供最高安全性，需要已安装沙箱组件。',
    coworkExecutionModeAutoTag: '推荐',
    coworkSandboxOnlineHint: '如需使用在线 Web 版沙箱模式，可访问',
    coworkSandboxOnlineLinkText: 'boclaw.ai',
    coworkSandboxOnlineHintSuffix: '注册使用。',
    coworkMemoryTitle: '记忆管理',
    coworkMemoryEnabled: '记忆功能',
    coworkMemoryEnabledHint: '开启后，AI 会自动记住你的偏好和关键信息，让对话更懂你。',
    coworkMemorySimpleHint: '你可以在下方手动管理记忆条目，也可以在对话中让 AI 自动学习。',
    coworkMemoryAutoWrite: '自动写入记忆',
    coworkMemoryCaptureEachTurn: '启用隐式更新',
    coworkMemoryCaptureEachTurnHint: '开启后，每轮对话结束时自动调用 AI 提取值得长期记住的内容（会产生少量额外调用）。',
    coworkMemoryGuardLevel: '写入门槛',
    coworkMemoryGuardStrict: '严格',
    coworkMemoryGuardStandard: '标准',
    coworkMemoryGuardRelaxed: '宽松',
    coworkMemoryMaxResults: '注入条目上限',
    coworkMemoryMaxResultsHint: '可选范围 1-60，建议 12',
    coworkMemoryMinScore: '最小相关性阈值',
    coworkMemoryMaxInjectChars: '最大注入字符数',
    coworkMemoryRecallInterval: '自动回忆间隔（轮）',
    coworkMemoryRecallIntervalHint: '每 N 轮自动注入一次记忆，建议 3',
    coworkMemoryCrudTitle: '记忆条目管理',
    coworkMemoryManageHint: '你可以在这里查看、搜索、新增、编辑或删除记忆内容。',
    coworkMemoryTotalLabel: '记忆总数',
    coworkMemoryActiveLabel: '生效中',
    coworkMemoryInactiveLabel: '暂不使用',
    coworkMemoryStatusActive: '生效中',
    coworkMemoryStatusInactive: '暂不使用',
    coworkMemoryStatusDeleted: '已删除',
    coworkMemoryUpdatedAt: '最后更新',
    coworkMemoryEditingTag: '正在编辑当前记忆',
    coworkMemoryRebuildIndex: '重建索引',
    coworkMemoryRebuildSuccess: '记忆索引重建完成',
    coworkMemoryRebuildFailed: '记忆索引重建失败',
    coworkMemoryStatsSummary: '已管理条目数',
    coworkMemorySearchPlaceholder: '搜索记忆标题/内容',
    coworkMemoryCategoryAll: '全部分类',
    coworkMemoryEmpty: '暂无记忆条目',
    coworkMemoryCrudTextPlaceholder: '输入要保存的记忆内容',
    coworkMemoryCrudCreate: '新增记忆',
    coworkMemoryCrudUpdate: '更新记忆',
    coworkMemoryCrudSaveFailed: '保存记忆条目失败',
    coworkMemoryCrudDeleteFailed: '删除记忆条目失败',
    coworkMemoryAdvancedShow: '显示高级设置',
    coworkMemoryAdvancedHide: '隐藏高级设置',
    coworkMemoryEmbeddingEnabled: '启用本地 embedding 重排',
    coworkMemoryEmbeddingEnabledHint: '在词法检索基础上用本地向量相似度重排结果，提升召回质量',
    coworkMemoryEmbeddingModel: 'Embedding 模型',
    coworkMemoryEmbeddingModelHint: '推荐 BAAI/bge-m3；可改为你已下载的其他 sentence-transformers 模型',
    coworkMemoryEmbeddingLocalModelPath: '本地模型目录（可选）',
    coworkMemoryEmbeddingLocalModelPathHint: '填写后优先加载本地目录；留空时按模型名加载',
    coworkMemoryEmbeddingAutoDownload: '允许自动下载模型',
    coworkMemoryEmbeddingAutoDownloadHint: '关闭后必须提供本地模型目录',
    coworkMemoryEmbeddingDownload: '下载 / 校验模型',
    coworkMemoryEmbeddingDownloading: '下载中...',
    coworkMemoryEmbeddingDownloadHint: '手动触发模型下载（或校验本地模型目录），下载过程可能较慢，请等待进度完成',
    coworkMemoryEmbeddingDownloadSuccess: 'Embedding 模型已就绪',
    coworkMemoryEmbeddingDownloadFailed: 'Embedding 模型下载失败',
    coworkMemoryEmbeddingProgressPreparing: '准备下载任务',
    coworkMemoryEmbeddingProgressInit: '初始化环境',
    coworkMemoryEmbeddingProgressDownload: '下载模型文件',
    coworkMemoryEmbeddingProgressLoad: '加载模型',
    coworkMemoryEmbeddingProgressEncode: '模型预热',
    coworkMemoryEmbeddingProgressDone: '完成',
    coworkMemoryEmbeddingProgressError: '失败',
    coworkMemoryEmbeddingWeight: '语义重排权重',
    coworkMemoryEmbeddingWeightHint: '范围 0-1，值越大越依赖 embedding 相似度，建议 0.62',
    coworkSandboxProfileRequired: '请先选择沙箱环境。',
    coworkSandboxImageRequired: '请先选择沙箱镜像。',
    sandboxEnvVars: '自定义环境变量',
    sandboxEnvVarsHint: '注入到沙箱虚拟机中的环境变量，可用于配置 API 密钥、代理地址等。AI 执行的脚本和工具可以读取这些变量。',
    sandboxEnvVarsAdd: '添加变量',
    sandboxEnvVarsKeyPlaceholder: '变量名',
    sandboxEnvVarsValuePlaceholder: '变量值',
    coworkSandboxBadge: '沙箱',
    modelContextWindow: '上下文窗口',
    coworkContextUsage: '上下文用量',
    coworkContextCompacting: '压缩中',
    coworkContextPending: '待更新',
    coworkContextUnknown: '未知',
    coworkUncachedInput: '非缓存输入',
    coworkCacheWrite: '缓存写入',
    coworkCacheRead: '缓存读取',
    coworkSourceDesktop: '桌面端',
    coworkSourceApp: 'App 远程',
    relaySendCloud: '发起会话',
    relaySendCloudDesc: '在云端沙箱中执行',
    relayNoDesktopOnline: '暂无在线桌面客户端',
    relayDesktopOffline: '目标桌面客户端已离线',
    coworkViewSandboxDesktop: '查看沙箱桌面',
    coworkSandboxDesktopTitle: '沙箱桌面视图',
    coworkSandboxDesktopEnlarge: '放大为浮窗',
    coworkSandboxDesktopOpenInTab: '新标签页打开',
    coworkSandboxDesktopConnecting: '正在连接沙箱桌面...',
    sandboxPreview: '沙箱预览',
    coworkTerminalTitle: '终端',
    coworkTerminalConnecting: '正在连接终端...',
    coworkTerminalDisconnected: '终端已断开',
    coworkTerminalNotRunning: '会话未运行，无法连接终端',
    coworkTerminalOpenFailed: '终端连接失败，请点击重新连接；若仍失败，请检查沙箱终端服务。',
    coworkTerminalClear: '清空',
    coworkTerminalReconnect: '重新连接',
    coworkTerminalResizeHint: '拖动调整终端宽度',
    coworkDeliverablesTitle: '交付物',
    coworkDeliverablesEmpty: '暂无交付物...',
    coworkDeliverablesSummary: '摘要',
    coworkDeliverablesFiles: '产出文件',
    coworkDeliverablesUploadedFiles: '上传文件',
    coworkDeliverablesGeneratedFiles: '生成文件',
    coworkDeliverablesPreview: '预览',
    coworkDeliverablesDownload: '下载',
    coworkDeliverablesNoPreview: '暂不支持预览',
    coworkDeliverableDownloadFailed: '下载失败：沙箱可能已停止，或该文件已不可读。继续会话后重试。',
    coworkDeliverableSandboxPaused: '沙箱空闲已暂停回收，文件仍在但暂不可读。发送任意消息继续本会话即可恢复文件访问。',
    coworkDeliverablesFilterAll: '全部',
    coworkDeliverablesFilterDoc: '文档',
    coworkDeliverablesFilterCode: '代码',
    coworkDeliverablesFilterData: '数据',
    coworkDeliverablesFilterImage: '图片',
    coworkDeliverablesFilterOther: '其他',
    coworkDeliverablesFilterEmpty: '该分类下暂无文件',
    // Sandbox profiles
    sandboxProfiles: '沙箱配置',
    sandboxProfilesAdd: '添加沙箱',
    sandboxProfileName: '沙箱名称',
    sandboxProfileNamePlaceholder: '例如：团队 CubeSandbox',
    sandboxProfileDelete: '删除',
    sandboxProfileEdit: '编辑',
    sandboxProfileDeleteConfirm: '确认删除该沙箱配置？',
    sandboxSelectorTitle: '选择沙箱',
    sandboxSelectLocal: '本地执行',
    sandboxManage: '管理沙箱...',
    sandboxProfileSelectTitle: '选择执行环境',
    sandboxEnvUnavailable: '环境不可用（模板已删除或停用）',
    sandboxImageSelectTitle: '选择沙箱',
    sandboxImageNameLabel: '镜像名',
    sandboxImageArchitectureLabel: '架构',
    sandboxImageRuntimeLabel: '运行时',
    sandboxImageResourcesLabel: '资源',
    envSelectorCloudSandbox: '云端沙箱',
    envSelectorDesktopClient: '桌面客户端',
    executionEnvLabel: '执行环境',
    scheduledTasksDesktopEnvTitle: '该桌面客户端不支持在网页端查看定时任务',
    scheduledTasksDesktopEnvHint: '{device} 的客户端版本没有定时任务通道，请升级桌面客户端后重试。也可以切回「云端沙箱」查看云端定时任务。',
    scheduledTasksDesktopEnvBanner: '这些定时任务保存在 {device} 上，由该设备自己的调度器执行。可以在这里启停、删除、立即执行和查看历史；新建与编辑请在桌面客户端里操作。',
    scheduledTasksDesktopCreateUnsupported: '桌面客户端的定时任务需要工作目录等本机设置，请在桌面客户端里新建或编辑。',
    executionEnvUnset: '未选择执行环境',
    scheduledTasksFormValidationEnvRequired: '请选择执行环境；原来绑定的沙箱模板可能已被停用或删除',
    refreshDesktopSessions: '刷新桌面会话',
    desktopSessionsRefreshed: '桌面会话已刷新',
    desktopSessionsRefreshFailed: '刷新失败，请检查桌面端是否在线',
    sandboxImageCores: '核',
    sandboxProfileEmpty: '暂无可用沙箱环境，请联系管理员配置',
    sandboxImageEmpty: '暂无可用沙箱镜像，请联系管理员配置',
    sandboxProfileSave: '保存',
    sandboxProfileCancel: '取消',
    coworkLocalBadge: '本地',
    coworkApiProviderModel: '从模型设置选择',
    coworkApiProviderModelCustom: '自定义',
    coworkApiProviderModelHint: '仅显示已启用且已配置 API Key/地址的模型',
    coworkApiBaseUrl: 'API 基础地址',
    coworkApiKey: 'API Key',
    coworkApiModel: '模型名称',
    coworkApiKeyRequired: '需要填写 API Key',
    coworkApiBaseUrlRequired: '需要填写 API 地址',
    coworkApiModelRequired: '需要填写模型名称',
    coworkApiBaseUrlInvalid: 'API 地址格式无效',
    coworkApiConfigSaveFailed: '保存 API 配置失败',
    coworkApiConfigLoadFailed: '加载 API 配置失败',
    coworkStatusIdle: '已停止',
    coworkStatusRunning: '运行中',
    coworkThinking: '思考中',
    coworkActivityAwaitingModel: '正在等待模型开始回复',
    coworkStatusCompleted: '已完成',
    turnStatus_completed: '已完成',
    turnStatus_incomplete: '部分完成',
    turnStatus_failed: '失败',
    turnStatus_stopped: '已停止',
    turnStatus_interrupted: '已中断',
    turnDuration: '用时',
    showThinkingProcess: '显示思考过程',
    secretaryPreference_warmHint: '友善耐心，不堆客套',
    secretaryPreference_conciseHint: '先给结论，减少铺垫',
    secretaryPreference_naturalHint: '像熟悉的长期伙伴',
    secretaryPreference_briefHint: '只说最关键内容',
    secretaryPreference_balancedHint: '结论、依据和下一步',
    secretaryPreference_detailedHint: '补充背景、风险和步骤',
    secretaryPreference_noneHint: '不主动使用幽默',
    secretaryPreference_lightHint: '轻微幽默，不影响专业',
    secretaryPreference_playfulHint: '非严肃场景更轻松',
    secretaryPreference_responsiveHint: '聚焦当前问题',
    secretaryPreference_moderateHint: '提醒遗漏、风险和下一步',
    secretaryPreference_proactiveHint: '主动给关联建议和待办',
    secretaryPreference_avatar: '头像配色',
    secretaryPreference_blue: '蓝色',
    secretaryPreference_violet: '紫色',
    secretaryPreference_teal: '青色',
    secretaryPreference_amber: '琥珀色',
    secretaryPreference_rose: '玫瑰色',
    secretaryPreference_loading: '正在读取秘书设置…',
    conversationHistory: '提问导航',
    secretaryPreference_title: '秘书身份与表达偏好',
    secretaryPreference_hint: '与下方自由 Soul 独立保存。保存后从下一轮秘书对话生效，正在执行的轮次不打断。恢复 Soul 默认不会清除这些设置。',
    secretaryPreference_error: '读取或保存失败，请重新打开设置重试。',
    secretaryPreference_saved: '已保存',
    secretaryPreference_saveIdentity: '保存身份与称呼',
    secretaryPreference_saveStyle: '保存表达偏好',
    secretaryPreference_assistantDisplayName: '秘书名称',
    secretaryPreference_preferredUserName: '如何称呼你',
    secretaryPreference_workDomain: '工作领域',
    secretaryPreference_assistantIntroduction: '秘书介绍',
    secretaryPreference_speechStyle: '说话方式',
    secretaryPreference_responseDetail: '回答详略',
    secretaryPreference_humorLevel: '幽默程度',
    secretaryPreference_initiativeLevel: '主动程度',
    secretaryPreference_warm: '温和专业',
    secretaryPreference_concise: '干练直接',
    secretaryPreference_natural: '轻松自然',
    secretaryPreference_brief: '简短',
    secretaryPreference_balanced: '适中',
    secretaryPreference_detailed: '详细',
    secretaryPreference_none: '不使用',
    secretaryPreference_light: '轻微',
    secretaryPreference_playful: '活泼',
    secretaryPreference_responsive: '响应为主',
    secretaryPreference_moderate: '适度提醒',
    secretaryPreference_proactive: '主动建议',
    conversationLatest: '回到最新',
    conversationSearch: '会话内搜索',
    conversationSearchHint: '搜索内容；留空查看提问目录',
    conversationPrevious: '上一处',
    conversationNext: '下一处',
    creditSessionUsage: '会话积分',
    creditTurnUsage: '本轮积分',
    creditLatestTurnUsage: '最近一轮积分',
    coworkCloudPermissionTitle: '沙箱内自动执行',
    coworkCloudPermissionHint: '工具在云端沙箱内自动执行；需要你回答的问题仍会等待确认。当前云端模板不支持切换客户端的权限档位。切换到桌面客户端后，使用该客户端的权限设置。',
    creditTurnSimulated: '本轮模拟费用',
    creditSessionSimulated: '会话累计模拟费用',
    creditTurnConsumed: '本轮共消耗',
    creditSessionTotal: '会话累计',
    creditPendingSettlement: '待确认',
    creditTurnBreakdownUnavailable: '暂无分轮明细',
    creditTurnBreakdownUnavailableHint: '平台未返回分轮明细，请参考会话累计消耗。',
    creditShadowShort: '影子计费',
    creditStaleShort: '数据待刷新',
    creditRecordedUsageHint: '已入账费用；后续结算可能更新。无法归属的历史费用仅计入会话总额。',
    creditFree: '免费',
    creditPerCall: '积分/次',
    creditInput: '输入',
    creditOutput: '输出',
    creditPer1k: '积分/1K token',
    creditMeterPrices: '工具与沙箱价目',
    creditMetersEmpty: '暂无公开价目，不代表免费。',
    creditMeterConfirmation: '使用前确认',
    connectorEditFailed: '读取或修改连接器失败，请刷新重试。',
    connectorToolsTitle: '检查工具',
    connectorToolsHint: '连接当前授权的 MCP 并读取工具列表，不执行工具或发起业务调用。',
    connectorToolsLoading: '正在连接并发现工具…',
    connectorToolsUnavailable: '未发现可用工具。请检查服务地址、连接授权后重试。',
    connectorToolsRetry: '重新检查',
    connectorEdit: '编辑',
    connectorDelete: '删除',
    connectorAdd: '添加',
    connectorDeleteConfirm: '确认删除此自定义连接器及其授权？',
    connectorEditTokenHint: '令牌不会回显。地址不变时留空保留旧令牌；更换地址请重新填写，留空将清除旧令牌。',
    subscriptionHistory: '订单记录',
    subscriptionAddons: '加购积分',
    subscriptionAddonEmpty: '暂无可加购套餐或可用支付渠道。',
    subscriptionHistoryEmpty: '暂无订单',
    subscriptionPrevious: '上一页',
    subscriptionNext: '下一页',
    subscriptionWechat: '微信支付',
    subscriptionAlipay: '支付宝',
    subscriptionPayLink: '打开付款页面',
    subscriptionRefresh: '刷新状态',
    subscriptionDays: '天',
    subscriptionCredits: '积分',
    subscriptionCnyOnly: '当前付款入口仅支持人民币套餐。',
    subscriptionResumeMissing: '刷新后无法恢复此付款码，请先在支付应用确认结果并刷新订单状态，再进行购买。',
    subscriptionTitle: '套餐购买',
    subscriptionDuration: '套餐有效期',
    subscriptionDuration_year: '年', subscriptionDuration_month: '月', subscriptionDuration_day: '天', subscriptionDuration_hour: '小时',
    subscriptionUnavailable: '套餐或订单暂不可用，请稍后返回重试。',
    subscriptionLoading: '正在读取套餐…',
    subscriptionEmpty: '暂无可购买套餐',
    subscriptionBase: '基础积分',
    subscriptionBonus: '赠送积分',
    subscriptionBuy: '购买并生成付款码',
    subscriptionViewOrder: '查看订单',
    subscriptionOrder: '订单号',
    subscriptionAmount: '付款金额',
    subscriptionSuccess: '平台已确认支付，正在刷新积分',
    subscriptionPending: '等待扫码付款，状态由平台确认',
    subscriptionExpired: '订单已过期',
    subscriptionUnknown: '请到平台核对订单状态',
    subscriptionExpires: '付款码到期时间',
    subscriptionClose: '收起（不取消订单）',

    coworkStatusError: '错误',
    coworkPermissionRequired: '需要权限确认',
    coworkPermissionDescription: 'BoCoder 请求执行以下操作',
    coworkToolName: '工具名称',
    coworkToolInput: '工具参数',
    coworkToolResult: '执行结果',
    coworkToolRunning: '执行中',
    coworkDocumentExtractStop: '停止',
    coworkExecutionProcess: '执行过程',
    coworkToolSequenceCount: '{count} 次操作',
    coworkToolActionSearch: '搜索',
    coworkToolActionView: '查看',
    coworkToolActionRun: '执行',
    coworkToolActionRead: '读取',
    coworkToolActionWrite: '写入',
    coworkToolActionEdit: '编辑',
    coworkToolActionFind: '查找',
    coworkToolActionDelegate: '处理',
    coworkToolActionPlan: '更新执行计划',
    coworkToolActionSkill: '加载技能',
    coworkTodosTitle: 'Todos',
    coworkTodoItems: '项',
    coworkTodoCompleted: '已完成',
    coworkTodoInProgress: '进行中',
    coworkTodoPending: '待处理',
    coworkTodoUntitled: '未命名待办',
    coworkTodoUnknownStatus: '未知状态',
    coworkTodoPanelTitle: '执行计划',
    coworkTodoPanelProgress: '进度',
    coworkTodoPanelAllDone: '所有任务已完成',
    coworkDangerousOperation: '警告：此操作可能会修改文件或执行系统命令，请仔细检查。',
    coworkApprove: '允许',
    coworkDeny: '拒绝',
    coworkPermissionModeLabel: '权限模式',
    coworkPermissionModeDefault: '每次询问',
    coworkPermissionModeAuto: '自动批准',
    coworkPermissionModeBypass: '跳过审批',
    coworkPermissionModeDefaultHint: '所有有副作用的操作都需要确认',
    coworkPermissionModeAutoHint: '默认允许，危险操作时询问',
    coworkPermissionModeBypassHint: '完全自动执行，不进行审批',
    coworkConfirmSelection: '提交当前选择',
    coworkDenyRequest: '直接拒绝请求',
    coworkPauseTimer: '暂停',
    coworkResumeTimer: '继续',
    coworkQuestionWizardTitle: '需要您的确认',
    coworkQuestionWizardSkip: '跳过',
    coworkQuestionWizardPrevious: '上一个',
    coworkQuestionWizardNext: '下一个',
    coworkQuestionWizardSubmit: '提交',
    coworkQuestionWizardOther: '其他',
    coworkQuestionWizardOtherPlaceholder: '请输入自定义答案...',
    coworkQuestionWizardSelectAtLeastOne: '请至少选择一个选项',
    coworkQuestionWizardAnswerRequired: '请选择或输入答案',
    coworkWelcome: '你好，我是{orgCode}',
    coworkDescription: '{orgName}智能体{orgCode}可以帮你处理文档、操作设备、深度研究，做你 7×24 小时的 AI 助力',
    coworkSkillsHint: '更多技能可在技能中心在线安装',
    coworkNewSession: '新会话',
    coworkContinuePlaceholder: '继续对话...',
    updateAvailablePill: '有新版本',
    updateAvailableTitle: '检测到新版本',
    updateAvailableMessage: '检测到新版本，请前往官网下载并覆盖安装。',
    updateAvailableConfirm: '好',
    updateAvailableCancel: '取消',
    updateOpenFailed: '打开下载页面失败',
    checkForUpdates: '检测更新',
    checkingForUpdates: '正在检测...',
    upToDate: '已是最新版本',
    downloadUpdate: '下载更新',
    currentVersionPrefix: '当前版本',
    coworkStartingSession: '正在启动会话...',
    coworkPreparingEnvironment: '准备环境中，请稍候',
    coworkAddFile: '添加文件',
    coworkDropFileHint: '拖拽文件到此处，或直接粘贴文件',
    coworkAddImage: '添加图片',
    coworkInputFileLabel: '输入文件',
    coworkAttachmentRemove: '移除',
    coworkFile: '文件',
    coworkShareSession: '分享',
    coworkExportImageInProgress: '正在导出图片...',
    coworkExportImageSuccess: '图片导出成功',
    coworkExportImageFailed: '导出图片失败',
    coworkExportImageTooLarge: '对话过长，无法完整导出为一张图片；请减少内容后重试。',
    coworkExportImageResourceFailed: '图片或字体未能加载，未生成不完整的导出；请稍后重试。',
    deleteSession: '删除任务',
    batchManage: '管理',
    batchDone: '完成',
    batchSelectAll: '全选',
    batchDeselectAll: '取消全选',
    batchDelete: '删除',
    batchDeleteConfirmTitle: '确认批量删除',
    batchDeleteConfirmMessage: '此操作无法撤销，选中的 {count} 个任务及其所有消息记录将被永久删除。',
    deleteTaskConfirmTitle: '确认删除任务',
    deleteTaskConfirmMessage: '此操作无法撤销，任务的所有消息记录将被永久删除。',
    back: '返回',
    browse: '浏览',
    addFolder: '添加文件夹',
    recentFolders: '最近使用',
    noFolderSelected: '未选择文件夹',
    coworkSelectFolderFirst: '请选择任务目录后再提交',
    noRecentFolders: '暂无最近文件夹',
    coworkOpenFolder: '打开文件夹',

    // Skills
    appSettings: '应用设置',
    skills: '技能中心',
    searchSkills: '搜索技能',
    manageSkills: '管理技能',
    officialSkills: '官方技能',
    addSkill: '添加',
    uploadSkillZip: '上传 .zip',
    uploadSkillFolder: '上传文件夹',
    skillImportPackaging: '正在打包 {source}',
    skillImportUploading: '正在上传 {source}',
    skillImportValidating: '正在校验 {source}',
    skillImportExtracting: '正在解压 {source}',
    skillImportDiscovering: '正在查找 {source} 中的技能',
    skillImportInstalling: '正在导入 {source}：已处理 {processed}/{total}，成功 {installed}',
    skillImportProgressLabel: '技能导入进度',
    skillDuplicatesConfirm: '以下技能已存在',
    skillSkipDuplicates: '跳过重复项',
    skillOverwriteDuplicates: '覆盖全部',
    skillFolderUploadResult: '文件夹上传完成：成功 {installed}，跳过 {skipped}，失败 {failed}',
    skillBatchUploadResult: '批量上传完成：成功 {installed}，跳过 {skipped}，失败 {failed}',
    skillImportMissingManifest: '未找到 SKILL.md',
    skillImportPackageTooLarge: '技能包超过大小或文件数量限制',
    skillImportTooManyFiles: '技能包文件数量超过限制',
    skillImportUnsafeSource: '技能包包含不安全的路径或链接',
    skillImportFailed: '技能导入失败',
    importFromGithub: '从 GitHub 导入',
    githubImportTitle: '从 GitHub 导入',
    githubImportDescription: '支持仓库链接与子目录链接；若仓库内有多个技能，将自动全部导入。',
    githubImportUrlLabel: 'URL',
    githubSkillPlaceholder: '例如：owner/repo 或 GitHub tree/blob 链接',
    githubImportExamples: '示例：owner/repo；https://github.com/owner/repo/tree/main/SKILLs/my-skill',
    importSkill: '导入',
    importingSkill: '导入中...',
    official: '官方',
    noSkillsAvailable: '暂无可用技能',
    skillsDescription: '为您的智能体提供预封装且可重复的最佳实践与工具',
    allCategories: '全部',
    uncategorized: '其他',
    categoryDocuments: '文档处理',
    categorySearch: '搜索资讯',
    categoryDesign: '设计创作',
    categoryTools: '效率工具',
    categoryWriting: '写作助手',
    categoryDev: '开发集成',
    categoryWebAutomation: '网页自动化',
    categoryCommunication: '通讯协作',
    categorySystem: '系统增强',
    skillsOnlineNoResults: '未找到匹配的社区技能',
    skillDetailsOpen: '查看技能详情',
    skillsFeaturedDetailTryAsking: '试试这样问我',
    skillsFeaturedDetailOutputArtifacts: '预期产物',
    skillsFeaturedDetailPreviewHint: '安装并启用后，可将示例提问带入对话草稿。',
    skillsFeaturedDetailUseSkill: '使用该技能',
    skillsFeaturedDetailFallbackQuestion1: '请介绍一下“{name}”最适合处理哪些任务，并给我一个开始步骤。',
    skillsFeaturedDetailFallbackQuestion2: '请使用“{name}”分析我接下来提供的材料，并指出还需要补充的信息。',
    skillsFeaturedDetailFallbackQuestion3: '请用“{name}”给我一个可直接执行的处理方案。',
    skillsFeaturedDetailDraftHint: '选择后进入新对话草稿，已有草稿和附件会保留；请确认内容后发送。',
    skillLaunchUnavailable: '技能已停用、删除或登录状态已变化，请刷新后重试。',
    skillDetailsDescription: '技能介绍',
    skillDetailsCategory: '分类',
    skillDetailsUpdated: '更新时间',
    skillDetailsLocation: '存储位置',
    skillDetailsBuiltIn: '内置',
    skillDetailsLocal: '本地技能',
    scenarioSkillPrepareTitle: '本场景需要以下技能',
    scenarioSkillPrepareDesc: '这些技能还没准备好。装上/启用后场景才能完整发挥作用。',
    scenarioSkillPrepareInstall: '安装并进入',
    scenarioSkillPrepareEnable: '启用并进入',
    scenarioSkillPrepareCancel: '取消',
    scenarioSkillPrepareInstalling: '安装中…',
    scenarioSkillPrepareRetry: '重试',
    scenarioSkillPrepareSkip: '跳过并进入',
    scenarioSkillPrepareFailedHint: '部分技能没装上。可以重试，也可以直接进入——未装上的技能这次不会生效。',
    scenarioSkillPrepareContinue: '知道了，继续进入',
    scenarioSkillStateReady: '已就绪',
    scenarioSkillStateMissing: '未安装',
    scenarioSkillStateDisabled: '已禁用',
    scenarioSkillStateUnavailable: '平台已下架',
    scenarioSkillStateFailed: '安装失败',
    coworkPromptModeLabel: '会话模式',
    coworkMoreTools: '更多工具',
    coworkInputShortcutHint: 'Enter 发送 · {shortcut} 换行',
    coworkDraftSendFailed: '消息发送失败，草稿已保留。',
    coworkDraftAttachmentsLost: '刷新前未保存的附件无法恢复，请重新添加。',
    coworkCopyLink: '复制会话链接',
    coworkLinkCopied: '会话链接已复制',
    coworkLinkCopyFailed: '复制失败，请检查剪贴板权限。',
    coworkAiDisclaimer: '内容由 AI 生成，请仔细甄别',
    coworkPromptModeCollab: '协作',
    coworkPromptModeQuick: '快速',
    coworkPromptModeChat: '对话',
    coworkPromptModeWork: '工作',
    coworkPromptModeCollabHint: '完整 Agent：加载工具、技能与沙箱执行',
    coworkPromptModeSwitchBusy: '运行中的会话不能切换模式，请先停止',
    coworkPromptModeQuickHint: '轻量对话：仅携带记忆，不加载工具与技能，不启动沙箱，响应更快',
    coworkPromptModeSwitchToQuick: '切换到快速对话（不启动沙箱）',
    coworkPromptModeSwitchToCollab: '切换到协作（启动沙箱，可用工具与技能）',
    coworkPromptModeSwitchFailed: '切换会话模式失败',
    coworkPromptModeLocked: '任务创建后不可更改对话模式',
    coworkQuickPlaceholder: '有什么想聊的？直接告诉我...',
    coworkToolScenario: '场景',
    secretaryEntry: 'BoMate',
    scenariosNoResults: '没有匹配的场景',
    scenariosAuthFailed: '平台登录态已失效',
    scenariosAuthFailedHint: '请退出后重新登录，即可加载你的场景应用',
    scenariosFeaturedTitle: '精选场景',
    scenariosBrowseTitle: '全部场景',
    scenariosHotBadge: '热门',
    scenariosRecommendedBadge: '推荐',
    secretaryMemoryTitle: 'BoMate 长期记忆',
    secretaryMemoryActive: '活跃',
    secretaryMemoryArchived: '已归档',
    secretaryMemoryIndexUsage: '索引',
    secretaryMemoryLastDream: '上次整理',
    secretaryMemorySearchPlaceholder: '搜索长期记忆...',
    secretaryMemoryEmpty: '还没有长期记忆 —— 和 BoMate 聊过之后会自动积累',
    secretaryMemoryForget: '忘记',
    secretarySoulEdit: '人格设定',
    secretarySoulHint: '定义 BoMate 的身份与交互方式（不保存业务事实）。保存后新会话生效。',
    secretarySoulReset: '恢复默认',
    secretarySoulSavedToast: '人格设定已保存',
    setCategory: '设置分类',
    clearCategory: '清除分类',
    skillsRoot: '技能目录',
    skillSourcePlaceholder: 'Git URL 或本地路径',
    downloadSkill: '下载技能',
    downloadingSkill: '正在下载...',
    deleteSkill: '删除技能',
    skillEditTags: '编辑标签',
    skillNewTagPlaceholder: '新增标签',
    skillAddTag: '添加',
    skillDeleteConfirm: '确定删除技能“{name}”吗？',
    skillDeleteFailed: '删除技能失败',
    skillBuiltInCannotDelete: '系统精选技能不允许删除',
    skillDownloadFailed: '下载技能失败',
    skillUpdateFailed: '更新技能失败',
    activeSkill: '当前技能',
    clearSkill: '清除技能',
    clearAll: '全部清除',
    clearAllSkills: '清除所有已选技能',
    skillsLocalTab: '本地技能',
    skillsFeaturedTab: '精选技能',
    skillsOnlineTab: '社区技能',
    skillsPersonalTab: '个人技能',
    skillsBuiltinTab: '系统精选',
    skillsCommunityTab: '社区技能',
    skillsFeaturedSubtitle: '官方精选优质技能，一键安装即刻体验',
    skillsFeaturedSearch: '搜索精选技能...',
    skillsFeaturedEmpty: '暂无精选技能',
    skillsFeaturedError: '加载失败，请稍后重试',
    skillsFeaturedSource: '以下列表来自 ',
    skillsFeaturedSourceSuffix: ' 精选推荐',
    skillsOnlineSubtitle: '探索社区精选技能，一键安装扩展 BoCoder 能力',
    skillsOnlineSearch: '搜索技能名称或描述...',
    skillsOnlineInstall: '安装',
    skillsOnlineInstalling: '安装中...',
    skillsOnlineInstalled: '已安装',
    skillsOnlineLoadMore: '加载更多',
    skillsOnlineEmpty: '暂无在线技能',
    skillsOnlineError: '加载失败，请稍后重试',
    skillsOnlineSource: '以下列表来自 ',
    skillsOnlineSourceSuffix: ' 技能商店',
    skillsOnlineSortDownloads: '下载量',
    skillsOnlineSortStars: '收藏数',
    skillsOnlineSortUpdated: '最近更新',

    // 邮箱技能配置
    emailTab: '邮箱',
    emailConfig: '邮箱配置',
    emailConfigHint: '该功能需安装 Email 技能进行使用',
    emailProvider: '邮箱服务商',
    emailSelectProvider: '请选择邮箱服务商',
    emailCustomProvider: '自定义',
    emailAddress: '邮箱地址',
    emailPassword: '密码 / 授权码',
    emailPasswordPlaceholder: '密码或应用专用密码',
    emailAdvancedSettings: '高级设置',
    emailMailbox: '默认收件箱',
    emailConfigSaved: '邮箱配置已保存',
    emailConfigError: '保存配置失败',
    emailHintGmail: '如果开启了两步验证，请使用应用专用密码（App Password）',
    emailHint163: '请使用授权码，而非账户密码。需先在网页端设置中开启 IMAP/SMTP 服务',
    emailHintQQ: '请使用授权码，而非账户密码。需先在网页端设置中开启 IMAP/SMTP 服务',

    // 文件操作
    openFile: '打开文件',
    openFolder: '打开文件夹',
    showInFolder: '在文件夹中显示',
    outputFiles: '输出文件',
    openFileFailed: '打开文件失败',
    fileCreated: '文件已创建',

    // IM Bot
    imBot: 'IM 工具',
    dingtalk: '钉钉',
    feishu: '飞书',
    telegram: 'Telegram',
    discord: 'Discord',
    wechatwork: '企业微信',
    connected: '已连接',
    disconnected: '未连接',
    starting: '启动中',
    imConfigGuide: '配置教程',
    imToggleNeedTest: '请先填写配置并测试连接通过后再启用',
    start: '启动',
    stop: '停止',
    messageType: '消息类型',
    domain: '域名',
    feishuChina: '飞书（中国）',
    renderMode: '渲染模式',
    textMode: '文本',
    cardMode: '卡片',
    chatSettings: '对话设置',
    enableSkills: '启用技能',
    systemPrompt: '系统提示词',
    systemPromptPlaceholder: '为 IM 机器人设置自定义指令...',
    saveConfig: '保存配置',
    imConnectivitySectionTitle: '连接诊断',
    imConnectivityTest: '测试连接',
    imConnectivityRetest: '重新测试',
    imConnectivityTesting: '测试中...',
    imConnectivityNoResult: '尚未执行诊断。建议启用后立即测试。',
    imConnectivityLastChecked: '最近测试',
    imConnectivitySuggestion: '建议',
    imConnectivityVerdict_pass: '可对话',
    imConnectivityVerdict_warn: '需关注',
    imConnectivityVerdict_fail: '不可用',
    imConnectivityCheckTitle_missing_credentials: '配置项缺失',
    imConnectivityCheckTitle_auth_check: '凭证鉴权',
    imConnectivityCheckTitle_gateway_running: 'IM 渠道启用状态',
    imConnectivityCheckTitle_inbound_activity: '入站消息活动',
    imConnectivityCheckTitle_outbound_activity: '出站消息活动',
    imConnectivityCheckTitle_platform_last_error: '平台最近错误',
    imConnectivityCheckTitle_feishu_group_requires_mention: '飞书群聊触发规则',
    imConnectivityCheckTitle_feishu_event_subscription_required: '飞书事件订阅要求',
    imConnectivityCheckTitle_discord_group_requires_mention: 'Discord 群聊触发规则',
    imConnectivityCheckTitle_telegram_privacy_mode_hint: 'Telegram Privacy Mode',
    imConnectivityCheckTitle_dingtalk_bot_membership_hint: '钉钉会话权限',
    imConnectivityCheckTitle_wechatwork_http_callback_hint: '企业微信回调配置',
    imConnectivityCheckSuggestion_missing_credentials: '补全必填配置项后重试。',
    imConnectivityCheckSuggestion_auth_check: '核对平台凭证、应用权限和发布状态。',
    imConnectivityCheckSuggestion_gateway_running: '若显示未启用，请点击对应 IM 渠道胶囊按钮启用；启用后确认网络可访问平台服务。',
    imConnectivityCheckSuggestion_inbound_activity: '向机器人发一条测试消息；群聊场景请 @机器人。',
    imConnectivityCheckSuggestion_outbound_activity: '检查机器人发消息权限、可见范围和会话回包权限。',
    imConnectivityCheckSuggestion_platform_last_error: '根据错误提示修复后再重测。',
    imConnectivityCheckSuggestion_feishu_group_requires_mention: '在群聊中使用 @机器人 + 内容。',
    imConnectivityCheckSuggestion_feishu_event_subscription_required: '在飞书后台开启 im.message.receive_v1 并发布版本。',
    imConnectivityCheckSuggestion_discord_group_requires_mention: '在频道中使用 @机器人 + 内容。',
    imConnectivityCheckSuggestion_telegram_privacy_mode_hint: '在 @BotFather 调整 Privacy Mode 设置。',
    imConnectivityCheckSuggestion_dingtalk_bot_membership_hint: '确认机器人已加入目标会话并允许收发消息。',
    imConnectivityCheckSuggestion_wechatwork_http_callback_hint: '在企业微信后台填写公网可访问的回调地址，并将流量转发到本地端口。',

    // 通用设置
    autoLaunch: '开机自启动',
    autoLaunchDescription: '系统启动时自动运行应用',

    // 定时任务
    scheduledTasks: '定时任务',
    scheduledTasksTitle: '定时任务',
    scheduledTasksNewTask: '新建任务',
    scheduledTasksEmptyState: '暂无定时任务',
    scheduledTasksEmptyHint: '创建定时任务，让 AI 按计划自动执行',
    scheduledTasksListColTitle: '标题',
    scheduledTasksListColSchedule: '计划于',
    scheduledTasksListColStatus: '状态',
    scheduledTasksListColMore: '更多',
    scheduledTasksTabTasks: '任务',
    scheduledTasksTabHistory: '历史',
    scheduledTasksHistoryEmpty: '暂无运行记录',
    scheduledTasksHistoryColTitle: '标题',
    scheduledTasksHistoryColTime: '执行时间',
    scheduledTasksHistoryColStatus: '状态',
    scheduledTasksClearHistory: '清理历史',
    scheduledTasksClearHistoryConfirmTitle: '清理运行历史',
    scheduledTasksClearHistoryConfirmMessage: '将清理当前账号的成功和失败记录，运行中的记录和关联会话会保留。此操作不可撤销。',
    scheduledTasksClearingHistory: '正在清理...',
    scheduledTasksClearHistoryFailed: '清理历史失败，请稍后重试',
    scheduledTasksFormName: '标题',
    scheduledTasksFormNamePlaceholder: '输入任务标题',
    scheduledTasksFormDescription: '描述',
    scheduledTasksFormDescriptionPlaceholder: '可选的任务描述',
    scheduledTasksFormScheduleType: '计划',
    scheduledTasksFormScheduleModeOnce: '不重复',
    scheduledTasksFormScheduleModeDaily: '每天',
    scheduledTasksFormScheduleModeWeekly: '每周',
    scheduledTasksFormScheduleModeMonthly: '每月',
    scheduledTasksFormWeekSun: '周日',
    scheduledTasksFormWeekMon: '周一',
    scheduledTasksFormWeekTue: '周二',
    scheduledTasksFormWeekWed: '周三',
    scheduledTasksFormWeekThu: '周四',
    scheduledTasksFormWeekFri: '周五',
    scheduledTasksFormWeekSat: '周六',
    scheduledTasksFormValidationTimeRequired: '请选择时间',
    scheduledTasksFormValidationWorkingDirectoryRequired: '请选择任务工作目录',
    scheduledTasksFormMonthDaySuffix: '日',
    scheduledTasksFormScheduleAt: '定时执行',
    scheduledTasksFormScheduleAtHint: '在指定时间执行一次',
    scheduledTasksFormScheduleInterval: '间隔执行',
    scheduledTasksFormScheduleIntervalHint: '按固定间隔重复执行',
    scheduledTasksFormScheduleCron: 'Cron 表达式',
    scheduledTasksFormScheduleCronHint: '使用 Cron 表达式定义复杂调度',
    scheduledTasksFormDatetime: '执行时间',
    scheduledTasksFormInterval: '间隔时间',
    scheduledTasksFormIntervalMinutes: '分钟',
    scheduledTasksFormIntervalHours: '小时',
    scheduledTasksFormIntervalDays: '天',
    scheduledTasksFormCronExpression: 'Cron 表达式',
    scheduledTasksFormCronPlaceholder: '例如: */5 * * * * (每5分钟)',
    scheduledTasksFormCronHelp: '格式: 分 时 日 月 周 (5段)',
    scheduledTasksFormPrompt: '执行提示词',
    scheduledTasksFormPromptPlaceholder: '输入要执行的提示词...',
    scheduledTasksFormWorkingDirectory: '工作目录',
    scheduledTasksFormWorkingDirectoryPlaceholder: '输入工作区路径',
    scheduledTasksFormSystemPrompt: '系统提示词',
    scheduledTasksFormSystemPromptPlaceholder: '可选的系统提示词...',
    scheduledTasksFormExecutionMode: '运行模式',
    scheduledTasksFormExecutionModeAuto: '自动',
    scheduledTasksFormExecutionModeLocal: '本地',
    scheduledTasksFormExecutionModeSandbox: '沙箱',
    scheduledTasksFormModel: '模型',
    scheduledTasksFormModelDefault: '使用默认模型',
    scheduledTasksFormDatePlaceholder: '年/月/日',
    scheduledTasksFormCalendarLabel: '选择日期',
    scheduledTasksFormCalendarPreviousMonth: '上个月',
    scheduledTasksFormCalendarNextMonth: '下个月',
    scheduledTasksFormEnabled: '启用任务',
    scheduledTasksFormCreate: '创建任务',
    scheduledTasksFormUpdate: '更新任务',
    scheduledTasksFormValidationNameRequired: '请输入任务标题',
    scheduledTasksFormValidationPromptRequired: '请输入执行提示词',
    scheduledTasksFormValidationDatetimeFuture: '执行时间必须在未来',
    scheduledTasksFormValidationIntervalPositive: '间隔时间必须大于 0',
    scheduledTasksFormValidationCronRequired: '请输入 Cron 表达式',
    scheduledTasksEdit: '编辑',
    scheduledTasksDelete: '删除',
    scheduledTasksDeleteConfirm: '确定要删除任务「{name}」吗？此操作不可撤销。',
    scheduledTasksRun: '立即运行',
    scheduledTasksStop: '停止',
    scheduledTasksEnabled: '已启用',
    scheduledTasksDisabled: '已禁用',
    scheduledTasksDetail: '任务详情',
    scheduledTasksConfiguration: '配置信息',
    scheduledTasksSchedule: '计划',
    scheduledTasksPrompt: '提示词',
    scheduledTasksWorkingDirectory: '工作目录',
    scheduledTasksSystemPrompt: '系统提示词',
    scheduledTasksExecutionMode: '运行模式',
    scheduledTasksStatus: '运行状态',
    scheduledTasksNextRun: '下次运行',
    scheduledTasksLastRun: '上次运行',
    scheduledTasksLastDuration: '上次耗时',
    scheduledTasksLastError: '最近错误',
    scheduledTasksConsecutiveErrors: '连续错误',
    scheduledTasksRunHistory: '运行历史',
    scheduledTasksNoRuns: '暂无运行记录',
    scheduledTasksLoadMore: '加载更多',
    scheduledTasksManual: '手动',
    scheduledTasksScheduled: '定时',
    scheduledTasksViewSession: '查看会话',
    scheduledTasksStatusSuccess: '成功',
    scheduledTasksStatusError: '失败',
    scheduledTasksStatusRunning: '运行中',
    scheduledTasksStatusIdle: '空闲',
    scheduledTasksNotSet: '未设置',
    scheduledTasksNone: '无',
    scheduledTasksScheduleAtLabel: '定时',
    scheduledTasksScheduleIntervalLabel: '间隔',
    scheduledTasksScheduleCronLabel: 'Cron',
    scheduledTasksScheduleEvery: '每',
    scheduledTasksAutoDisabledErrors: '连续错误过多，任务已自动禁用',
    scheduledTasksCreateFailed: '创建任务失败',
    scheduledTasksUpdateFailed: '更新任务失败',
    scheduledTasksDeleteFailed: '删除任务失败',
    scheduledTasksRunFailed: '运行任务失败',
    scheduledTasksStopFailed: '停止任务失败',
    scheduledTasksFormExpiresAt: '到期时间',
    scheduledTasksFormOptional: '（可选）',
    scheduledTasksFormExpiresAtHint: '可选，到期后任务不再运行',
    scheduledTasksFormExpiresAtClear: '清除',
    scheduledTasksFormExpiresAtNone: '永不过期',
    scheduledTasksDetailExpiresAt: '到期时间',
    scheduledTasksFormNotify: '通知',
    scheduledTasksFormNotifyHint: '可选，任务完成后通过 IM 发送结果通知',
    scheduledTasksFormNotifyDingtalk: '钉钉',
    scheduledTasksFormNotifyFeishu: '飞书',
    scheduledTasksFormNotifyTelegram: 'Telegram',
    scheduledTasksFormNotifyDiscord: 'Discord',
    scheduledTasksFormNotifyNone: '无',
    scheduledTasksFormSandboxProfile: '沙箱环境',
    scheduledTasksFormSandboxImage: '镜像',
    scheduledTasksFormSandboxProfileDefault: '使用默认环境',
    scheduledTasksFormSandboxImageDefault: '使用默认镜像',
    scheduledTasksDetailNotify: '通知',
    scheduledTasksToggleWarningAtPast: '该任务的执行时间已过，启用后将不会运行',
    scheduledTasksToggleWarningExpired: '该任务已过期，启用后将不会运行',

    // 场景应用
    scenarios: '场景应用',
    scenariosTitle: '场景应用',
    scenariosEmpty: '暂无可用场景',
    scenariosLoadFailed: '加载场景失败，请检查连接后重试。',
    scenarioApplyToConversation: '应用到当前对话',
    scenariosRecentlyUsed: '最近使用',
    scenariosShuffle: '换一批',
    scenariosViewAll: '查看全部',
    scenariosUsedAt: '{time}使用',
    scenariosEmptyHint: '请联系管理员分配场景应用',
    scenariosStartChat: '开始对话',
    scenarioDetailsLoadFailed: '场景技能检查失败，请重试。',
    scenarioDetailsNoSkills: '本场景无需额外技能。',
    scenarioDetailsReadOnlyHint: '确认开始后才会准备技能，不会自动发送消息。',
    scenarioDetailsRecommendedModel: '推荐模型：{model}（不更改全局模型设置）',
    scenariosHot: '热门',
    scenariosRecommended: '推荐',
    scenariosUsageCount: '使用 {count} 次',
    scenariosRefresh: '刷新',
    scenariosLinkedSkills: '关联技能',
    scenariosDismiss: '取消场景',
    scenariosServeYou: '为你服务',
    scenariosServeHint: '请告诉我你需要什么帮助',
    scenariosWorkflow: '操作流程',
    scenariosAll: '全部',

    // 连接器
    connectors: '连接器',
    connectorsDescription: '浏览平台连接器并授权；授权后，智慧助理即可在 Cowork 中调用。',
    connectorSearchPlaceholder: '搜索连接器（名称 / 简介 / 提供者）',
    connectorFilterAll: '全部',
    connectorFilterMcp: 'MCP 功能',
    connectorIMPurpose: '消息渠道：配置并启用机器人后，可从聊天软件发起任务和接收结果。',
    connectorIMUnavailable: '此渠道尚未接入 Web 机器人配置，不代表已连接或可调用。',
    connectorIMUnsupported: 'Web 暂不支持',
    connectorFilterIm: '消息渠道',
    connectorConnect: '连接',
    connectorReauthRequired: '需要重新授权',
    connectorReauthorize: '重新授权',
    connectorClientUpgradeRequired: '请将 Web 升级至 {version} 后再连接',
    connectorDesktopOnly: '此连接器需要桌面端直连',
    connectorConfigIncomplete: '连接器配置不完整，请联系管理员',

    connectorConfigure: '设置',
    connectorDisconnect: '断开',
    connectorConnectFailed: '连接失败',
    connectorDisconnectFailed: '断开失败',
    connectorCredentialHint: '凭证将由平台安全保存，不会写入浏览器本地存储。',
    connectorEmpty: '没有找到匹配的连接器',
    refresh: '刷新',
    scenariosSearchPlaceholder: '搜索场景名称或描述...',
    scenariosNoMatches: '未找到匹配的场景',
    scenariosPreviousPage: '上一页',
    scenariosNextPage: '下一页',
    scenariosPopularTitle: '热门场景',
    scenariosRankingHint: '基于使用频率排名',

    // 工具列表
    toolList: '工具列表',
    toolListDesc: '以下工具由管理员在管理平台中配置，AI 可直接调用对应 API 完成工作',
    toolListEmpty: '暂无可用工具',
    toolListEmptyHint: '管理员尚未在管理平台中配置工具，请联系管理员添加',
    toolListStatusEnabled: '已启用',
    toolListStatusDisabled: '已禁用',
    toolListRefresh: '刷新',
    toolIntegration: '工具接入',
    toolIntegrationDesc: '将智能助手与企业工具完全打通，配置业务系统的连接凭证后，AI 可直接调用对应 API 完成工作',
    toolIntegrationDescHint: '该功能需配合对应业务系统的技能使用，如有企业接入需求请联系',
    toolIntegrationAdd: '添加工具',
    toolIntegrationEdit: '编辑工具',
    toolIntegrationDelete: '删除工具',
    toolIntegrationName: '工具名称',
    toolIntegrationUrl: 'API 地址',
    toolIntegrationAuthType: '认证方式',
    toolIntegrationCredentialHint: '所有凭证均通过加密方式存储在您的本地设备，不会上传至任何服务器',
    toolIntegrationToken: 'Token',
    toolIntegrationUsername: '用户名',
    toolIntegrationPassword: '密码',
    toolIntegrationLogo: '图标',
    toolIntegrationEnabled: '已启用',
    toolIntegrationEmpty: '暂无接入工具',
    toolIntegrationEmptyHint: '添加企业业务系统后，AI 可以使用您的凭证调用对应 API',
    toolIntegrationConnected: '已接入以下工具，我可以帮你查询数据、提交工单、操作这些系统',
    toolIntegrationDeleteConfirm: '确定删除该工具吗？',
    toolIntegrationSaved: '工具配置已保存',
    toolIntegrationNamePlaceholder: '例如 Jira、GitLab',
    toolIntegrationUrlPlaceholder: '例如 https://jira.example.com',
    toolIntegrationTestConnection: '测试网络连接',
    toolIntegrationTestingConnection: '测试中...',
    toolIntegrationConnectionSuccess: '连接成功',
    toolIntegrationConnectionFailed: '连接失败，请检查地址是否正确',
    toolIntegrationTokenPlaceholder: '输入 Token',
    toolIntegrationUsernamePlaceholder: '输入用户名',
    toolIntegrationPasswordPlaceholder: '输入密码',
    toolIntegrationSkills: '适用技能',
    toolIntegrationSkillsHint: '选择该工具凭证适用的技能，执行时自动注入',
    toolIntegrationSkillsPlaceholder: '搜索技能名称…',
    toolIntegrationEnvVarsTitle: '将自动注入以下环境变量（技能脚本可直接读取）',
    toolIntegrationEnvVarsRule: '命名规则：技能 ID 转大写并将 - 替换为 _，例如 folib-artifact → FOLIB_ARTIFACT_BASE_URL / FOLIB_ARTIFACT_TOKEN',
    toolIntegrationInjectBtn: '注入凭证到技能',
    toolIntegrationInjectSuccess: '注入成功',
    toolIntegrationInjectError: '注入失败，请重试',
    toolQuickTasks: '快捷任务',
    toolQuickTasksHint: '描述任务场景，可直接添加或让 AI 生成详细指令',
    toolQuickTasksInputPlaceholder: '例如：岗位:开发岗，场景:查看我的需求进度，要求:按优先级汇总...',
    toolQuickTasksGenerate: '生成',
    toolQuickTasksGenerating: '生成中...',
    toolQuickTasksAddDirect: '直接添加',
    toolQuickTasksSuggestionsTitle: '点击添加到快捷任务：',
    toolQuickTasksEmptyHint: '暂无快捷任务，输入描述后点击生成',
    toolQuickTasksClickToUse: '点击快速发起任务',

    // 镜像管理
    mirrorManagement: '镜像管理',
    mirrorManagementDesc: '选择沙箱环境中使用的镜像源',
    mirrorManagementRefresh: '刷新',
    mirrorManagementRefreshing: '刷新中...',
    mirrorManagementEmpty: '暂无可用镜像',
    mirrorManagementEmptyHint: '请在平台管理后台添加镜像源',
    mirrorManagementSelected: '已选中',
    mirrorManagementDefault: '默认',
    mirrorManagementNoSelection: '不使用镜像源',
    mirrorManagementFetchError: '获取镜像列表失败',
    mirrorManagementNpm: 'NPM 镜像',
    mirrorManagementPypi: 'PyPI 镜像',
    mirrorManagementApk: 'APK 镜像',

    // Widget (生成式 UI)
    widgetShowCode: '查看源码',
    widgetHideCode: '隐藏源码',
    widgetLoading: '正在生成可视化...',
  },
  'zh-TW': {
    // App 扫码登录：状态保存翻译键，切换语言不重建扫码会话。
    authAppQrTab: "App 掃碼",
    authAppQrRegion: "App 掃碼登入",
    authAppQrTitle: "使用 App 掃碼登入",
    authAppQrCreating: "正在產生二維碼…",
    authAppQrPlatformChanged: "平台已切換，請重新產生二維碼",
    authAppQrExpired: "二維碼已過期",
    authAppQrLogging: "正在登入…",
    authAppQrSuccess: "登入成功",
    authAppQrInitFailed: "登入初始化失敗，請重新登入",
    authAppQrCancelled: "二維碼已取消或已使用",
    authAppQrPending: "等待手機掃碼",
    authAppQrScanned: "已掃碼",
    authAppQrVerifying: "等待兩步驗證",
    authAppQrDeciding: "正在驗證授權…",
    authAppQrUnconfirmed: "登入結果未確認，請重新產生二維碼",
    authAppQrInvalid: "二維碼已失效，請重新產生",
    authAppQrRetrying: "連線暫時中斷，正在重試…",
    authAppQrDisabled: "App 掃碼登入已關閉，請使用其他方式登入",
    authAppQrUnavailable: "二維碼暫時無法使用，請稍後重試",
    authAppQrInstructions: "開啟 App → 設定 → 掃一掃登入",
    authAppQrExpiryHint: "二維碼僅可使用一次，將在 {minutes} 分鐘內過期",
    authAppQrConfirmHint: "請在手機上確認登入",
    authAppQrVerifyHint: "請在手機上輸入兩步驗證碼",
    authAppQrLoggingHint: "手機已授權，正在建立工作階段",
    authAppQrSuccessHint: "正在進入 {app}…",
    authAppQrDecidingHint: "請稍候，正在校驗手機授權",
    authAppQrCheckCode: "核對碼 {code}",
    authAppQrBack: "返回其他登入方式",
    authAppQrRefresh: "重新整理二維碼",
    authAppQrRegenerate: "重新產生二維碼",

    loginPhoneRegion: "手機區號",
    loginPhoneMainland: "中國大陸",
    loginPhoneHongKong: "中國香港",
    loginSwitchPhone: "手機號",
    loginSwitchPassword: "帳號密碼",
    loginSwitchWechat: "微信掃碼",
    loginSmsLabel: "簡訊驗證碼",

    loginSmsFrequent: "傳送過於頻繁，請稍後再試",
    loginSmsDailyLimit: "今日驗證碼傳送次數已達上限",
    loginSmsInvalid: "驗證碼錯誤，請重新輸入",
    loginSmsExpired: "驗證碼已過期，請重新獲取",
    loginSmsInvalidOrExpired: "驗證碼錯誤或已過期，請重新獲取",

    loginOtherMethods: "其他方式",
    loginPasswordMethod: "帳號密碼登入",
    loginWeChatMethod: "微信掃碼登入",
    loginRegister: "登入 / 註冊",
    loginForgot: "忘記密碼？",
    loginShowPassword: "顯示密碼",
    loginHidePassword: "隱藏密碼",
    loginResend: "重新獲取",
    loginCountdown: "{seconds}s 後重發",
    loginCodeInvalid: "請輸入 6 位驗證碼",
    loginPasswordInvalid: "帳號或密碼錯誤",
    loginAccountRequired: "請輸入帳號",
    loginPasswordRequired: "請輸入密碼",
    loginPhoneUnavailable: "手機號登入暫未開放，請使用帳號密碼登入",
    loginWeChatUnavailable: "微信登入暫未開放，請使用其他方式登入",
    loginLoadingMethods: "正在載入登入方式…",
    loginConsentQr: "請先閱讀並同意下方協議，再載入二維碼",
    loginScan: "開啟微信 · 掃一掃",
    loginScanRegister: "首次掃碼需綁定手機號後登入",
    loginRetryQr: "點擊重新整理",
    loginSending: "傳送中…",
    loginAccount: "帳號",
    loginPassword: "密碼",
    loginAssistant: "AI 智慧助理",

    settingsBasicGroup: '基礎設定',
    settingsCapabilityGroup: '協作能力',
    settingsSystemGroup: '系統',

    customAgentFixedModel: "Agent 指定模型",
    personalStorageTitle: "Web 檔案與快取",
    personalStorageRefresh: "重新整理",
    personalStorageUnknown: "暫不可用",
    personalStorageFailed: "儲存檢查失敗，請稍後重試",
    personalStorageScope: "統計目前帳號保存在 Web 伺服器的附件、產物、文件素材與對話快取。不統計或清理 Cube 掛載工作區，也不包含桌面客戶端檔案。",
    personalStorageChecking: "正在檢查儲存…",
    personalStorageTotal: "Web 對話檔案占用",
    personalStorageIncomplete: "部分分類暫不可用，已知分類仍可查看，請稍後重新整理。",
    personalStoragelegacy: "舊版對話檔案與快取",
    personalStoragedocuments: "文件修訂與素材",
    personalStorageinputs: "對話附件",
    personalStorageartifacts: "生成產物與暫存上傳",
    personalStorageFiles: "項",
    personalStoragePolicy: "僅清理失敗或過期的暫存產物上傳。已儲存的附件、產物與正在上傳的檔案保留。確認時會再次檢查狀態；預覽五分鐘有效。",
    personalStoragePreview: "預覽清理範圍",
    personalStorageRemoved: "已清理",
    personalStorageSkipped: "狀態變化已略過",
    personalStorageFailedCount: "失敗",
    personalStorageCancel: "取消",
    personalStorageConfirm: "確認清理",
    backgroundTasksTitle: "背景任務",
    backgroundTasksHint: "查看本對話的子代理與背景執行。關閉面板不會停止任務，子任務完成不代表整個對話完成。",
    backgroundTasksRefresh: "重新整理任務",
    backgroundTasksClose: "關閉任務面板",
    backgroundTasksFailed: "任務檢查失敗，請稍後重試",
    backgroundTasksunsupported: "目前沙箱或對話不支援任務控制。歷史紀錄僅供查看。",
    backgroundTasksdisconnected: "執行連線暫不可用。以下為最後紀錄，活動任務狀態需要重新確認。",
    backgroundTasksChecked: "最後檢查",
    backgroundTasksLoading: "正在讀取任務…",
    backgroundTasksEmpty: "目前沒有已記錄的背景任務",
    backgroundTasksrunning: "執行中",
    backgroundTaskscompleted: "已完成",
    backgroundTasksfailed: "失敗",
    backgroundTasksstopped: "已停止",
    backgroundTaskspending: "等待中",
    backgroundTasksunknown: "待確認",
    backgroundTasksAgent: "子代理",
    backgroundTasksShell: "背景命令",
    backgroundTasksGeneric: "任務",
    backgroundTasksLocate: "定位對話",
    backgroundTasksStop: "停止任務",
    backgroundTasksTruncated: "僅顯示最近保留的 200 項任務，較早紀錄可能已省略。",
    backgroundTasksStopHint: "僅停止此子任務，不取消整個對話。既有檔案改動不會回復；伺服器確認後才顯示停止結果。",
    backgroundTasksCancel: "取消",
    backgroundTasksConfirmStop: "確認停止",
    memoryCatalogScope: "記憶範圍",
    memoryCatalogPersonal: "個人記憶檔案",
    memoryCatalogLegacy: "舊全域記憶（相容）",
    memoryCatalogRefresh: "重新整理記憶目錄",
    memoryCatalogNew: "新增記憶",
    memoryCatalogPersonalHint: "目前帳號的個人記憶檔案，供一般對話和秘書依問題召回。一般對話遵守記憶開關；歸檔後不再召回。SOUL 人設及對話內部記憶保持獨立。",
    memoryCatalogLegacyHint: "保留舊客戶端同步的全域檔案，僅屬於目前帳號。不會自動合併或覆蓋個人記憶。",
    memoryCatalogSearch: "搜尋記憶名稱或正文",
    memoryCatalogLoading: "正在讀取記憶目錄…",
    memoryCatalogEmpty: "沒有符合的記憶檔案",
    memoryCatalogActive: "生效",
    memoryCatalogArchived: "已歸檔",
    memoryCatalogOther: "其他狀態",
    memoryCatalogEdit: "編輯與歷史",
    memoryCatalogArchive: "歸檔",
    memoryCatalogMore: "載入更多",
    memoryCatalogName: "檔名（不含副檔名）",
    memoryCatalogContent: "記憶內容",
    memoryCatalogFormatHint: "可直接填寫事實正文，或保留 Markdown 檔案標頭；請勿把人設指令寫入事實記憶。",
    memoryCatalogArchiveHint: "歸檔後退出後續事實召回，正文和修訂保留，可從編輯器還原歷史版本。",
    memoryCatalogCancel: "取消",
    memoryCatalogCreate: "建立",
    memoryCatalogConfirmArchive: "確認歸檔",
    memoryCatalogUnavailable: "記憶服務暫不可用，請稍後重試",
    memoryCatalogOpen: "個人記憶",
    memoryCatalogClose: "關閉記憶管理",
    customAgentPolicy: "Agent 按帳號獨立保存，使用平台模型與每會話隔離的雲端目錄。修改只影響新會話，既有會話保留建立時版本。",
    customAgentLoadFailed: "Agent 清單載入失敗",
    customAgentReload: "重新載入",
    customAgentSaveFailed: "儲存失敗，請重試",
    customAgentNew: "新增 Agent",
    customAgentEnabled: "已啟用",
    customAgentDisabled: "已停用",
    customAgentname: "名稱",
    customAgentdescription: "用途說明",
    customAgentrole: "角色",
    customAgentsystemPrompt: "指令",
    customAgentModel: "模型",
    customAgentCurrentModel: "使用新會話所選模型",
    customAgentModelUnavailable: "目前無法使用",
    customAgentDelete: "刪除",
    customAgentSave: "儲存",
    customAgentSaving: "儲存中…",
    customAgentDeleteHint: "僅刪除 Agent 定義；既有會話、設定快照與檔案會保留。",
    customAgentCancel: "取消",
    customAgentSelect: "選擇 Agent",
    customAgentDefault: "預設助理",
    customAgentManage: "管理 Agent",
    customAgentClose: "關閉",
    customAgentSnapshot: "建立時 Agent 設定",

    conversationResultsTitle: "來源與產物",
    conversationResultsHint: "依本輪工具與檔案記錄檢查",
    conversationResultsFailed: "檢查失敗，請重新整理",
    conversationResultsDownloadFailed: "下載失敗，請重新檢查",
    conversationResultsRefresh: "重新檢查",
    conversationResultsChecking: "正在檢查…",
    conversationResultsverified: "檔案校驗通過",
    conversationResultsinvalid: "內容校驗未通過",
    conversationResultsunavailable: "暫不可用",
    conversationResultsunverified: "內容待檢查",
    conversationResultsDownload: "下載",
    conversationResultsSources: "本輪來源",
    conversationResultsEmpty: "本輪尚無可核驗的託管產物或結構化搜尋來源；不代表已完整交付。",
    conversationResultsTruncated: "本次顯示前 20 個產物，請在檔案面板查看其他檔案。",

    telegramTokenHint: "從 @BotFather 取得 Bot Token；權杖僅儲存於目前帳號的連線實例。",
    imInstancesTitle: "連線實例",
    imInstancesDefault: "預設連線",
    qq: 'QQ',
    wechat: '微信',
    imWechatWebHint: '使用微信掃描QR碼並確認登入。憑據僅儲存到目前連線，登入後請手動啟用；重新掃碼前先停用。',
    imWechatAccount: '微信帳號',
    imPairingScan: '請掃碼並在手機上確認',
    imPairingScanned: '已掃碼，等待確認',
    imPairingSaved: '登入已儲存，請啟用連線',
    imPairingExpired: 'QR碼已過期，請重新取得',
    imPairingStart: '掃碼登入',
    imPairingFailed: '掃碼失敗，請重試',
    imNotificationTitle: "任務通知",
    imNotificationHint: "為目前連線選擇接收會話。只有排程任務勾選本平台後才會通知；新訊息不會改變你的選擇。",
    imNotificationTarget: "接收會話",
    imNotificationNone: "不接收通知",
    imNotificationDirect: "私聊",
    imNotificationGroup: "群聊",
    imNotificationEmpty: "請先讓接收人在機器人會話中發一則訊息，然後重新整理列表。",
    imNotificationWechatHint: "微信通知需要有效會話上下文。服務重啟或上下文過期後，請讓接收人重新發一則訊息。",
    imNotificationSent: "最近一次通知已被平台接收",
    imNotificationFailed: "最近一次通知未確認，請檢查連線、接收會話和平台發送限制；不會自動重發。",
    imNotificationNotSelected: "未設定接收會話，通知未發送",
    imNotificationRequestFailed: "通知設定讀取或儲存失敗，請重新整理後重試。",
    scheduledTasksNotificationFailed: "任務通知未確認，請在聊天入口的對應連線中檢查接收會話和發送狀態。",
    scheduledTasksNotifyTargetHint: "請先在聊天入口中設定接收會話。所選平台下每個已設定目標的連線實例都會收到通知。",
    scheduledTasksFormNotifyQq: "QQ",
    scheduledTasksFormNotifyWechat: "微信",
    scheduledTasksFormNotifyWechatwork: "企業微信",
    scheduledTasksFormNotifyNim: "網易雲信",
    imQQConnectMode: 'QQ連線方式',
    imQQManualMode: '手動設定',
    imQQPairingHint: '使用手機QQ掃描並完成官方機器人綁定。憑據僅儲存到目前連線，完成後請手動啟用。',
    imQQWebHint: '填寫QQ開放平台的App ID與App Secret，儲存後測試並啟用。支援頻道、群組和私訊；修改憑據前先停用連線。',
    imInstancesHint: "每個帳號的連線獨立儲存。同一平台可建立多個機器人實例；舊的無主設定不會自動繼承。",
    imInstancesAdd: "新增實例",
    imInstancesDelete: "刪除實例",
    imInstancesDeleteHint: "刪除會停止此實例並移除設定。既有聊天、檔案和積分帳單會保留。",
    imInstancesName: "實例名稱",
    imInstancesPlatform: "平台",
    imInstancesFailed: "操作失敗，請重試",
    imInstancesUnsupported: "目前執行端不支援實例管理",

    coworkModelSaveFailed: "模型切換未儲存，仍使用原模型。請稍後重試。",
    coworkContinueInstruction: "請基於先前已完成的結果繼續目前任務。保留既有成果，不要重複已成功執行的操作。",
    coworkRecoveryContinue: "繼續任務",
    coworkRecoverySending: "正在提交…",
    coworkRecoverySubmitted: "已提交",
    coworkRecoveryFailed: "繼續請求未確認，請檢查連線後再試。",
    coworkRecoveryWait: "請稍後再試",

    turnDelete_title: "按輪次刪除",
    turnDelete_hint: "每輪包含提問、回答及工具訊息。刪除無法復原；檔案、獨立記憶和已扣積分保留。最多選擇 200 輪。續聊時會重建模型上下文；舊沙箱可能需要更新。",
    turnDelete_busy: "工作階段正在執行或排隊，請結束後再刪除。",
    turnDelete_unsupported: "此舊工作階段暫不支援安全重設歷史，請使用新版工作階段。",
    turnDelete_failed: "刪除未確認，選擇已保留。請重新整理核對後再試。",
    turnDelete_attachment: "附件訊息",
    turnDelete_count: "已選擇 {count} 輪",
    turnDelete_confirm: "確認永久刪除所選輪次？",
    turnDelete_confirmButton: "確認永久刪除",
    turnDelete_delete: "刪除所選輪次",
    turnDelete_deleting: "正在刪除…",

    campaign_title: "活動福利",
    campaign_close: "關閉活動",
    campaign_details: "查看詳情",
    campaign_claim: "領取",
    campaign_claimed: "今日已領取",
    campaign_success: "已領取 {credit} 積分",
    campaign_total: "累計領取 {credit} 積分",
    campaign_failed: "領取結果暫未確認，正在更新資格。請查看積分餘額後再操作。",

    memoryFile_title: "編輯記憶檔案",
    memoryFile_hint: "保留檔案標頭。儲存會產生歷史版本；其他裝置修改後需重新載入。",
    memoryFile_history: "版本歷史",
    memoryFile_current: "目前版本",
    memoryFile_preview: "歷史內容（唯讀）",
    memoryFile_content: "檔案內容",
    memoryFile_reload: "重新載入",
    memoryFile_restore: "還原此版本",
    memoryFile_restoreConfirm: "還原會產生新版本，並取代目前草稿。繼續還原？",
    memoryFile_discardConfirm: "有未儲存的修改，確認捨棄？",
    memoryFile_unavailable: "記憶檔案暫時無法使用",
    memoryFile_manual: "手動編輯",
    memoryFile_restoreActor: "還原版本",
    memoryFile_model: "模型更新",
    memoryFile_system: "系統更新",
    memoryFile_organizer: "記憶整理",
    memoryFile_fileName: "檔案名稱（不含 .md）",
    memoryFile_rename: "重新命名",
    memoryFile_renameConfirm: "重新命名會保留內容和歷史，並同步舊名稱的刪除。繼續？",
    memoryFile_renameHint: "支援小寫字母、數字、中文、底線及連字號；檔名與正文名稱獨立。",
    memoryFile_saveBeforeRename: "請先儲存或重新載入草稿，再重新命名。",
    memoryFile_renameActor: "重新命名檔案",
    memoryFile_soulEditHistory: "編輯 Soul 與版本歷史",
    memoryFile_soulHint: "身分與互動方式獨立儲存，不進入事實同步。還原預設先產生草稿，儲存後生效。",

    creditForbidden: "目前帳號無權查詢積分或已被停用。",
    creditNoPlan: "暫無方案或贈送額度",
    creditOtherSource: "其他來源",
    // 用户积分与账户：沿用平台计量单位，不混用实扣和模拟用量。
    creditTitle: "積分與用量",
    creditRefresh: "重新整理",
    creditLoading: "正在讀取積分…",
    creditUnsupported: "目前平台尚不支援此積分查詢。",
    creditSignIn: "請重新登入後查看積分。",
    creditUnavailable: "積分資料暫時無法取得，請稍後重新整理。",
    creditStale: "以下為上次成功讀取的資料，可能已過期。",
    creditNoExpiry: "未設定 / 不適用",
    creditUnit: "積分",
    creditShadow: "影子計費：用量為模擬應扣積分，不代表實際扣款。",
    creditOff: "目前未啟用積分計費；餘額為平台紀錄，不將用量顯示為實扣積分。",
    creditDebt: "待結清欠款",
    creditWallet: "錢包餘額",
    creditWalletHint: "不與方案或企業共用池重複相加。",
    creditSubscription: "方案與贈送剩餘",
    creditUnlimited: "不限量",
    creditUsed: "已用",
    creditIssued: "本期額度",
    creditBase: "基本額度",
    creditBonus: "贈送額度",
    creditReset: "下次重設",
    creditPool: "企業共用池剩餘",
    creditPoolHint: "這是共用額度，不是個人專屬餘額。",
    creditSimulatedUsage: "模擬用量（積分）",
    creditUsage: "積分用量",
    creditToday: "今日",
    creditWeek: "近 7 天",
    creditMonth: "近 30 天",
    creditPartial: "部分區間統計無法取得；「—」表示未知，不是零消費。",
    creditDailyLimit: "每日額度已用 / 上限",
    creditInventory: "積分來源與到期明細",
    creditHistory: '收支記錄',
    creditHistoryFilter: '記錄類型',
    creditHistoryHint: '按平台記錄展示領取、儲值與消費。未提供的歷史積分金額顯示為 —，不由餘額推算。',
    creditHistoryUsed: '消耗積分',
    creditHistorySimulated: '模擬費用',
    creditHistoryPrevious: '上一頁',
    creditHistoryNext: '下一頁',
    creditLogType0: '全部記錄',
    creditLogType1: '儲值',
    creditLogType2: '消費',
    creditLogType3: '帳戶變動',
    creditLogType4: '系統記錄',
    creditLogType5: '錯誤記錄',
    creditLogType6: '退款',
    creditInventoryHint: "依發放批次顯示；錢包只顯示目前餘額，不推算歷史儲值或消耗。",
    creditEmpty: "暫無積分來源紀錄。",
    creditPlan: "方案",
    creditReward: "獎勵 / 贈送",
    creditExpired: "已失效",
    creditActive: "有效",
    creditRemaining: "剩餘",
    creditExpiry: "到期時間",
    creditSource: "來源",
    creditUpdated: "最近更新",
    // 通用
    save: '儲存',
    cancel: '取消',
    saving: '儲存中...',
    create: '建立',
    user: '使用者',
    login: '登入',
    loginWelcome: '登入你的賬戶',
    loginSubtitle: '歡迎回來，請輸入你的登入資訊',
    register: '註冊',
    logout: '退出登入',
    inDevelopment: '正在開發中',
    all: '全部',
    assigned: '已分配',
    unassigned: '未分配',
    featured: '精選',
    personal: '個人',
    skillsEmpty: '暫無技能',
    skillCreatorPrompt: '幫我建立一個新技能。請先問我這個技能應該做什麼。',
    retry: '重試',
    imagePreview: '預覽圖片',
    imageOriginalSize: '原始尺寸',
    imageFitWindow: '適應視窗',
    imageLoadFailed: '圖片載入失敗，請重試',
    retrying: '重試中...',
    platformOfflineMessage: '平台服務暫時不可用，已登入狀態保留，本地功能可繼續使用',
    builtinSkillsDescription: '管理員為您所屬部門分配的精選技能，沙箱執行時自動掛載',
    categoryAnalysis: '數據分析',
    categoryEducation: '教育學習',
    categoryOther: '其他',
    categoryCollaboration: '通訊協作',
    createViaChat: '通過對話建立',
    createViaChatDescription: '描述你的需求，AI 幫你生成',
    skillDuplicateDisabled: '已選擇同名技能的其他版本',
    skillCreatorBothDisabled: '個人技能和內置技能中都有 skill-creator 但均未啟用，請先開啟',
    skillCreatorBuiltinDisabled: '內置技能中 skill-creator 已關閉，請先在內置技能中開啟',
    skillCreatorPersonalDisabled: 'skill-creator 技能未啟用，請先在個人技能中開啟',
    skillCreatorMissing: '您尚未擁有 skill-creator 技能，請聯絡管理員分配',
    authAccount: '賬戶',
    authAccountStatus: '賬戶狀態',
    authAccountSettings: '賬戶設定',
    authSignIn: '登入',
    authUsername: '賬號',
    authUsernamePlaceholder: '輸入賬號',
    authPhone: '手機號',
    authPhonePlaceholder: '輸入手機號',
    authVerificationCode: '驗證碼',
    authVerificationCodePlaceholder: '輸入手機驗證碼',
    authTwoFactorTitle: '二步驗證',
    authTwoFactorCode: '2FA 驗證碼',
    authTwoFactorCodePlaceholder: '輸入 2FA 驗證碼',
    authTwoFactorCodeRequired: '請輸入 2FA 驗證碼',
    authTwoFactorRequired: '該賬號需要 2FA 驗證，請繼續輸入驗證碼',
    authBackToLogin: '返回登入',
    authUsernamePasswordRequired: '請輸入賬號和密碼',
    authCaptchaRequired: '請輸入驗證碼',
    authLoginTabPassword: '密碼登入',
    authLoginTabPhone: '手機號登入',
    authLoginTabWeChat: '微信掃碼',
    authSendSmsCode: '獲取驗證碼',
    authSmsCountdownSecond: '{seconds}s',
    authSmsCodeSent: '驗證碼已傳送',
    authInvalidPhone: '請輸入正確的手機號',
    authPhoneCodeRequired: '請填寫手機號和驗證碼',
    authWeChatScanHint: '請使用微信掃描二維碼登入',
    authWeChatQrLoading: '二維碼載入中...',
    authWeChatQrExpired: '二維碼已過期，請重新整理',
    authRefreshQrCode: '重新整理二維碼',
    authWeChatBindPhoneTitle: '繫結手機號',
    authWeChatBindPhoneHint: '請驗證並綁定手機號，完成註冊後即可登入；已有手機號帳號將關聯本次微信。',
    authRegisterRequired: '請完整填寫註冊所需欄位',
    authLoginSuccess: '登入成功',
    authRegisterSuccess: '註冊成功，請登入',
    authAgreePrefix: '我已閱讀並同意',
    authUserAgreement: '使用者協議',
    authAnd: '和',
    authPrivacyPolicy: '隱私政策',
    authPleaseAgree: '請先同意使用者協議和隱私政策',
    authNoAccount: '還沒有賬戶？',
    authGoToRegister: '前往註冊',
    authLogoutSuccess: '已退出登入',
    authTokenExpired: '登入狀態已失效，可能由於賬號密碼變更或被管理員下線，請重新登入',
    authSessionExpired: '登入狀態已過期，請重新登入',
    // OAuth 授權頁面
    oauthAuthorizeTitle: '授權 {orgCode} 客戶端',
    oauthAuthorizeDesc: '客戶端正在請求訪問您的 {orgCode} 賬戶',
    oauthAuthorizeButton: '授權並繼續',
    oauthLoginTitle: '登入以授權客戶端',
    oauthLoginDesc: '請登入您的 BoCoder 賬戶以授權客戶端訪問',
    oauthLoginAndAuthorize: '登入並授權',
    oauthVerifyAndAuthorize: '驗證並授權',
    oauthRedirecting: '授權成功',
    oauthSuccessDesc: '已完成身份驗證，請返回 {orgCode} 客戶端繼續使用。\n您可以安全地關閉此頁面。',
    oauthInvalidRedirect: '無效的回撥地址',
    oauthClientHint: '應用 {clientId} 正在請求授權',
    authNotLoggedIn: '當前未登入 BoCoder 賬戶',
    authUserStatus: '狀態',
    authUserStatusNormal: '正常',
    authUserStatusUnknown: '未知狀態',
    authSession: '會話',
    authSessionEmpty: '登入後可在這裡管理當前賬戶會話',

    // 設定
    help: '幫助',
    settings: '設定',
    edit: '編輯',
    delete: '刪除',
    general: '通用',
    model: '模型',
    shortcuts: '快捷鍵',
    theme: '主題',
    accentColor: '主題色',
    appearance: '外觀',
    language: '語言',
    useSystemProxy: '使用系統代理',
    useSystemProxyDescription: '開啟後網路請求將跟隨系統代理（儲存後生效）',
    quickActionSuggestions: '對話輔助提示',
    quickActionSuggestionsDescription: '任務完成後自動推薦後續操作（由 LLM 生成，會消耗少量 Token）',
    light: '淺色',
    dark: '深色',
    system: '跟隨系統',
    chinese: '簡體中文',
    traditionalChinese: '繁體中文',
    english: 'English',
    
    // 提供商標籤
    providerLabelCustom: '自定義',
    apiKeyGetHelp: '獲取 API Key',

    // API設定
    apiKey: 'API Key',
    apiKeyPlaceholder: '輸入你的 API Key',
    baseUrl: 'API Base URL',
    baseUrlPlaceholder: '輸入 API 基礎 URL',
    baseUrlHint1: '一般只需填寫域名，系統自動補全路徑',
    baseUrlHintExample1: 'https://ai.boclaw.ai',
    baseUrlHint2: '非標準路徑可填寫完整地址',
    baseUrlHintExample2: 'https://ai.boclaw.ai/api/v3/chat/completions',
    currentModel: '當前模型',
    availableModels: '可用模型列表',
    modelSwitchHint: '在聊天介面可以切換使用的模型',
    
    // 模型提供商設定
    enabled: '已啟用',
    disabled: '已停用',
    providerStatusOn: '已開啟',
    providerStatusOff: '未開啟',
    providerSettings: '提供商設定',
    modelProviders: '模型提供商',
    addModel: '新增模型',
    editModel: '編輯模型',
    addNewModel: '新增新模型',
    modelName: '模型名稱',
    modelId: '模型ID',
    modelNameAndIdRequired: '請填寫模型名稱和模型ID',
    modelIdExists: '模型ID已存在，請使用不同的ID',
    supportsImageInput: '支援影像輸入',
    imageInput: '影像',
    noModelsAvailable: '暫無可用模型',
    addFirstModel: '新增第一個模型',
    testConnection: '測試連線',
    testing: '測試中...',
    connectionSuccess: '連線成功',
    connectionFailed: '連線失敗',
    testConnectionAuthError: 'API Key 無效或已過期',
    testConnectionModelNotFound: '連線正常，但該模型不存在或無權訪問',
    testConnectionRateLimited: '連線正常，但請求頻率超限，請稍後再試',
    testConnectionNetworkError: '網路連線失敗，請檢查網路或開啟系統代理',
    noModelsConfigured: '請先新增模型',
    fetchModels: '重新整理模型列表',
    fetchingModels: '重新整理中...',
    fetchModelsSuccess: '已重新整理 {count} 個模型',
    fetchModelsFailed: '重新整理模型列表失敗',
    apiFormat: 'API 格式',
    apiFormatNative: 'Anthropic 相容',
    apiFormatOpenAI: 'OpenAI 相容',
    apiFormatHint: '請選擇 API 協議相容格式：Anthropic 相容或 OpenAI 相容',
    zhipuCodingPlanHint: '啟用後使用 GLM Coding Plan 專屬 API 端點',
    zhipuCodingPlanEndpointHint: '使用 GLM Coding Plan 時，系統將自動切換到 Coding 專屬端點',
    qwenCodingPlanHint: '啟用後使用阿里雲百鍊 Coding Plan 專屬 API 端點',
    qwenCodingPlanEndpointHint: '使用 Coding Plan 時，需要配置專屬的 API Key（格式：sk-sp-xxxxx）',
    moonshotCodingPlanHint: '啟用後使用 Moonshot Coding Plan 專屬 API 端點',
    moonshotCodingPlanEndpointHint: '使用 Coding Plan 時，系統將自動切換到 Coding 專屬端點',
    import: '匯入',
    export: '匯出',
    importProvidersFailed: '匯入失敗',
    exportProvidersFailed: '匯出失敗',
    invalidProvidersFile: '匯入檔案格式不正確',
    decryptProvidersFailed: '金鑰解密失敗，請確認檔案由當前裝置匯出',
    decryptProvidersPartial: '部分金鑰無法解密，已保留本地金鑰或留空，請手動檢查',

    // 密碼相關
    password: '密碼',
    confirmPassword: '確認密碼',
    enterPassword: '請輸入密碼',
    enterPasswordAgain: '請再次輸入密碼',
    exportPasswordTitle: '設定匯出密碼',
    importPasswordTitle: '輸入匯入密碼',
    exportPasswordHint: '此密碼用於加密你的 API 金鑰，匯入時需要使用相同的密碼',
    importPasswordHint: '請輸入匯出時設定的密碼',
    passwordRequired: '請輸入密碼',
    passwordMismatch: '兩次輸入的密碼不一致',
    passwordTooShort: '密碼長度至少為4位',
    wrongPassword: '密碼錯誤，請檢查後重試',
    
    // 快捷鍵
    keyboardShortcuts: '鍵盤快捷鍵',
    // 產品分組（側邊欄入口）
    productGroup: '產品',
    codeProgramming: 'Code 程式設計',
    appDownloadEntry: 'App 下載',
    codeBetaBadge: '公測',
    // Code 程式設計頁（走中繼控制 desktop）
    codeDeviceUnconnected: '未連線裝置',
    codeNoOnlineDesktop: '無線上桌面端。請在電腦上登入 BoCoder 桌面端並保持執行。',
    codeCloudEnv: '雲端環境',
    codeCloudEnvTag: '雲端',
    codeGitRepoLabel: '從 Git 倉庫開始（必填）',
    codeGitRepoPlaceholder: '倉庫地址（必填）',
    codeGitBranchPlaceholder: '分支',
    codeGitUsernamePlaceholder: '使用者名稱',
    codeGitPasswordPlaceholder: '密碼/Token',
    codeToastNoRepo: '請先填寫倉庫地址',
    codeExecutionMode: '執行模式',
    codePermModeAuto: '自動模式',
    codePermModeDefault: '預設',
    codePermModeAcceptEdits: '自動接受編輯',
    codePermModePlan: '計劃模式',
    codePermModeBypassPermissions: '跳過所有許可權',
    codeCloudEmptyHint: '描述你的需求，訊息將在雲端沙箱中執行，無需本地桌面端',
    codeToastCloudUnreachable: '無法連線雲端環境，請稍後重試',
    codeNewSession: '新建會話',
    codeNoSessions: '暫無程式設計會話，發訊息即可開始',
    codeSelectDeviceFirst: '請先選擇一臺線上桌面端',
    codeUntitledSession: '未命名會話',
    codeNewSessionCwd: '~ 新會話',
    codeCwdTitle: '工作目錄',
    codeCwdUseDefault: '使用預設',
    codeCwdSelectThis: '選定此目錄',
    codeCwdParent: '上級目錄',
    codeCwdNoSub: '無子目錄',
    codeCwdTruncated: '僅顯示前 200 項',
    codeCwdDefaultLabel: '預設目錄',
    codeCwdLoadFailed: '載入目錄失敗',
    codeRunning: '執行中',
    codeEmptyTitle: '開始程式設計',
    codeSelectDesktopToStart: '選擇一臺桌面端開始',
    codeEmptyHint: '訊息會發送到你的桌面端，由本機的 Code 引擎執行',
    codePermissionTool: '請求執行工具',
    codeAllow: '允許',
    codeAllowAlways: '始終允許',
    codeDeny: '拒絕',
    codeComposerPlaceholder: '給 Code 發訊息…（Enter 傳送，Shift+Enter 換行）',
    codeComposerDisabled: '請先選擇線上桌面端',
    codeStop: '停止',
    codeThinking: '思考中',
    codeJustNow: '剛剛',
    codeToastDeviceUnreachable: '無法連線所選裝置，請確認桌面端線上',
    codeToastNoDesktop: '沒有可用的桌面裝置',
    codeToastLoadSessionFailed: '載入會話失敗',
    codeToastSendFailed: '傳送失敗',
    codeToastStopFailed: '停止失敗',
    codeToastPermissionFailed: '許可權響應失敗',
    codeToastModelFailed: '切換模型失敗',
    codeToastModeFailed: '切換模式失敗',
    codeSearchPlaceholder: '搜尋會話',
    codeDeleteSession: '刪除會話',
    codeDeleteConfirm: '確定刪除該會話？此操作不可撤銷。',
    codeToastDeleteFailed: '刪除失敗',
    codeNoSessionMatch: '沒有匹配的會話',
    codeStatusIdle: '空閒',
    codeStatusRunning: '執行中',
    codeStatusStopped: '已停止',
    codeStatusError: '錯誤',
    codeCollapseSidebar: '收起側欄',
    codeExpandSidebar: '展開側欄',
    codeAgentWorking: '工具呼叫',
    codeThinkingProcess: '思考過程',
    codeClickExpand: '點選展開',
    codeNoOutput: '無輸出',
    codeNavSessions: '程式設計會話',
    codeNavNewSession: '新建會話',
    codeNavSkills: '技能中心',
    codeNavTasks: '定時任務',
    codeManage: '管理',
    codeManageDone: '完成',
    codePin: '置頂',
    codeUnpin: '取消置頂',
    codeRename: '重新命名',
    codeRenamePrompt: '輸入新的會話名稱',
    codeMore: '更多',
    codeSelectAll: '全選',
    codeBatchDelete: '刪除選中',
    codeBatchDeleteConfirm: '確定刪除選中的會話？此操作不可撤銷。',
    codeToastRenameFailed: '重新命名失敗',
    newChat: '新建任務',
    search: '搜尋任務',
    openSettings: '開啟設定',
    close: '關閉',
    loginNotAvailable: '登入功能暫未開放',
    collapse: '收起',
    expand: '展開',
    downloadDesktopApp: '下載桌面應用',
    downloadMac: 'macOS',
    downloadWin: 'Windows',
    downloadLinuxArm64: 'Linux ARM64',
    downloadLinuxX64: 'Linux x64',
    featureInDevelopment: '正在開發中',
    
    // 錯誤資訊
    failedToLoadSettings: '載入設定失敗',
    failedToSaveSettings: '儲存設定失敗',
    settingsSaveSuccess: '設定已儲存',
    
    // 載入狀態
    loading: '載入中...',
    
    // 側邊欄
    conversations: '對話',
    noConversations: '暫無對話',
    createNewChat: '新建對話',
    deleteConversation: '刪除對話',
    renameConversation: '重新命名',
    moveToProject: '移至專案',
    pinConversation: '置頂聊天',
    unpinConversation: '取消置頂',
    noProject: '無專案',
    noProjects: '暫無專案',
    confirmDelete: '確認刪除',
    confirmDeleteMessage: '確定要刪除這個對話嗎？此操作不可撤銷。',
    searchChats: '搜尋聊天',
    searchConversations: '搜尋任務...',
    searchNoResults: '未找到匹配任務',
    projects: '專案',
    yourChats: '你的聊天',
    createProject: '新專案',
    projectNamePlaceholder: '專案名稱',
    projectColorLabel: '顏色',
    projectIconLabel: '圖示',
    project: '專案',
    projectHistory: '歷史記錄',
    projectPrompt: '提示詞',
    projectPromptPlaceholder: '為該專案設定提示詞',
    projectSettings: '專案設定',
    projectNameLabel: '專案名稱',
    deleteProject: '刪除專案',
    confirmDeleteProject: '確定要刪除這個專案嗎？專案內聊天將移回到聊天列表。此操作不可撤銷。',
    folderIconDefault: '預設',
    folderIconHealth: '健康',
    folderIconStudy: '學習',
    folderIconMath: '數學',
    folderIconWork: '工作',
    folderIconCode: '程式碼',
    folderIconIdea: '靈感',
    
    // 聊天視窗
    sendMessage: '傳送訊息',
    typeMessage: '詢問任何問題...',
    quickPrompt: '詢問任何問題',
    regenerateResponse: '重新生成回覆',
    copyToClipboard: '複製到剪貼簿',
    coworkResultHelpful: '有幫助',
    coworkResultNotHelpful: '沒有幫助',
    coworkOpinionTitle: '這條回答你覺得哪裡不滿意',
    coworkOpinionOther: '其他',
    coworkOpinionPlaceholder: '請描述這條回答的問題（可選）',
    coworkOpinionSubmit: '提交回饋',
    coworkOpinionCancelFailed: '取消點踩失敗，請重試',
    coworkFeedbackFailed: '回饋提交失敗，請重試',
    bobotCliInstall: 'BoBot CLI (終端)',
    bobotCliMacLinux: 'macOS / Linux',
    bobotCliWindows: 'Windows (PowerShell)',
    bobotCliNpm: '通用 (npm)',
    bobotCliCopied: '已複製',
    messageCopied: '訊息已複製',
    clearConversation: '清空對話',
    confirmClearConversation: '確定要清空當前對話嗎？此操作不可撤銷。',
    today: '今天',
    yesterday: '昨天',
    daysAgo: '天前',
    justNow: '剛剛',
    minutesAgo: '分鐘前',
    hoursAgo: '小時前',
    welcomeMessage: '我能幫你做什麼呢？',
    thinking: '思考中...',
    reasoning: '思考過程',
    editMessage: '編輯訊息',
    emptyMessage: '空訊息',
    artifactOpen: '開啟',
    artifactView: '檢視',
    artifactViewing: '預覽中',
    artifactPreview: '預覽',
    artifactCode: '程式碼',
    imageLimitReached: '最多上傳 10 張圖片',
    imageReadError: '讀取圖片失敗',
    imageInputNotSupported: '當前模型不支援影像輸入',
    
    // 模型選擇
    selectModel: '選擇模型',
    
    // 錯誤提示
    errorOccurred: '發生錯誤',
    tryAgain: '請重試',
    networkError: '網路錯誤',
    apiKeyRequired: '需要設定API金鑰',
    configureApiKey: '請在設定中配置您的API金鑰',
    
    // 初始化
    initializationError: '初始化應用程式失敗。請檢查您的配置。',
    apiKeyNotConfigured: 'API金鑰未配置。請在設定中設定您的API金鑰。',
    initTitle: '初始化配置',
    initSubtitle: '請填寫 BoCoder 管理後臺地址',
    initUrlPlaceholder: 'http://192.168.1.100:9000',
    initVerifyBtn: '驗證連線',
    initVerifying: '正在驗證...',
    initSuccess: '連線成功',
    initFailed: '連線失敗，請檢查地址',
    initContinue: '繼續',

    // BoCoder
    cowork: 'BoCoder',
    coworkSandbox: '沙箱設定',
    sandboxManagement: '沙箱管理',
    coworkSettings: 'BoCoder 設定',
    coworkHistory: '歷史會話',
    coworkNoSessions: '暫無任務記錄',
    coworkPinSession: '置頂任務',
    coworkUnpinSession: '取消置頂',
    coworkSessionActions: '更多操作',
    coworkPlaceholder: '快給我安排一個任務吧！如需指定技能請在技能選項中進行選擇...',
    coworkInterruptAndSend: '目前任務結束後傳送',
    coworkQueuedSummary: '等待傳送 {count} 條',
    coworkQueuedCancel: '取消這條排隊訊息',
    coworkQueuedEdit: '編輯訊息',
    coworkQueuedSteer: '引導目前任務',
    coworkQueuedCheck: '確認狀態',
    coworkQueuedSteerUnavailable: '目前執行環境暫不支援引導，訊息將在本輪結束後傳送',
    coworkQueuedSteerAttachments: '附有檔案的訊息需在下一輪上傳後傳送，仍可編輯正文',
    coworkQueuedSteeringPending: '等待目前任務接收；未消費的訊息將在本輪結束後繼續排隊傳送',
    coworkQueuedSteeringUnknown: '送達狀態待確認，請勿重複傳送。可點擊確認狀態繼續查詢',
    coworkQueuedUpdateFailed: '操作未完成，可能已被其他頁面修改或執行狀態已變化；草稿已保留，請重試',
    coworkInterruptSystemInstruction: '【重要：使用者在你執行任務的過程中傳送了新的訊息】\n請根據上下文判斷使用者意圖：\n- 可能是對當前任務的補充說明或修正（如調整細節、追加要求），此時繼續原有目標並融入新要求\n- 也可能是要求停下當前任務、轉向做別的事情，此時按使用者新指示執行\n- 如果無法判斷使用者意圖，請先詢問確認再繼續',
    coworkWorkingDirectory: '工作目錄',
    coworkWorkingDirectoryPlaceholder: '輸入工作區路徑',
    coworkWorkingDirectoryHint: 'BoCoder 將在此目錄下執行命令',
    coworkSystemPrompt: '系統提示詞',
    coworkSystemPromptPlaceholder: '為 BoCoder 設定自定義指令...',
    coworkSystemPromptHint: '可選的系統提示詞，用於自定義 BoCoder 的行為',
    coworkLoginRequired: '請先登入賬戶使用服務。沒有賬戶可點選註冊。不登入也可前往「模型」標籤頁自定義配置。',
    coworkModelSettingsRequired: '當前沒有可用模型，請聯絡管理員配置。',
    coworkModelSettingsTitle: '模型設定',
    coworkModelSettingsHint: 'BoCoder 使用模型設定中的當前模型與提供商配置。',
    coworkModelSettingsAction: '前往模型設定',
    coworkApiConfigTitle: 'API 配置',
    coworkApiConfigHint: '支援 Anthropic 相容與 OpenAI 相容協議（OpenAI 相容通過本地轉換服務接入）。',
    coworkExecutionMode: '執行模式',
    coworkExecutionModeAuto: '自動模式',
    coworkExecutionModeLocal: '本地模式',
    coworkExecutionModeSandbox: '沙箱模式',
    coworkExecutionModeAutoHint: '自動選擇最佳執行環境，優先使用沙箱隔離執行，沙箱不可用時自動回退到本地執行。',
    coworkExecutionModeLocalHint: '所有操作直接在本機執行，適合需要訪問本地檔案和開發工具的場景。',
    coworkExecutionModeSandboxHint: '強制在隔離的虛擬機器中執行，提供最高安全性，需要已安裝沙箱元件。',
    coworkExecutionModeAutoTag: '推薦',
    coworkSandboxOnlineHint: '如需使用線上 Web 版沙箱模式，可訪問',
    coworkSandboxOnlineLinkText: 'boclaw.ai',
    coworkSandboxOnlineHintSuffix: '註冊使用。',
    coworkMemoryTitle: '記憶管理',
    coworkMemoryEnabled: '記憶功能',
    coworkMemoryEnabledHint: '開啟後，AI 會自動記住你的偏好和關鍵資訊，讓對話更懂你。',
    coworkMemorySimpleHint: '你可以在下方手動管理記憶條目，也可以在對話中讓 AI 自動學習。',
    coworkMemoryAutoWrite: '自動寫入記憶',
    coworkMemoryCaptureEachTurn: '啟用隱式更新',
    coworkMemoryCaptureEachTurnHint: '開啟後，每輪對話結束時自動呼叫 AI 提取值得長期記住的內容（會產生少量額外呼叫）。',
    coworkMemoryGuardLevel: '寫入門檻',
    coworkMemoryGuardStrict: '嚴格',
    coworkMemoryGuardStandard: '標準',
    coworkMemoryGuardRelaxed: '寬鬆',
    coworkMemoryMaxResults: '注入條目上限',
    coworkMemoryMaxResultsHint: '可選範圍 1-60，建議 12',
    coworkMemoryMinScore: '最小相關性閾值',
    coworkMemoryMaxInjectChars: '最大注入字元數',
    coworkMemoryRecallInterval: '自動回憶間隔（輪）',
    coworkMemoryRecallIntervalHint: '每 N 輪自動注入一次記憶，建議 3',
    coworkMemoryCrudTitle: '記憶條目管理',
    coworkMemoryManageHint: '你可以在這裡檢視、搜尋、新增、編輯或刪除記憶內容。',
    coworkMemoryTotalLabel: '記憶總數',
    coworkMemoryActiveLabel: '生效中',
    coworkMemoryInactiveLabel: '暫不使用',
    coworkMemoryStatusActive: '生效中',
    coworkMemoryStatusInactive: '暫不使用',
    coworkMemoryStatusDeleted: '已刪除',
    coworkMemoryUpdatedAt: '最後更新',
    coworkMemoryEditingTag: '正在編輯當前記憶',
    coworkMemoryRebuildIndex: '重建索引',
    coworkMemoryRebuildSuccess: '記憶索引重建完成',
    coworkMemoryRebuildFailed: '記憶索引重建失敗',
    coworkMemoryStatsSummary: '已管理條目數',
    coworkMemorySearchPlaceholder: '搜尋記憶標題/內容',
    coworkMemoryCategoryAll: '全部分類',
    coworkMemoryEmpty: '暫無記憶條目',
    coworkMemoryCrudTextPlaceholder: '輸入要儲存的記憶內容',
    coworkMemoryCrudCreate: '新增記憶',
    coworkMemoryCrudUpdate: '更新記憶',
    coworkMemoryCrudSaveFailed: '儲存記憶條目失敗',
    coworkMemoryCrudDeleteFailed: '刪除記憶條目失敗',
    coworkMemoryAdvancedShow: '顯示進階設定',
    coworkMemoryAdvancedHide: '隱藏進階設定',
    coworkMemoryEmbeddingEnabled: '啟用本地 embedding 重排',
    coworkMemoryEmbeddingEnabledHint: '在詞法檢索基礎上用本地向量相似度重排結果，提升召回質量',
    coworkMemoryEmbeddingModel: 'Embedding 模型',
    coworkMemoryEmbeddingModelHint: '推薦 BAAI/bge-m3；可改為你已下載的其他 sentence-transformers 模型',
    coworkMemoryEmbeddingLocalModelPath: '本地模型目錄（可選）',
    coworkMemoryEmbeddingLocalModelPathHint: '填寫後優先載入本地目錄；留空時按模型名載入',
    coworkMemoryEmbeddingAutoDownload: '允許自動下載模型',
    coworkMemoryEmbeddingAutoDownloadHint: '關閉後必須提供本地模型目錄',
    coworkMemoryEmbeddingDownload: '下載 / 校驗模型',
    coworkMemoryEmbeddingDownloading: '下載中...',
    coworkMemoryEmbeddingDownloadHint: '手動觸發模型下載（或校驗本地模型目錄），下載過程可能較慢，請等待進度完成',
    coworkMemoryEmbeddingDownloadSuccess: 'Embedding 模型已就緒',
    coworkMemoryEmbeddingDownloadFailed: 'Embedding 模型下載失敗',
    coworkMemoryEmbeddingProgressPreparing: '準備下載任務',
    coworkMemoryEmbeddingProgressInit: '初始化環境',
    coworkMemoryEmbeddingProgressDownload: '下載模型檔案',
    coworkMemoryEmbeddingProgressLoad: '載入模型',
    coworkMemoryEmbeddingProgressEncode: '模型預熱',
    coworkMemoryEmbeddingProgressDone: '完成',
    coworkMemoryEmbeddingProgressError: '失敗',
    coworkMemoryEmbeddingWeight: '語義重排權重',
    coworkMemoryEmbeddingWeightHint: '範圍 0-1，值越大越依賴 embedding 相似度，建議 0.62',
    coworkSandboxProfileRequired: '請先選擇沙箱環境。',
    coworkSandboxImageRequired: '請先選擇沙箱映象。',
    sandboxEnvVars: '自定義環境變數',
    sandboxEnvVarsHint: '注入到沙箱虛擬機器中的環境變數，可用於配置 API 金鑰、代理地址等。AI 執行的指令碼和工具可以讀取這些變數。',
    sandboxEnvVarsAdd: '新增變數',
    sandboxEnvVarsKeyPlaceholder: '變數名',
    sandboxEnvVarsValuePlaceholder: '變數值',
    coworkSandboxBadge: '沙箱',
    modelContextWindow: '上下文窗口',
    coworkContextUsage: '上下文用量',
    coworkContextCompacting: '壓縮中',
    coworkContextPending: '待更新',
    coworkContextUnknown: '未知',
    coworkUncachedInput: '非快取輸入',
    coworkCacheWrite: '快取寫入',
    coworkCacheRead: '快取讀取',
    coworkSourceDesktop: '桌面端',
    coworkSourceApp: 'App 遠端',
    relaySendCloud: '發起會話',
    relaySendCloudDesc: '在雲端沙箱中執行',
    relayNoDesktopOnline: '暫無線上桌面客戶端',
    relayDesktopOffline: '目標桌面客戶端已離線',
    coworkViewSandboxDesktop: '檢視沙箱桌面',
    coworkSandboxDesktopTitle: '沙箱桌面檢視',
    coworkSandboxDesktopEnlarge: '放大為浮窗',
    coworkSandboxDesktopOpenInTab: '新標籤頁開啟',
    coworkSandboxDesktopConnecting: '正在連線沙箱桌面...',
    sandboxPreview: '沙箱預覽',
    coworkTerminalTitle: '終端',
    coworkTerminalConnecting: '正在連線終端...',
    coworkTerminalDisconnected: '終端已斷開',
    coworkTerminalNotRunning: '會話未執行，無法連線終端',
    coworkTerminalOpenFailed: '終端連線失敗，請點擊重新連線；若仍失敗，請檢查沙箱終端服務。',
    coworkTerminalClear: '清空',
    coworkTerminalReconnect: '重新連線',
    coworkTerminalResizeHint: '拖動調整終端寬度',
    coworkDeliverablesTitle: '交付物',
    coworkDeliverablesEmpty: '暫無交付物...',
    coworkDeliverablesSummary: '摘要',
    coworkDeliverablesFiles: '產出檔案',
    coworkDeliverablesUploadedFiles: '上傳檔案',
    coworkDeliverablesGeneratedFiles: '生成檔案',
    coworkDeliverablesPreview: '預覽',
    coworkDeliverablesDownload: '下載',
    coworkDeliverablesNoPreview: '暫不支援預覽',
    coworkDeliverableDownloadFailed: '下載失敗：沙箱可能已停止，或該檔案已不可讀。繼續工作階段後重試。',
    coworkDeliverableSandboxPaused: '沙箱閒置已暫停回收，檔案仍在但暫不可讀。傳送任意訊息繼續本工作階段即可恢復檔案存取。',
    coworkDeliverablesFilterAll: '全部',
    coworkDeliverablesFilterDoc: '文件',
    coworkDeliverablesFilterCode: '程式碼',
    coworkDeliverablesFilterData: '資料',
    coworkDeliverablesFilterImage: '圖片',
    coworkDeliverablesFilterOther: '其他',
    coworkDeliverablesFilterEmpty: '該分類下暫無檔案',
    // Sandbox profiles
    sandboxProfiles: '沙箱配置',
    sandboxProfilesAdd: '新增沙箱',
    sandboxProfileName: '沙箱名稱',
    sandboxProfileNamePlaceholder: '例如：团队 CubeSandbox',
    sandboxProfileDelete: '刪除',
    sandboxProfileEdit: '編輯',
    sandboxProfileDeleteConfirm: '確認刪除該沙箱配置？',
    sandboxSelectorTitle: '選擇沙箱',
    sandboxSelectLocal: '本地執行',
    sandboxManage: '管理沙箱...',
    sandboxProfileSelectTitle: '選擇執行環境',
    sandboxEnvUnavailable: '環境不可用（範本已刪除或停用）',
    sandboxImageSelectTitle: '選擇沙箱',
    sandboxImageNameLabel: '映像名稱',
    sandboxImageArchitectureLabel: '架構',
    sandboxImageRuntimeLabel: '執行階段',
    sandboxImageResourcesLabel: '資源',
    envSelectorCloudSandbox: '雲端沙箱',
    envSelectorDesktopClient: '桌面客戶端',
    executionEnvLabel: '執行環境',
    scheduledTasksDesktopEnvTitle: '該桌面客戶端不支援在網頁端查看定時任務',
    scheduledTasksDesktopEnvHint: '{device} 的客戶端版本沒有定時任務通道，請升級桌面客戶端後重試。也可以切回「雲端沙箱」查看雲端定時任務。',
    scheduledTasksDesktopEnvBanner: '這些定時任務儲存在 {device} 上，由該裝置自己的排程器執行。可以在這裡啟停、刪除、立即執行與查看歷史；新增與編輯請在桌面客戶端裡操作。',
    scheduledTasksDesktopCreateUnsupported: '桌面客戶端的定時任務需要工作目錄等本機設定，請在桌面客戶端裡新增或編輯。',
    executionEnvUnset: '未選擇執行環境',
    scheduledTasksFormValidationEnvRequired: '請選擇執行環境；原本綁定的沙箱範本可能已被停用或刪除',
    refreshDesktopSessions: '重新整理桌面會話',
    desktopSessionsRefreshed: '桌面會話已重新整理',
    desktopSessionsRefreshFailed: '重新整理失敗，請檢查桌面端是否線上',
    sandboxImageCores: '核',
    sandboxProfileEmpty: '暫無可用沙箱環境，請聯絡管理員配置',
    sandboxImageEmpty: '暫無可用沙箱映象，請聯絡管理員配置',
    sandboxProfileSave: '儲存',
    sandboxProfileCancel: '取消',
    coworkLocalBadge: '本地',
    coworkApiProviderModel: '從模型設定選擇',
    coworkApiProviderModelCustom: '自定義',
    coworkApiProviderModelHint: '僅顯示已啟用且已配置 API Key/地址的模型',
    coworkApiBaseUrl: 'API 基礎地址',
    coworkApiKey: 'API Key',
    coworkApiModel: '模型名稱',
    coworkApiKeyRequired: '需要填寫 API Key',
    coworkApiBaseUrlRequired: '需要填寫 API 地址',
    coworkApiModelRequired: '需要填寫模型名稱',
    coworkApiBaseUrlInvalid: 'API 地址格式無效',
    coworkApiConfigSaveFailed: '儲存 API 配置失敗',
    coworkApiConfigLoadFailed: '載入 API 配置失敗',
    coworkStatusIdle: '已停止',
    coworkStatusRunning: '執行中',
    coworkThinking: '思考中',
    coworkActivityAwaitingModel: '正在等待模型開始回覆',
    coworkStatusCompleted: '已完成',
    turnStatus_completed: '已完成',
    turnStatus_incomplete: '部分完成',
    turnStatus_failed: '失敗',
    turnStatus_stopped: '已停止',
    turnStatus_interrupted: '已中斷',
    turnDuration: '用時',
    showThinkingProcess: '顯示思考過程',
    secretaryPreference_warmHint: '友善耐心，不堆客套',
    secretaryPreference_conciseHint: '先給結論，減少鋪墊',
    secretaryPreference_naturalHint: '像熟悉的長期夥伴',
    secretaryPreference_briefHint: '只說最關鍵內容',
    secretaryPreference_balancedHint: '結論、依據和下一步',
    secretaryPreference_detailedHint: '補充背景、風險和步驟',
    secretaryPreference_noneHint: '不主動使用幽默',
    secretaryPreference_lightHint: '輕微幽默，不影響專業',
    secretaryPreference_playfulHint: '非嚴肅場景更輕鬆',
    secretaryPreference_responsiveHint: '聚焦目前問題',
    secretaryPreference_moderateHint: '提醒遺漏、風險和下一步',
    secretaryPreference_proactiveHint: '主動給關聯建議和待辦',
    secretaryPreference_avatar: '頭像配色',
    secretaryPreference_blue: '藍色',
    secretaryPreference_violet: '紫色',
    secretaryPreference_teal: '青色',
    secretaryPreference_amber: '琥珀色',
    secretaryPreference_rose: '玫瑰色',
    secretaryPreference_loading: '正在讀取秘書設定…',
    conversationHistory: '提問導覽',
    secretaryPreference_title: '秘書身分與表達偏好',
    secretaryPreference_hint: '與下方自由 Soul 獨立儲存。儲存後從下一輪秘書對話生效，不打斷正在執行的輪次。恢復 Soul 預設不會清除這些設定。',
    secretaryPreference_error: '讀取或儲存失敗，請重新開啟設定重試。',
    secretaryPreference_saved: '已儲存',
    secretaryPreference_saveIdentity: '儲存身分與稱呼',
    secretaryPreference_saveStyle: '儲存表達偏好',
    secretaryPreference_assistantDisplayName: '秘書名稱',
    secretaryPreference_preferredUserName: '如何稱呼你',
    secretaryPreference_workDomain: '工作領域',
    secretaryPreference_assistantIntroduction: '秘書介紹',
    secretaryPreference_speechStyle: '說話方式',
    secretaryPreference_responseDetail: '回答詳略',
    secretaryPreference_humorLevel: '幽默程度',
    secretaryPreference_initiativeLevel: '主動程度',
    secretaryPreference_warm: '溫和專業',
    secretaryPreference_concise: '幹練直接',
    secretaryPreference_natural: '輕鬆自然',
    secretaryPreference_brief: '簡短',
    secretaryPreference_balanced: '適中',
    secretaryPreference_detailed: '詳細',
    secretaryPreference_none: '不使用',
    secretaryPreference_light: '輕微',
    secretaryPreference_playful: '活潑',
    secretaryPreference_responsive: '回應為主',
    secretaryPreference_moderate: '適度提醒',
    secretaryPreference_proactive: '主動建議',
    conversationLatest: '回到最新',
    conversationSearch: '工作階段內搜尋',
    conversationSearchHint: '搜尋內容；留空查看提問目錄',
    conversationPrevious: '上一處',
    conversationNext: '下一處',
    creditSessionUsage: '工作階段積分',
    creditTurnUsage: '本輪積分',
    creditLatestTurnUsage: '最近一輪積分',
    coworkCloudPermissionTitle: '沙箱內自動執行',
    coworkCloudPermissionHint: '工具在雲端沙箱內自動執行，互動提問仍會等待回答。目前雲端範本不支援切換桌面權限模式；桌面任務使用客戶端的權限設定。',
    creditTurnSimulated: '本輪模擬費用',
    creditSessionSimulated: '會話累計模擬費用',
    creditTurnConsumed: '本輪共消耗',
    creditSessionTotal: '會話累計',
    creditPendingSettlement: '待確認',
    creditTurnBreakdownUnavailable: '暫無分輪明細',
    creditTurnBreakdownUnavailableHint: '平台未回傳分輪明細，請參考會話累計消耗。',
    creditShadowShort: '影子計費',
    creditStaleShort: '資料待重新整理',
    creditRecordedUsageHint: '已入帳費用；後續結算可能更新。無法歸屬的歷史費用僅計入工作階段總額。',
    creditFree: '免費',
    creditPerCall: '積分/次',
    creditInput: '輸入',
    creditOutput: '輸出',
    creditPer1k: '積分/1K token',
    creditMeterPrices: '工具與沙箱價目',
    creditMetersEmpty: '暫無公開價目，不代表免費。',
    creditMeterConfirmation: '使用前確認',
    connectorEditFailed: '讀取或修改連接器失敗，請重新整理後重試。',
    connectorToolsTitle: '檢查工具',
    connectorToolsHint: '連線目前授權的 MCP 並讀取工具清單，不執行工具或發起業務呼叫。',
    connectorToolsLoading: '正在連線並發現工具…',
    connectorToolsUnavailable: '未發現可用工具，請檢查服務位址、連線授權後重試。',
    connectorToolsRetry: '重新檢查',
    connectorEdit: '編輯',
    connectorDelete: '刪除',
    connectorAdd: '新增',
    connectorDeleteConfirm: '確認刪除此自訂連接器及其授權？',
    connectorEditTokenHint: '權杖不會回顯。地址不變時留空保留舊權杖；更換地址請重新填寫，留空將清除舊權杖。',
    subscriptionHistory: '訂單記錄',
    subscriptionAddons: '加購積分',
    subscriptionAddonEmpty: '暫無可加購套餐或可用支付管道。',
    subscriptionHistoryEmpty: '暫無訂單',
    subscriptionPrevious: '上一頁',
    subscriptionNext: '下一頁',
    subscriptionWechat: '微信支付',
    subscriptionAlipay: '支付寶',
    subscriptionPayLink: '開啟付款頁面',
    subscriptionRefresh: '重新整理狀態',
    subscriptionDays: '天',
    subscriptionCredits: '積分',
    subscriptionCnyOnly: '目前付款入口僅支援人民幣套餐。',
    subscriptionResumeMissing: '重新整理後無法恢復此付款碼，請先在支付應用確認結果並重新整理訂單狀態，再進行購買。',
    subscriptionTitle: '套餐購買',
    subscriptionDuration: '套餐有效期',
    subscriptionDuration_year: '年', subscriptionDuration_month: '月', subscriptionDuration_day: '天', subscriptionDuration_hour: '小時',
    subscriptionUnavailable: '套餐或訂單暫不可用，請稍後返回重試。',
    subscriptionLoading: '正在讀取套餐…',
    subscriptionEmpty: '暫無可購買套餐',
    subscriptionBase: '基礎積分',
    subscriptionBonus: '贈送積分',
    subscriptionBuy: '購買並產生付款碼',
    subscriptionViewOrder: '查看訂單',
    subscriptionOrder: '訂單號',
    subscriptionAmount: '付款金額',
    subscriptionSuccess: '平台已確認支付，正在重新整理積分',
    subscriptionPending: '等待掃碼付款，狀態由平台確認',
    subscriptionExpired: '訂單已過期',
    subscriptionUnknown: '請到平台核對訂單狀態',
    subscriptionExpires: '付款碼到期時間',
    subscriptionClose: '收起（不取消訂單）',

    coworkStatusError: '錯誤',
    coworkPermissionRequired: '需要許可權確認',
    coworkPermissionDescription: 'BoCoder 請求執行以下操作',
    coworkToolName: '工具名稱',
    coworkToolInput: '工具引數',
    coworkToolResult: '執行結果',
    coworkToolRunning: '執行中',
    coworkDocumentExtractStop: '停止',
    coworkExecutionProcess: '執行過程',
    coworkToolSequenceCount: '{count} 次操作',
    coworkToolActionSearch: '搜尋',
    coworkToolActionView: '檢視',
    coworkToolActionRun: '執行',
    coworkToolActionRead: '讀取',
    coworkToolActionWrite: '寫入',
    coworkToolActionEdit: '編輯',
    coworkToolActionFind: '查詢',
    coworkToolActionDelegate: '處理',
    coworkToolActionPlan: '更新執行計劃',
    coworkToolActionSkill: '載入技能',
    coworkTodosTitle: 'Todos',
    coworkTodoItems: '項',
    coworkTodoCompleted: '已完成',
    coworkTodoInProgress: '進行中',
    coworkTodoPending: '待處理',
    coworkTodoUntitled: '未命名待辦',
    coworkTodoUnknownStatus: '未知狀態',
    coworkTodoPanelTitle: '執行計劃',
    coworkTodoPanelProgress: '進度',
    coworkTodoPanelAllDone: '所有任務已完成',
    coworkDangerousOperation: '警告：此操作可能會修改檔案或執行系統命令，請仔細檢查。',
    coworkApprove: '允許',
    coworkDeny: '拒絕',
    coworkConfirmSelection: '提交當前選擇',
    coworkDenyRequest: '直接拒絕請求',
    coworkPauseTimer: '暫停',
    coworkResumeTimer: '繼續',
    coworkQuestionWizardTitle: '需要您的確認',
    coworkQuestionWizardSkip: '跳過',
    coworkQuestionWizardPrevious: '上一個',
    coworkQuestionWizardNext: '下一個',
    coworkQuestionWizardSubmit: '提交',
    coworkQuestionWizardOther: '其他',
    coworkQuestionWizardOtherPlaceholder: '請輸入自定義答案...',
    coworkQuestionWizardSelectAtLeastOne: '請至少選擇一個選項',
    coworkQuestionWizardAnswerRequired: '請選擇或輸入答案',
    coworkWelcome: '你好，我是{orgCode}',
    coworkDescription: '{orgName}智慧體{orgCode}可以幫你處理文件、操作裝置、深度研究，做你 7×24 小時的 AI 助力',
    coworkSkillsHint: '更多技能可在技能中心線上安裝',
    coworkNewSession: '新會話',
    coworkContinuePlaceholder: '繼續對話...',
    updateAvailablePill: '有新版本',
    updateAvailableTitle: '檢測到新版本',
    updateAvailableMessage: '檢測到新版本，請前往官網下載並覆蓋安裝。',
    updateAvailableConfirm: '好',
    updateAvailableCancel: '取消',
    updateOpenFailed: '開啟下載頁面失敗',
    checkForUpdates: '檢測更新',
    checkingForUpdates: '正在檢測...',
    upToDate: '已是最新版本',
    downloadUpdate: '下載更新',
    currentVersionPrefix: '當前版本',
    coworkStartingSession: '正在啟動會話...',
    coworkPreparingEnvironment: '準備環境中，請稍候',
    coworkAddFile: '新增檔案',
    coworkDropFileHint: '拖拽檔案到此處，或直接貼上檔案',
    coworkAddImage: '新增圖片',
    coworkInputFileLabel: '輸入檔案',
    coworkAttachmentRemove: '移除',
    coworkFile: '檔案',
    coworkShareSession: '分享',
    coworkExportImageInProgress: '正在匯出圖片...',
    coworkExportImageSuccess: '圖片匯出成功',
    coworkExportImageFailed: '匯出圖片失敗',
    coworkExportImageTooLarge: '對話過長，無法完整匯出為一張圖片；請減少內容後重試。',
    coworkExportImageResourceFailed: '圖片或字體未能載入，未產生不完整的匯出；請稍後重試。',
    deleteSession: '刪除任務',
    batchManage: '管理',
    batchDone: '完成',
    batchSelectAll: '全選',
    batchDeselectAll: '取消全選',
    batchDelete: '刪除',
    batchDeleteConfirmTitle: '確認批次刪除',
    batchDeleteConfirmMessage: '此操作無法撤銷，選中的 {count} 個任務及其所有訊息記錄將被永久刪除。',
    deleteTaskConfirmTitle: '確認刪除任務',
    deleteTaskConfirmMessage: '此操作無法撤銷，任務的所有訊息記錄將被永久刪除。',
    back: '返回',
    browse: '瀏覽',
    addFolder: '新增資料夾',
    recentFolders: '最近使用',
    noFolderSelected: '未選擇資料夾',
    coworkSelectFolderFirst: '請選擇任務目錄後再提交',
    noRecentFolders: '暫無最近資料夾',
    coworkOpenFolder: '開啟資料夾',

    // Skills
    appSettings: '應用設定',
    skills: '技能中心',
    searchSkills: '搜尋技能',
    manageSkills: '管理技能',
    officialSkills: '官方技能',
    addSkill: '新增',
    uploadSkillZip: '上傳 .zip',
    uploadSkillFolder: '上傳資料夾',
    skillImportPackaging: '正在打包 {source}',
    skillImportUploading: '正在上傳 {source}',
    skillImportValidating: '正在驗證 {source}',
    skillImportExtracting: '正在解壓 {source}',
    skillImportDiscovering: '正在尋找 {source} 中的技能',
    skillImportInstalling: '正在匯入 {source}：已處理 {processed}/{total}，成功 {installed}',
    skillImportProgressLabel: '技能匯入進度',
    skillDuplicatesConfirm: '以下技能已存在',
    skillSkipDuplicates: '略過重複項',
    skillOverwriteDuplicates: '覆蓋全部',
    skillFolderUploadResult: '資料夾上傳完成：成功 {installed}，略過 {skipped}，失敗 {failed}',
    skillBatchUploadResult: '批次上傳完成：成功 {installed}，略過 {skipped}，失敗 {failed}',
    skillImportMissingManifest: '找不到 SKILL.md',
    skillImportPackageTooLarge: '技能包超過大小或檔案數量限制',
    skillImportTooManyFiles: '技能包檔案數量超過限制',
    skillImportUnsafeSource: '技能包包含不安全的路徑或連結',
    skillImportFailed: '技能匯入失敗',
    importFromGithub: '從 GitHub 匯入',
    githubImportTitle: '從 GitHub 匯入',
    githubImportDescription: '支援倉庫連結與子目錄連結；若倉庫內有多個技能，將自動全部匯入。',
    githubImportUrlLabel: 'URL',
    githubSkillPlaceholder: '例如：owner/repo 或 GitHub tree/blob 連結',
    githubImportExamples: '示例：owner/repo；https://github.com/owner/repo/tree/main/SKILLs/my-skill',
    importSkill: '匯入',
    importingSkill: '匯入中...',
    official: '官方',
    noSkillsAvailable: '暫無可用技能',
    skillsDescription: '為您的智慧體提供預封裝且可重複的最佳實踐與工具',
    allCategories: '全部',
    uncategorized: '其他',
    categoryDocuments: '文件處理',
    categorySearch: '搜尋資訊',
    categoryDesign: '設計創作',
    categoryTools: '效率工具',
    categoryWriting: '寫作助手',
    categoryDev: '開發整合',
    categoryWebAutomation: '網頁自動化',
    categoryCommunication: '通訊協作',
    categorySystem: '系統增強',
    skillsOnlineNoResults: '未找到符合的社區技能',
    skillDetailsOpen: '查看技能詳細資料',
    skillsFeaturedDetailTryAsking: '試試這樣問我',
    skillsFeaturedDetailOutputArtifacts: '預期產物',
    skillsFeaturedDetailPreviewHint: '安裝並啟用後，可將範例提問帶入對話草稿。',
    skillsFeaturedDetailUseSkill: '使用該技能',
    skillsFeaturedDetailFallbackQuestion1: '請介紹一下「{name}」最適合處理哪些任務，並給我一個開始步驟。',
    skillsFeaturedDetailFallbackQuestion2: '請使用「{name}」分析我接下來提供的資料，並指出還需要補充的資訊。',
    skillsFeaturedDetailFallbackQuestion3: '請用「{name}」給我一個可直接執行的處理方案。',
    skillsFeaturedDetailDraftHint: '選擇後進入新對話草稿，保留已有草稿和附件；請確認內容後傳送。',
    skillLaunchUnavailable: '技能已停用、刪除或登入狀態已變化，請重新整理後重試。',
    skillDetailsDescription: '技能介紹',
    skillDetailsCategory: '分類',
    skillDetailsUpdated: '更新時間',
    skillDetailsLocation: '儲存位置',
    skillDetailsBuiltIn: '內建',
    skillDetailsLocal: '本機技能',
    scenarioSkillPrepareTitle: '本場景需要以下技能',
    scenarioSkillPrepareDesc: '這些技能尚未就緒。安裝／啟用後場景才能完整發揮作用。',
    scenarioSkillPrepareInstall: '安裝並進入',
    scenarioSkillPrepareEnable: '啟用並進入',
    scenarioSkillPrepareCancel: '取消',
    scenarioSkillPrepareInstalling: '安裝中…',
    scenarioSkillPrepareRetry: '重試',
    scenarioSkillPrepareSkip: '略過並進入',
    scenarioSkillPrepareFailedHint: '部分技能未安裝成功。可以重試，也可以直接進入——未安裝的技能這次不會生效。',
    scenarioSkillPrepareContinue: '知道了，繼續進入',
    scenarioSkillStateReady: '已就緒',
    scenarioSkillStateMissing: '未安裝',
    scenarioSkillStateDisabled: '已停用',
    scenarioSkillStateUnavailable: '平台已下架',
    scenarioSkillStateFailed: '安裝失敗',
    coworkPromptModeLabel: '會話模式',
    coworkMoreTools: '更多工具',
    coworkInputShortcutHint: 'Enter 傳送 · {shortcut} 換行',
    coworkDraftSendFailed: '訊息傳送失敗，草稿已保留。',
    coworkDraftAttachmentsLost: '重新整理前未儲存的附件無法恢復，請重新新增。',
    coworkCopyLink: '複製會話連結',
    coworkLinkCopied: '會話連結已複製',
    coworkLinkCopyFailed: '複製失敗，請檢查剪貼簿權限。',
    coworkAiDisclaimer: '內容由 AI 生成，請仔細甄別',
    coworkPromptModeCollab: '協作',
    coworkPromptModeQuick: '快速',
    coworkPromptModeChat: '對話',
    coworkPromptModeWork: '工作',
    coworkPromptModeCollabHint: '完整 Agent：載入工具、技能與沙箱執行',
    coworkPromptModeSwitchBusy: '執行中的會話不能切換模式，請先停止',
    coworkPromptModeQuickHint: '輕量對話：僅攜帶記憶，不載入工具與技能，不啟動沙箱，回應更快',
    coworkPromptModeSwitchToQuick: '切換到快速對話（不啟動沙箱）',
    coworkPromptModeSwitchToCollab: '切換到協作（啟動沙箱，可用工具與技能）',
    coworkPromptModeSwitchFailed: '切換會話模式失敗',
    coworkPromptModeLocked: '任務建立後不可變更對話模式',
    coworkQuickPlaceholder: '有什麼想聊的？直接告訴我...',
    coworkToolScenario: '場景',
    secretaryEntry: 'BoMate',
    scenariosNoResults: '沒有符合的場景',
    scenariosAuthFailed: '平台登入狀態已失效',
    scenariosAuthFailedHint: '請登出後重新登入，即可載入你的場景應用',
    scenariosFeaturedTitle: '精選場景',
    scenariosBrowseTitle: '全部場景',
    scenariosHotBadge: '熱門',
    scenariosRecommendedBadge: '推薦',
    secretaryMemoryTitle: 'BoMate 長期記憶',
    secretaryMemoryActive: '活躍',
    secretaryMemoryArchived: '已封存',
    secretaryMemoryIndexUsage: '索引',
    secretaryMemoryLastDream: '上次整理',
    secretaryMemorySearchPlaceholder: '搜尋長期記憶...',
    secretaryMemoryEmpty: '還沒有長期記憶 —— 和 BoMate 聊過之後會自動累積',
    secretaryMemoryForget: '忘記',
    secretarySoulEdit: '人格設定',
    secretarySoulHint: '定義 BoMate 的身份與互動方式（不儲存業務事實）。儲存後新會話生效。',
    secretarySoulReset: '恢復預設',
    secretarySoulSavedToast: '人格設定已儲存',
    setCategory: '設定分類',
    clearCategory: '清除分類',
    skillsRoot: '技能目錄',
    skillSourcePlaceholder: 'Git URL 或本地路徑',
    downloadSkill: '下載技能',
    downloadingSkill: '正在下載...',
    deleteSkill: '刪除技能',
    skillEditTags: '編輯標籤',
    skillNewTagPlaceholder: '新增標籤',
    skillAddTag: '新增',
    skillDeleteConfirm: '確定刪除技能“{name}”嗎？',
    skillDeleteFailed: '刪除技能失敗',
    skillBuiltInCannotDelete: '系統精選技能不允許刪除',
    skillDownloadFailed: '下載技能失敗',
    skillUpdateFailed: '更新技能失敗',
    activeSkill: '當前技能',
    clearSkill: '清除技能',
    clearAll: '全部清除',
    clearAllSkills: '清除所有已選技能',
    skillsLocalTab: '本地技能',
    skillsFeaturedTab: '精選技能',
    skillsOnlineTab: '社群技能',
    skillsPersonalTab: '個人技能',
    skillsBuiltinTab: '系統精選',
    skillsCommunityTab: '社群技能',
    skillsFeaturedSubtitle: '官方精選優質技能，一鍵安裝即刻體驗',
    skillsFeaturedSearch: '搜尋精選技能...',
    skillsFeaturedEmpty: '暫無精選技能',
    skillsFeaturedError: '載入失敗，請稍後重試',
    skillsFeaturedSource: '以下列表來自 ',
    skillsFeaturedSourceSuffix: ' 精選推薦',
    skillsOnlineSubtitle: '探索社群精選技能，一鍵安裝擴充套件 BoCoder 能力',
    skillsOnlineSearch: '搜尋技能名稱或描述...',
    skillsOnlineInstall: '安裝',
    skillsOnlineInstalling: '安裝中...',
    skillsOnlineInstalled: '已安裝',
    skillsOnlineLoadMore: '載入更多',
    skillsOnlineEmpty: '暫無線上技能',
    skillsOnlineError: '載入失敗，請稍後重試',
    skillsOnlineSource: '以下列表來自 ',
    skillsOnlineSourceSuffix: ' 技能商店',
    skillsOnlineSortDownloads: '下載量',
    skillsOnlineSortStars: '收藏數',
    skillsOnlineSortUpdated: '最近更新',

    // 郵箱技能配置
    emailTab: '郵箱',
    emailConfig: '郵箱配置',
    emailConfigHint: '該功能需安裝 Email 技能進行使用',
    emailProvider: '郵箱服務商',
    emailSelectProvider: '請選擇郵箱服務商',
    emailCustomProvider: '自定義',
    emailAddress: '郵箱地址',
    emailPassword: '密碼 / 授權碼',
    emailPasswordPlaceholder: '密碼或應用專用密碼',
    emailAdvancedSettings: '進階設定',
    emailMailbox: '預設收件箱',
    emailConfigSaved: '郵箱配置已儲存',
    emailConfigError: '儲存配置失敗',
    emailHintGmail: '如果開啟了兩步驗證，請使用應用專用密碼（App Password）',
    emailHint163: '請使用授權碼，而非賬戶密碼。需先在網頁端設定中開啟 IMAP/SMTP 服務',
    emailHintQQ: '請使用授權碼，而非賬戶密碼。需先在網頁端設定中開啟 IMAP/SMTP 服務',

    // 檔案操作
    openFile: '開啟檔案',
    openFolder: '開啟資料夾',
    showInFolder: '在資料夾中顯示',
    outputFiles: '輸出檔案',
    openFileFailed: '開啟檔案失敗',
    fileCreated: '檔案已建立',

    // IM Bot
    imBot: 'IM 工具',
    dingtalk: '釘釘',
    feishu: '飛書',
    telegram: 'Telegram',
    discord: 'Discord',
    wechatwork: '企業微信',
    connected: '已連線',
    disconnected: '未連線',
    starting: '啟動中',
    imConfigGuide: '配置教程',
    imToggleNeedTest: '請先填寫配置並測試連線通過後再啟用',
    start: '啟動',
    stop: '停止',
    messageType: '訊息型別',
    domain: '域名',
    feishuChina: '飛書（中國）',
    renderMode: '渲染模式',
    textMode: '文本',
    cardMode: '卡片',
    chatSettings: '對話設定',
    enableSkills: '啟用技能',
    systemPrompt: '系統提示詞',
    systemPromptPlaceholder: '為 IM 機器人設定自定義指令...',
    saveConfig: '儲存配置',
    imConnectivitySectionTitle: '連線診斷',
    imConnectivityTest: '測試連線',
    imConnectivityRetest: '重新測試',
    imConnectivityTesting: '測試中...',
    imConnectivityNoResult: '尚未執行診斷。建議啟用後立即測試。',
    imConnectivityLastChecked: '最近測試',
    imConnectivitySuggestion: '建議',
    imConnectivityVerdict_pass: '可對話',
    imConnectivityVerdict_warn: '需關注',
    imConnectivityVerdict_fail: '不可用',
    imConnectivityCheckTitle_missing_credentials: '配置項缺失',
    imConnectivityCheckTitle_auth_check: '憑證鑑權',
    imConnectivityCheckTitle_gateway_running: 'IM 渠道啟用狀態',
    imConnectivityCheckTitle_inbound_activity: '入站訊息活動',
    imConnectivityCheckTitle_outbound_activity: '出站訊息活動',
    imConnectivityCheckTitle_platform_last_error: '平臺最近錯誤',
    imConnectivityCheckTitle_feishu_group_requires_mention: '飛書群聊觸發規則',
    imConnectivityCheckTitle_feishu_event_subscription_required: '飛書事件訂閱要求',
    imConnectivityCheckTitle_discord_group_requires_mention: 'Discord 群聊觸發規則',
    imConnectivityCheckTitle_telegram_privacy_mode_hint: 'Telegram Privacy Mode',
    imConnectivityCheckTitle_dingtalk_bot_membership_hint: '釘釘會話許可權',
    imConnectivityCheckTitle_wechatwork_http_callback_hint: '企業微信回撥配置',
    imConnectivityCheckSuggestion_missing_credentials: '補全必填配置項後重試。',
    imConnectivityCheckSuggestion_auth_check: '核對平臺憑證、應用許可權和釋出狀態。',
    imConnectivityCheckSuggestion_gateway_running: '若顯示未啟用，請點選對應 IM 渠道膠囊按鈕啟用；啟用後確認網路可訪問平臺服務。',
    imConnectivityCheckSuggestion_inbound_activity: '向機器人發一條測試訊息；群聊場景請 @機器人。',
    imConnectivityCheckSuggestion_outbound_activity: '檢查機器人發訊息許可權、可見範圍和會話回包許可權。',
    imConnectivityCheckSuggestion_platform_last_error: '根據錯誤提示修復後再重測。',
    imConnectivityCheckSuggestion_feishu_group_requires_mention: '在群聊中使用 @機器人 + 內容。',
    imConnectivityCheckSuggestion_feishu_event_subscription_required: '在飛書後臺開啟 im.message.receive_v1 併發布版本。',
    imConnectivityCheckSuggestion_discord_group_requires_mention: '在頻道中使用 @機器人 + 內容。',
    imConnectivityCheckSuggestion_telegram_privacy_mode_hint: '在 @BotFather 調整 Privacy Mode 設定。',
    imConnectivityCheckSuggestion_dingtalk_bot_membership_hint: '確認機器人已加入目標會話並允許收發訊息。',
    imConnectivityCheckSuggestion_wechatwork_http_callback_hint: '在企業微信後臺填寫公網可訪問的回撥地址，並將流量轉發到本地埠。',

    // 通用設定
    autoLaunch: '開機自啟動',
    autoLaunchDescription: '系統啟動時自動執行應用',

    // 定時任務
    scheduledTasks: '定時任務',
    scheduledTasksTitle: '定時任務',
    scheduledTasksNewTask: '新建任務',
    scheduledTasksEmptyState: '暫無定時任務',
    scheduledTasksEmptyHint: '建立定時任務，讓 AI 按計劃自動執行',
    scheduledTasksListColTitle: '標題',
    scheduledTasksListColSchedule: '計劃於',
    scheduledTasksListColStatus: '狀態',
    scheduledTasksListColMore: '更多',
    scheduledTasksTabTasks: '任務',
    scheduledTasksTabHistory: '歷史',
    scheduledTasksHistoryEmpty: '暫無執行記錄',
    scheduledTasksHistoryColTitle: '標題',
    scheduledTasksHistoryColTime: '執行時間',
    scheduledTasksHistoryColStatus: '狀態',
    scheduledTasksClearHistory: '清理歷史',
    scheduledTasksClearHistoryConfirmTitle: '清理執行歷史',
    scheduledTasksClearHistoryConfirmMessage: '將清理目前帳號的成功和失敗記錄，執行中的記錄和關聯對話會保留。此操作無法復原。',
    scheduledTasksClearingHistory: '正在清理...',
    scheduledTasksClearHistoryFailed: '清理歷史失敗，請稍後重試',
    scheduledTasksFormName: '標題',
    scheduledTasksFormNamePlaceholder: '輸入任務標題',
    scheduledTasksFormDescription: '描述',
    scheduledTasksFormDescriptionPlaceholder: '可選的任務描述',
    scheduledTasksFormScheduleType: '計劃',
    scheduledTasksFormScheduleModeOnce: '不重複',
    scheduledTasksFormScheduleModeDaily: '每天',
    scheduledTasksFormScheduleModeWeekly: '每週',
    scheduledTasksFormScheduleModeMonthly: '每月',
    scheduledTasksFormWeekSun: '週日',
    scheduledTasksFormWeekMon: '週一',
    scheduledTasksFormWeekTue: '週二',
    scheduledTasksFormWeekWed: '週三',
    scheduledTasksFormWeekThu: '週四',
    scheduledTasksFormWeekFri: '週五',
    scheduledTasksFormWeekSat: '週六',
    scheduledTasksFormValidationTimeRequired: '請選擇時間',
    scheduledTasksFormValidationWorkingDirectoryRequired: '請選擇任務工作目錄',
    scheduledTasksFormMonthDaySuffix: '日',
    scheduledTasksFormScheduleAt: '定時執行',
    scheduledTasksFormScheduleAtHint: '在指定時間執行一次',
    scheduledTasksFormScheduleInterval: '間隔執行',
    scheduledTasksFormScheduleIntervalHint: '按固定間隔重複執行',
    scheduledTasksFormScheduleCron: 'Cron 表示式',
    scheduledTasksFormScheduleCronHint: '使用 Cron 表示式定義複雜排程',
    scheduledTasksFormDatetime: '執行時間',
    scheduledTasksFormInterval: '間隔時間',
    scheduledTasksFormIntervalMinutes: '分鐘',
    scheduledTasksFormIntervalHours: '小時',
    scheduledTasksFormIntervalDays: '天',
    scheduledTasksFormCronExpression: 'Cron 表示式',
    scheduledTasksFormCronPlaceholder: '例如: */5 * * * * (每5分鐘)',
    scheduledTasksFormCronHelp: '格式: 分 時 日 月 周 (5段)',
    scheduledTasksFormPrompt: '執行提示詞',
    scheduledTasksFormPromptPlaceholder: '輸入要執行的提示詞...',
    scheduledTasksFormWorkingDirectory: '工作目錄',
    scheduledTasksFormWorkingDirectoryPlaceholder: '輸入工作區路徑',
    scheduledTasksFormSystemPrompt: '系統提示詞',
    scheduledTasksFormSystemPromptPlaceholder: '可選的系統提示詞...',
    scheduledTasksFormExecutionMode: '執行模式',
    scheduledTasksFormExecutionModeAuto: '自動',
    scheduledTasksFormExecutionModeLocal: '本地',
    scheduledTasksFormExecutionModeSandbox: '沙箱',
    scheduledTasksFormModel: '模型',
    scheduledTasksFormModelDefault: '使用預設模型',
    scheduledTasksFormDatePlaceholder: '年/月/日',
    scheduledTasksFormCalendarLabel: '選擇日期',
    scheduledTasksFormCalendarPreviousMonth: '上個月',
    scheduledTasksFormCalendarNextMonth: '下個月',
    scheduledTasksFormEnabled: '啟用任務',
    scheduledTasksFormCreate: '建立任務',
    scheduledTasksFormUpdate: '更新任務',
    scheduledTasksFormValidationNameRequired: '請輸入任務標題',
    scheduledTasksFormValidationPromptRequired: '請輸入執行提示詞',
    scheduledTasksFormValidationDatetimeFuture: '執行時間必須在未來',
    scheduledTasksFormValidationIntervalPositive: '間隔時間必須大於 0',
    scheduledTasksFormValidationCronRequired: '請輸入 Cron 表示式',
    scheduledTasksEdit: '編輯',
    scheduledTasksDelete: '刪除',
    scheduledTasksDeleteConfirm: '確定要刪除任務「{name}」嗎？此操作不可撤銷。',
    scheduledTasksRun: '立即執行',
    scheduledTasksStop: '停止',
    scheduledTasksEnabled: '已啟用',
    scheduledTasksDisabled: '已停用',
    scheduledTasksDetail: '任務詳情',
    scheduledTasksConfiguration: '配置資訊',
    scheduledTasksSchedule: '計劃',
    scheduledTasksPrompt: '提示詞',
    scheduledTasksWorkingDirectory: '工作目錄',
    scheduledTasksSystemPrompt: '系統提示詞',
    scheduledTasksExecutionMode: '執行模式',
    scheduledTasksStatus: '執行狀態',
    scheduledTasksNextRun: '下次執行',
    scheduledTasksLastRun: '上次執行',
    scheduledTasksLastDuration: '上次耗時',
    scheduledTasksLastError: '最近錯誤',
    scheduledTasksConsecutiveErrors: '連續錯誤',
    scheduledTasksRunHistory: '執行歷史',
    scheduledTasksNoRuns: '暫無執行記錄',
    scheduledTasksLoadMore: '載入更多',
    scheduledTasksManual: '手動',
    scheduledTasksScheduled: '定時',
    scheduledTasksViewSession: '檢視會話',
    scheduledTasksStatusSuccess: '成功',
    scheduledTasksStatusError: '失敗',
    scheduledTasksStatusRunning: '執行中',
    scheduledTasksStatusIdle: '空閒',
    scheduledTasksNotSet: '未設定',
    scheduledTasksNone: '無',
    scheduledTasksScheduleAtLabel: '定時',
    scheduledTasksScheduleIntervalLabel: '間隔',
    scheduledTasksScheduleCronLabel: 'Cron',
    scheduledTasksScheduleEvery: '每',
    scheduledTasksAutoDisabledErrors: '連續錯誤過多，任務已自動停用',
    scheduledTasksCreateFailed: '建立任務失敗',
    scheduledTasksUpdateFailed: '更新任務失敗',
    scheduledTasksDeleteFailed: '刪除任務失敗',
    scheduledTasksRunFailed: '執行任務失敗',
    scheduledTasksStopFailed: '停止任務失敗',
    scheduledTasksFormExpiresAt: '到期時間',
    scheduledTasksFormOptional: '（可選）',
    scheduledTasksFormExpiresAtHint: '可選，到期後任務不再執行',
    scheduledTasksFormExpiresAtClear: '清除',
    scheduledTasksFormExpiresAtNone: '永不過期',
    scheduledTasksDetailExpiresAt: '到期時間',
    scheduledTasksFormNotify: '通知',
    scheduledTasksFormNotifyHint: '可選，任務完成後通過 IM 傳送結果通知',
    scheduledTasksFormNotifyDingtalk: '釘釘',
    scheduledTasksFormNotifyFeishu: '飛書',
    scheduledTasksFormNotifyTelegram: 'Telegram',
    scheduledTasksFormNotifyDiscord: 'Discord',
    scheduledTasksFormNotifyNone: '無',
    scheduledTasksFormSandboxProfile: '沙箱環境',
    scheduledTasksFormSandboxImage: '映象',
    scheduledTasksFormSandboxProfileDefault: '使用預設環境',
    scheduledTasksFormSandboxImageDefault: '使用預設映象',
    scheduledTasksDetailNotify: '通知',
    scheduledTasksToggleWarningAtPast: '該任務的執行時間已過，啟用後將不會執行',
    scheduledTasksToggleWarningExpired: '該任務已過期，啟用後將不會執行',

    // 場景應用
    scenarios: '場景應用',
    scenariosTitle: '場景應用',
    scenariosEmpty: '暫無可用場景',
    scenariosLoadFailed: '載入場景失敗，請檢查連線後重試。',
    scenarioApplyToConversation: '套用至目前對話',
    scenariosRecentlyUsed: '最近使用',
    scenariosShuffle: '換一批',
    scenariosViewAll: '查看全部',
    scenariosUsedAt: '{time}使用',
    scenariosEmptyHint: '請聯絡管理員分配場景應用',
    scenariosStartChat: '開始對話',
    scenarioDetailsLoadFailed: '場景技能檢查失敗，請重試。',
    scenarioDetailsNoSkills: '本場景無需額外技能。',
    scenarioDetailsReadOnlyHint: '確認開始後才會準備技能，不會自動傳送訊息。',
    scenarioDetailsRecommendedModel: '推薦模型：{model}（不更改全域模型設定）',
    scenariosHot: '熱門',
    scenariosRecommended: '推薦',
    scenariosUsageCount: '使用 {count} 次',
    scenariosRefresh: '重新整理',
    scenariosLinkedSkills: '關聯技能',
    scenariosDismiss: '取消場景',
    scenariosServeYou: '為你服務',
    scenariosServeHint: '請告訴我你需要什麼幫助',
    scenariosWorkflow: '操作流程',
    scenariosAll: '全部',

    // 連接器
    connectors: '連接器',
    connectorsDescription: '瀏覽平台連接器並授權；授權後，智慧助理即可在 Cowork 中呼叫。',
    connectorSearchPlaceholder: '搜尋連接器（名稱 / 簡介 / 提供者）',
    connectorFilterAll: '全部',
    connectorFilterMcp: 'MCP 功能',
    connectorIMPurpose: '訊息渠道：設定並啟用機器人後，可從聊天軟體發起任務及接收結果。',
    connectorIMUnavailable: '此渠道尚未接入 Web 機器人設定，不代表已連接或可呼叫。',
    connectorIMUnsupported: 'Web 暫不支援',
    connectorFilterIm: '消息渠道',
    connectorConnect: '連線',
    connectorReauthRequired: '需要重新授權',
    connectorReauthorize: '重新授權',
    connectorClientUpgradeRequired: '請將 Web 升級至 {version} 後再連線',
    connectorDesktopOnly: '此連接器需要桌面端直連',
    connectorConfigIncomplete: '連接器配置不完整，請聯絡管理員',

    connectorConfigure: '設定',
    connectorDisconnect: '中斷',
    connectorConnectFailed: '連線失敗',
    connectorDisconnectFailed: '中斷失敗',
    connectorCredentialHint: '憑證將由平台安全保存，不會寫入瀏覽器本機儲存空間。',
    connectorEmpty: '找不到符合的連接器',
    refresh: '重新整理',
    scenariosSearchPlaceholder: '搜尋場景名稱或描述...',
    scenariosNoMatches: '未找到符合的場景',
    scenariosPreviousPage: '上一頁',
    scenariosNextPage: '下一頁',
    scenariosPopularTitle: '熱門場景',
    scenariosRankingHint: '依使用頻率排名',

    // 工具列表
    toolList: '工具列表',
    toolListDesc: '以下工具由管理員在管理平臺中配置，AI 可直接呼叫對應 API 完成工作',
    toolListEmpty: '暫無可用工具',
    toolListEmptyHint: '管理員尚未在管理平臺中配置工具，請聯絡管理員新增',
    toolListStatusEnabled: '已啟用',
    toolListStatusDisabled: '已停用',
    toolListRefresh: '重新整理',
    toolIntegration: '工具接入',
    toolIntegrationDesc: '將智慧助手與企業工具完全打通，配置業務系統的連線憑證後，AI 可直接呼叫對應 API 完成工作',
    toolIntegrationDescHint: '該功能需配合對應業務系統的技能使用，如有企業接入需求請聯絡',
    toolIntegrationAdd: '新增工具',
    toolIntegrationEdit: '編輯工具',
    toolIntegrationDelete: '刪除工具',
    toolIntegrationName: '工具名稱',
    toolIntegrationUrl: 'API 地址',
    toolIntegrationAuthType: '認證方式',
    toolIntegrationCredentialHint: '所有憑證均通過加密方式儲存在您的本地裝置，不會上傳至任何伺服器',
    toolIntegrationToken: 'Token',
    toolIntegrationUsername: '使用者名稱',
    toolIntegrationPassword: '密碼',
    toolIntegrationLogo: '圖示',
    toolIntegrationEnabled: '已啟用',
    toolIntegrationEmpty: '暫無接入工具',
    toolIntegrationEmptyHint: '新增企業業務系統後，AI 可以使用您的憑證呼叫對應 API',
    toolIntegrationConnected: '已接入以下工具，我可以幫你查詢資料、提交工單、操作這些系統',
    toolIntegrationDeleteConfirm: '確定刪除該工具嗎？',
    toolIntegrationSaved: '工具配置已儲存',
    toolIntegrationNamePlaceholder: '例如 Jira、GitLab',
    toolIntegrationUrlPlaceholder: '例如 https://jira.example.com',
    toolIntegrationTestConnection: '測試網路連線',
    toolIntegrationTestingConnection: '測試中...',
    toolIntegrationConnectionSuccess: '連線成功',
    toolIntegrationConnectionFailed: '連線失敗，請檢查地址是否正確',
    toolIntegrationTokenPlaceholder: '輸入 Token',
    toolIntegrationUsernamePlaceholder: '輸入使用者名稱',
    toolIntegrationPasswordPlaceholder: '輸入密碼',
    toolIntegrationSkills: '適用技能',
    toolIntegrationSkillsHint: '選擇該工具憑證適用的技能，執行時自動注入',
    toolIntegrationSkillsPlaceholder: '搜尋技能名稱…',
    toolIntegrationEnvVarsTitle: '將自動注入以下環境變數（技能指令碼可直接讀取）',
    toolIntegrationEnvVarsRule: '命名規則：技能 ID 轉大寫並將 - 替換為 _，例如 folib-artifact → FOLIB_ARTIFACT_BASE_URL / FOLIB_ARTIFACT_TOKEN',
    toolIntegrationInjectBtn: '注入憑證到技能',
    toolIntegrationInjectSuccess: '注入成功',
    toolIntegrationInjectError: '注入失敗，請重試',
    toolQuickTasks: '快捷任務',
    toolQuickTasksHint: '描述任務場景，可直接新增或讓 AI 生成詳細指令',
    toolQuickTasksInputPlaceholder: '例如：崗位:開發崗，場景:檢視我的需求進度，要求:按優先順序彙總...',
    toolQuickTasksGenerate: '生成',
    toolQuickTasksGenerating: '生成中...',
    toolQuickTasksAddDirect: '直接新增',
    toolQuickTasksSuggestionsTitle: '點選新增到快捷任務：',
    toolQuickTasksEmptyHint: '暫無快捷任務，輸入描述後點擊生成',
    toolQuickTasksClickToUse: '點選快速發起任務',

    // 映象管理
    mirrorManagement: '映象管理',
    mirrorManagementDesc: '選擇沙箱環境中使用的映象源',
    mirrorManagementRefresh: '重新整理',
    mirrorManagementRefreshing: '重新整理中...',
    mirrorManagementEmpty: '暫無可用映象',
    mirrorManagementEmptyHint: '請在平臺管理後臺新增映象源',
    mirrorManagementSelected: '已選中',
    mirrorManagementDefault: '預設',
    mirrorManagementNoSelection: '不使用映象源',
    mirrorManagementFetchError: '獲取映象列表失敗',
    mirrorManagementNpm: 'NPM 映象',
    mirrorManagementPypi: 'PyPI 映象',
    mirrorManagementApk: 'APK 映象',

    // Widget (生成式 UI)
    widgetShowCode: '檢視原始碼',
    widgetHideCode: '隱藏原始碼',
    widgetLoading: '正在生成視覺化...',
  },
  en: {
    // App 扫码登录：状态保存翻译键，切换语言不重建扫码会话。
    authAppQrTab: "App QR",
    authAppQrRegion: "App QR sign-in",
    authAppQrTitle: "Scan with the app to sign in",
    authAppQrCreating: "Generating QR code…",
    authAppQrPlatformChanged: "Server changed. Generate a new QR code.",
    authAppQrExpired: "QR code expired",
    authAppQrLogging: "Signing in…",
    authAppQrSuccess: "Signed in",
    authAppQrInitFailed: "Could not finish signing in. Please try again.",
    authAppQrCancelled: "QR code cancelled or already used",
    authAppQrPending: "Waiting for scan",
    authAppQrScanned: "Scanned",
    authAppQrVerifying: "Waiting for two-factor verification",
    authAppQrDeciding: "Verifying approval…",
    authAppQrUnconfirmed: "Sign-in could not be confirmed. Generate a new QR code.",
    authAppQrInvalid: "QR code is no longer valid. Generate a new one.",
    authAppQrRetrying: "Connection interrupted. Retrying…",
    authAppQrDisabled: "App QR sign-in is disabled. Use another sign-in method.",
    authAppQrUnavailable: "QR code unavailable. Please try again later.",
    authAppQrInstructions: "Open the app → Settings → Scan to sign in",
    authAppQrExpiryHint: "One-time code. Expires within {minutes} min.",
    authAppQrConfirmHint: "Confirm sign-in on your phone",
    authAppQrVerifyHint: "Enter the two-factor code on your phone",
    authAppQrLoggingHint: "Approved on your phone. Starting your session.",
    authAppQrSuccessHint: "Opening {app}…",
    authAppQrDecidingHint: "Please wait while we verify phone approval",
    authAppQrCheckCode: "Check code {code}",
    authAppQrBack: "Other sign-in methods",
    authAppQrRefresh: "Refresh QR code",
    authAppQrRegenerate: "Generate a new QR code",

    loginPhoneRegion: "Country code",
    loginPhoneMainland: "Mainland China",
    loginPhoneHongKong: "Hong Kong, China",
    loginSwitchPhone: "Phone",
    loginSwitchPassword: "Password",
    loginSwitchWechat: "WeChat",
    loginSmsLabel: "SMS code",

    loginSmsFrequent: "Too many requests. Please try again later.",
    loginSmsDailyLimit: "Daily code limit reached.",
    loginSmsInvalid: "Incorrect code. Please try again.",
    loginSmsExpired: "Code expired. Please request a new one.",
    loginSmsInvalidOrExpired: "Incorrect or expired code. Please request a new one.",

    loginOtherMethods: "Other ways to sign in",
    loginPasswordMethod: "Password login",
    loginWeChatMethod: "WeChat login",
    loginRegister: "Sign in / Register",
    loginForgot: "Forgot password?",
    loginShowPassword: "Show password",
    loginHidePassword: "Hide password",
    loginResend: "Resend code",
    loginCountdown: "Resend in {seconds}s",
    loginCodeInvalid: "Enter the 6-digit code",
    loginPasswordInvalid: "Incorrect account or password",
    loginAccountRequired: "Enter your account",
    loginPasswordRequired: "Enter your password",
    loginPhoneUnavailable: "Phone login is unavailable. Please use your password.",
    loginWeChatUnavailable: "WeChat login is unavailable. Please use another method.",
    loginLoadingMethods: "Loading sign-in options…",
    loginConsentQr: "Read and accept the agreements below to load the QR code.",
    loginScan: "Open WeChat · Scan",
    loginScanRegister: "First-time users must link a phone number to sign in.",
    loginRetryQr: "Refresh QR code",
    loginSending: "Sending…",
    loginAccount: "Account",
    loginPassword: "Password",
    loginAssistant: "AI assistant",

    settingsBasicGroup: 'Basics',
    settingsCapabilityGroup: 'Collaboration',
    settingsSystemGroup: 'System',

    customAgentFixedModel: "Agent model",
    personalStorageTitle: "Web files and cache",
    personalStorageRefresh: "Refresh",
    personalStorageUnknown: "Unavailable",
    personalStorageFailed: "Storage check failed. Please retry.",
    personalStorageScope: "Files and cache stored by the Web server for this account. This does not measure or clean Cube mounted workspaces or desktop client files.",
    personalStorageChecking: "Checking storage…",
    personalStorageTotal: "Web conversation files",
    personalStorageIncomplete: "Some categories are unavailable. Available categories are shown; refresh to retry.",
    personalStoragelegacy: "Legacy conversation files and cache",
    personalStoragedocuments: "Document revisions and assets",
    personalStorageinputs: "Conversation attachments",
    personalStorageartifacts: "Generated artifacts and temporary uploads",
    personalStorageFiles: "items",
    personalStoragePolicy: "Only failed or expired temporary artifact uploads are removed. Saved attachments, artifacts and active uploads are kept. File state is checked again on confirmation. Preview expires in five minutes.",
    personalStoragePreview: "Preview cleanup",
    personalStorageRemoved: "Removed",
    personalStorageSkipped: "Changed and skipped",
    personalStorageFailedCount: "Failed",
    personalStorageCancel: "Cancel",
    personalStorageConfirm: "Confirm cleanup",
    backgroundTasksTitle: "Background tasks",
    backgroundTasksHint: "Subagents and background work in this conversation. Closing this panel does not stop tasks. A finished task does not mean the conversation is complete.",
    backgroundTasksRefresh: "Refresh tasks",
    backgroundTasksClose: "Close task panel",
    backgroundTasksFailed: "Task check failed. Please refresh.",
    backgroundTasksunsupported: "Task control is unavailable for this runtime or conversation. Historical records are read-only.",
    backgroundTasksdisconnected: "The runtime connection is unavailable. Showing previous records; active task status needs confirmation.",
    backgroundTasksChecked: "Last checked",
    backgroundTasksLoading: "Loading tasks…",
    backgroundTasksEmpty: "No background tasks recorded",
    backgroundTasksrunning: "Running",
    backgroundTaskscompleted: "Completed",
    backgroundTasksfailed: "Failed",
    backgroundTasksstopped: "Stopped",
    backgroundTaskspending: "Pending",
    backgroundTasksunknown: "Unconfirmed",
    backgroundTasksAgent: "Subagent",
    backgroundTasksShell: "Background command",
    backgroundTasksGeneric: "Task",
    backgroundTasksLocate: "Locate in conversation",
    backgroundTasksStop: "Stop task",
    backgroundTasksTruncated: "Showing up to 200 retained tasks. Earlier records may be omitted.",
    backgroundTasksStopHint: "Stop only this task. The conversation continues and existing file changes are kept. The server must confirm the result.",
    backgroundTasksCancel: "Cancel",
    backgroundTasksConfirmStop: "Confirm stop",
    memoryCatalogScope: "Memory scope",
    memoryCatalogPersonal: "Personal memory files",
    memoryCatalogLegacy: "Legacy global memory",
    memoryCatalogRefresh: "Refresh memory files",
    memoryCatalogNew: "New memory",
    memoryCatalogPersonalHint: "Personal files recalled by topic in conversations and secretary sessions. General conversations honor the memory toggle; archived files are excluded. SOUL and internal session memory remain separate.",
    memoryCatalogLegacyHint: "Global files synced by older clients, owned only by this account. Files are not automatically merged into or used to overwrite personal memory.",
    memoryCatalogSearch: "Search memory names or content",
    memoryCatalogLoading: "Loading memory files…",
    memoryCatalogEmpty: "No matching memory files",
    memoryCatalogActive: "Active",
    memoryCatalogArchived: "Archived",
    memoryCatalogOther: "Other status",
    memoryCatalogEdit: "Edit and history",
    memoryCatalogArchive: "Archive",
    memoryCatalogMore: "Load more",
    memoryCatalogName: "File name without extension",
    memoryCatalogContent: "Memory content",
    memoryCatalogFormatHint: "Enter factual content or retain Markdown frontmatter. Keep persona instructions in SOUL settings.",
    memoryCatalogArchiveHint: "Archive excludes this fact from future recall while retaining its content and history. Restore an earlier revision in the editor.",
    memoryCatalogCancel: "Cancel",
    memoryCatalogCreate: "Create",
    memoryCatalogConfirmArchive: "Confirm archive",
    memoryCatalogUnavailable: "Memory service unavailable. Please retry.",
    memoryCatalogOpen: "Personal memory",
    memoryCatalogClose: "Close memory manager",
    customAgentPolicy: "Agents belong to your account and use platform models and isolated cloud workspaces. Changes affect new conversations; existing conversations keep their original configuration.",
    customAgentLoadFailed: "Could not load agents",
    customAgentReload: "Reload",
    customAgentSaveFailed: "Could not save. Try again.",
    customAgentNew: "New agent",
    customAgentEnabled: "Enabled",
    customAgentDisabled: "Disabled",
    customAgentname: "Name",
    customAgentdescription: "Description",
    customAgentrole: "Role",
    customAgentsystemPrompt: "Instructions",
    customAgentModel: "Model",
    customAgentCurrentModel: "Use the model selected for the new conversation",
    customAgentModelUnavailable: "Currently unavailable",
    customAgentDelete: "Delete",
    customAgentSave: "Save",
    customAgentSaving: "Saving…",
    customAgentDeleteHint: "Only the agent definition is deleted. Existing conversations, configuration snapshots and files remain.",
    customAgentCancel: "Cancel",
    customAgentSelect: "Choose an agent",
    customAgentDefault: "Default assistant",
    customAgentManage: "Manage agents",
    customAgentClose: "Close",
    customAgentSnapshot: "Original agent configuration",

    conversationResultsTitle: "Sources and files",
    conversationResultsHint: "Checked against this turn’s tools and files",
    conversationResultsFailed: "Check failed. Refresh to retry.",
    conversationResultsDownloadFailed: "Download failed. Refresh and retry.",
    conversationResultsRefresh: "Check again",
    conversationResultsChecking: "Checking…",
    conversationResultsverified: "File checked",
    conversationResultsinvalid: "Validation failed",
    conversationResultsunavailable: "Unavailable",
    conversationResultsunverified: "Content not checked",
    conversationResultsDownload: "Download",
    conversationResultsSources: "Sources for this turn",
    conversationResultsEmpty: "No verifiable stored files or structured search sources for this turn. This does not confirm complete delivery.",
    conversationResultsTruncated: "Showing the first 20 files. Open the file panel for more.",

    telegramTokenHint: "Get a Bot Token from @BotFather. It belongs only to this account and connection.",
    imInstancesTitle: "Connections",
    imInstancesDefault: "Default connection",
    qq: 'QQ',
    wechat: 'WeChat',
    imWechatWebHint: 'Scan with WeChat and confirm sign-in. Credentials are saved to this connection only. Enable it after signing in; disable it before pairing again.',
    imWechatAccount: 'WeChat account',
    imPairingScan: 'Scan and confirm on your phone',
    imPairingScanned: 'Scanned; waiting for confirmation',
    imPairingSaved: 'Sign-in saved. Enable the connection to receive messages.',
    imPairingExpired: 'QR code expired. Request a new one.',
    imPairingStart: 'Sign in with QR code',
    imPairingFailed: 'Pairing failed. Please retry.',
    imNotificationTitle: "Task notifications",
    imNotificationHint: "Select a conversation for this connection. Scheduled tasks notify it only when this platform is selected. Incoming messages never change your selection.",
    imNotificationTarget: "Recipient conversation",
    imNotificationNone: "Do not receive notifications",
    imNotificationDirect: "Direct",
    imNotificationGroup: "Group",
    imNotificationEmpty: "Ask the recipient to send a message to this bot, then refresh the list.",
    imNotificationWechatHint: "WeChat requires an active conversation context. After a restart or context expiry, ask the recipient to send another message.",
    imNotificationSent: "The platform accepted the latest notification",
    imNotificationFailed: "The latest notification was not confirmed. Check the connection, recipient and platform limits. It will not be retried automatically.",
    imNotificationNotSelected: "No recipient selected; notification not sent",
    imNotificationRequestFailed: "Could not load or save notification settings. Refresh and retry.",
    scheduledTasksNotificationFailed: "Task notification was not confirmed. Check the recipient and delivery status in the relevant Chat Gateway connection.",
    scheduledTasksNotifyTargetHint: "Set recipients in Chat Gateway first. Every connection with a selected recipient on these platforms will receive notifications.",
    scheduledTasksFormNotifyQq: "QQ",
    scheduledTasksFormNotifyWechat: "WeChat",
    scheduledTasksFormNotifyWechatwork: "WeCom",
    scheduledTasksFormNotifyNim: "NIM",
    imQQConnectMode: 'QQ connection method',
    imQQManualMode: 'Manual setup',
    imQQPairingHint: 'Scan with QQ to complete official bot pairing. Credentials are saved to this connection only. Enable it after pairing.',
    imQQWebHint: 'Enter your QQ Open Platform App ID and App Secret, then test and enable the connection. Supports channels, groups and direct messages. Disable before changing credentials.',
    imInstancesHint: "Connections belong to your account. Add multiple bots for the same platform. Legacy unowned settings are not inherited.",
    imInstancesAdd: "Add connection",
    imInstancesDelete: "Delete connection",
    imInstancesDeleteHint: "Deleting stops this connection and removes its configuration. Chats, files and credit records are preserved.",
    imInstancesName: "Connection name",
    imInstancesPlatform: "Platform",
    imInstancesFailed: "Operation failed. Please retry.",
    imInstancesUnsupported: "This runtime does not support connection management",

    coworkModelSaveFailed: "The model change was not saved. The previous model is still selected. Try again shortly.",
    coworkContinueInstruction: "Continue the current task from the results already completed. Preserve existing work and do not repeat operations that have already succeeded.",
    coworkRecoveryContinue: "Continue task",
    coworkRecoverySending: "Submitting…",
    coworkRecoverySubmitted: "Submitted",
    coworkRecoveryFailed: "The continuation was not confirmed. Check your connection and try again.",
    coworkRecoveryWait: "Try again shortly",

    turnDelete_title: "Delete conversation turns",
    turnDelete_hint: "Each turn includes the question, answer and tool messages. Deletion is permanent. Files, independent memories and charged credits remain. Select up to 200 turns. Context will be rebuilt on continuation; older sandboxes may need an update.",
    turnDelete_busy: "The conversation is running or queued. Wait until it finishes.",
    turnDelete_unsupported: "This older conversation cannot safely reset history. Use a new conversation.",
    turnDelete_failed: "Deletion was not confirmed. Your selection is kept. Refresh to check before retrying.",
    turnDelete_attachment: "Attachment message",
    turnDelete_count: "{count} turns selected",
    turnDelete_confirm: "Permanently delete the selected turns?",
    turnDelete_confirmButton: "Confirm permanent deletion",
    turnDelete_delete: "Delete selected turns",
    turnDelete_deleting: "Deleting…",

    campaign_title: "Rewards",
    campaign_close: "Dismiss campaign",
    campaign_details: "Details",
    campaign_claim: "Claim",
    campaign_claimed: "Claimed today",
    campaign_success: "Received {credit} credits",
    campaign_total: "Total claimed: {credit} credits",
    campaign_failed: "Claim result is unconfirmed. Refreshing eligibility; check your balance before trying again.",

    memoryFile_title: "Edit memory file",
    memoryFile_hint: "Keep the file header. Saving creates a revision; reload if another device has changed this file.",
    memoryFile_history: "Version history",
    memoryFile_current: "Current version",
    memoryFile_preview: "Revision preview (read only)",
    memoryFile_content: "File content",
    memoryFile_reload: "Reload",
    memoryFile_restore: "Restore this revision",
    memoryFile_restoreConfirm: "Restore creates a new revision and replaces your draft. Continue?",
    memoryFile_discardConfirm: "Discard unsaved changes?",
    memoryFile_unavailable: "Memory file is unavailable",
    memoryFile_manual: "Manual edit",
    memoryFile_restoreActor: "Restore",
    memoryFile_model: "Model update",
    memoryFile_system: "System update",
    memoryFile_organizer: "Memory maintenance",
    memoryFile_fileName: "File name (without .md)",
    memoryFile_rename: "Rename",
    memoryFile_renameConfirm: "Rename this file, keeping content and history and syncing removal of the old name?",
    memoryFile_renameHint: "Use lowercase letters, numbers, Chinese characters, underscores or hyphens. The content name stays unchanged.",
    memoryFile_saveBeforeRename: "Save or reload your draft before renaming.",
    memoryFile_renameActor: "File renamed",
    memoryFile_soulEditHistory: "Edit Soul and version history",
    memoryFile_soulHint: "Identity and interaction settings stay separate from facts. Reset loads a draft; save to apply it.",

    creditForbidden: "This account cannot access credit data or has been disabled.",
    creditNoPlan: "No plan or bonus allocation",
    creditOtherSource: "Other source",
    // 用户积分与账户：沿用平台计量单位，不混用实扣和模拟用量。
    creditTitle: "Credits and usage",
    creditRefresh: "Refresh",
    creditLoading: "Loading credits…",
    creditUnsupported: "This platform does not support this credit query yet.",
    creditSignIn: "Sign in again to view credits.",
    creditUnavailable: "Credit data is unavailable. Please refresh later.",
    creditStale: "The last successful data is shown below and may be out of date.",
    creditNoExpiry: "Not set / not applicable",
    creditUnit: "credits",
    creditShadow: "Shadow billing: usage shows simulated charges, not actual deductions.",
    creditOff: "Credit billing is off. Balances are platform records; usage is not shown as actual credit charges.",
    creditDebt: "Outstanding credit debt",
    creditWallet: "Wallet balance",
    creditWalletHint: "Shown separately from plans and the shared enterprise pool.",
    creditSubscription: "Plan and bonus remaining",
    creditUnlimited: "Unlimited",
    creditUsed: "Used",
    creditIssued: "Period allocation",
    creditBase: "Base allocation",
    creditBonus: "Bonus allocation",
    creditReset: "Next reset",
    creditPool: "Enterprise pool remaining",
    creditPoolHint: "This balance is shared, not allocated exclusively to you.",
    creditSimulatedUsage: "Simulated usage (credits)",
    creditUsage: "Credit usage",
    creditToday: "Today",
    creditWeek: "Last 7 days",
    creditMonth: "Last 30 days",
    creditPartial: "Some usage totals are unavailable. “—” means unknown, not zero usage.",
    creditDailyLimit: "Daily used / limit",
    creditInventory: "Credit sources and expiry",
    creditHistory: 'Transactions',
    creditHistoryFilter: 'Record type',
    creditHistoryHint: 'Claims, top-ups and usage as recorded by the platform. Missing historical credit amounts appear as —, never inferred from the balance.',
    creditHistoryUsed: 'Credits used',
    creditHistorySimulated: 'Simulated cost',
    creditHistoryPrevious: 'Previous',
    creditHistoryNext: 'Next',
    creditLogType0: 'All records',
    creditLogType1: 'Top-up',
    creditLogType2: 'Usage',
    creditLogType3: 'Account change',
    creditLogType4: 'System record',
    creditLogType5: 'Error record',
    creditLogType6: 'Refund',
    creditInventoryHint: "Each grant is listed separately. Wallet records show the current balance, not inferred historical top-ups or usage.",
    creditEmpty: "No credit source records.",
    creditPlan: "Plan",
    creditReward: "Reward / bonus",
    creditExpired: "Inactive",
    creditActive: "Active",
    creditRemaining: "Remaining",
    creditExpiry: "Expires",
    creditSource: "Source",
    creditUpdated: "Last updated",
    // Common
    save: 'Save',
    cancel: 'Cancel',
    saving: 'Saving...',
    create: 'Create',
    user: 'User',
    login: 'Login',
    loginWelcome: 'Sign in to your account',
    loginSubtitle: 'Welcome back, please enter your credentials',
    register: 'Register',
    logout: 'Log out',
    inDevelopment: 'In development',
    all: 'All',
    assigned: 'Assigned',
    unassigned: 'Unassigned',
    featured: 'Featured',
    personal: 'Personal',
    skillsEmpty: 'No skills available',
    skillCreatorPrompt: 'Help me create a new skill. First, ask me what this skill should do.',
    retry: 'Retry',
    imagePreview: 'Preview image',
    imageOriginalSize: 'Original size',
    imageFitWindow: 'Fit to window',
    imageLoadFailed: 'Image failed to load. Please retry.',
    retrying: 'Retrying...',
    platformOfflineMessage: 'Platform service is temporarily unavailable. Your session is retained and local features remain available.',
    builtinSkillsDescription: 'Featured skills assigned to your department by an administrator are mounted automatically in the sandbox.',
    categoryAnalysis: 'Data Analysis',
    categoryEducation: 'Education & Learning',
    categoryOther: 'Other',
    categoryCollaboration: 'Communication & Collaboration',
    createViaChat: 'Create via chat',
    createViaChatDescription: 'Describe your needs and AI will generate it for you',
    skillDuplicateDisabled: 'Another version of this skill is already selected',
    skillCreatorBothDisabled: 'skill-creator exists in both personal and built-in skills, but both are disabled. Please enable one first.',
    skillCreatorBuiltinDisabled: 'The built-in skill-creator is disabled. Please enable it in built-in skills first.',
    skillCreatorPersonalDisabled: 'The skill-creator skill is disabled. Please enable it in personal skills first.',
    skillCreatorMissing: 'You do not have the skill-creator skill. Please contact your administrator.',
    authAccount: 'Account',
    authAccountStatus: 'Account Status',
    authAccountSettings: 'Account Settings',
    authSignIn: 'Sign In',
    authUsername: 'Account',
    authUsernamePlaceholder: 'Enter account',
    authPhone: 'Phone Number',
    authPhonePlaceholder: 'Enter phone number',
    authVerificationCode: 'Verification Code',
    authVerificationCodePlaceholder: 'Enter SMS verification code',
    authTwoFactorTitle: 'Two-Factor Verification',
    authTwoFactorCode: '2FA Code',
    authTwoFactorCodePlaceholder: 'Enter 2FA code',
    authTwoFactorCodeRequired: '2FA code is required',
    authTwoFactorRequired: 'This account requires 2FA verification. Continue with your code.',
    authBackToLogin: 'Back to Login',
    authUsernamePasswordRequired: 'Account and password are required',
    authCaptchaRequired: 'Please enter the verification code',
    authLoginTabPassword: 'Password',
    authLoginTabPhone: 'Phone',
    authLoginTabWeChat: 'WeChat QR',
    authSendSmsCode: 'Send Code',
    authSmsCountdownSecond: '{seconds}s',
    authSmsCodeSent: 'Verification code sent',
    authInvalidPhone: 'Please enter a valid phone number',
    authPhoneCodeRequired: 'Phone number and code are required',
    authWeChatScanHint: 'Scan the QR code with WeChat to sign in',
    authWeChatQrLoading: 'Loading QR code...',
    authWeChatQrExpired: 'QR code expired, please refresh',
    authRefreshQrCode: 'Refresh QR Code',
    authWeChatBindPhoneTitle: 'Bind Phone Number',
    authWeChatBindPhoneHint: 'Verify your phone number to register and sign in, or link WeChat to your existing phone account.',
    authRegisterRequired: 'Complete all required registration fields',
    authLoginSuccess: 'Signed in successfully',
    authRegisterSuccess: 'Registration successful. Please sign in.',
    authAgreePrefix: 'I have read and agree to the',
    authUserAgreement: 'User Agreement',
    authAnd: 'and',
    authPrivacyPolicy: 'Privacy Policy',
    authPleaseAgree: 'Please agree to the User Agreement and Privacy Policy first',
    authNoAccount: 'No account?',
    authGoToRegister: 'Sign up',
    authLogoutSuccess: 'Signed out',
    authTokenExpired: 'Your session has been revoked (possibly due to password change or admin force-logout). Please sign in again.',
    authSessionExpired: 'Your session has expired. Please sign in again.',
    // OAuth authorize page
    oauthAuthorizeTitle: 'Authorize {orgCode} Desktop',
    oauthAuthorizeDesc: 'The desktop client is requesting access to your {orgCode} account',
    oauthAuthorizeButton: 'Authorize and Continue',
    oauthLoginTitle: 'Sign in to Authorize',
    oauthLoginDesc: 'Sign in to your BoCoder account to authorize the desktop client',
    oauthLoginAndAuthorize: 'Sign in & Authorize',
    oauthVerifyAndAuthorize: 'Verify & Authorize',
    oauthRedirecting: 'Authorization Successful',
    oauthSuccessDesc: 'Authentication complete. Please return to the {orgCode} desktop client to continue.\nYou can safely close this page.',
    oauthInvalidRedirect: 'Invalid redirect URL',
    oauthClientHint: 'Application {clientId} is requesting authorization',
    authNotLoggedIn: 'You are not signed in to a BoCoder account',
    authUserStatus: 'Status',
    authUserStatusNormal: 'Normal',
    authUserStatusUnknown: 'Unknown',
    authSession: 'Session',
    authSessionEmpty: 'Sign in to manage the current account session here',
    // Settings
    help: 'Help',
    settings: 'Settings',
    edit: 'Edit',
    delete: 'Delete',
    general: 'General',
    model: 'Model',
    shortcuts: 'Shortcuts',
    theme: 'Theme',
    accentColor: 'Accent Color',
    appearance: 'Appearance',
    language: 'Language',
    useSystemProxy: 'Use System Proxy',
    useSystemProxyDescription: 'When enabled, network requests follow system proxy settings (takes effect after saving)',
    quickActionSuggestions: 'Conversation Suggestions',
    quickActionSuggestionsDescription: 'Suggest follow-up actions after task completion (powered by LLM, consumes a small amount of tokens)',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
    chinese: 'Simplified Chinese',
    traditionalChinese: 'Traditional Chinese',
    english: 'English',
    
    // Provider labels
    providerLabelCustom: 'Custom',
    apiKeyGetHelp: 'Get API Key',

    // API Settings
    apiKey: 'API Key',
    apiKeyPlaceholder: 'Enter your API Key',
    baseUrl: 'API Base URL',
    baseUrlPlaceholder: 'Enter API Base URL',
    baseUrlHint1: 'Usually just the domain, path will be appended automatically',
    baseUrlHintExample1: 'https://api.siliconflow.cn',
    baseUrlHint2: 'For non-standard APIs, enter the full URL',
    baseUrlHintExample2: 'https://ark.cn-beijing.volces.com/api/v3/chat/completions',
    currentModel: 'Current Model',
    availableModels: 'Available Models',
    modelSwitchHint: 'You can switch models in the chat interface',
    
    // Model Provider Settings
    enabled: 'Enabled',
    disabled: 'Disabled',
    providerStatusOn: 'on',
    providerStatusOff: 'off',
    providerSettings: 'Provider Settings',
    modelProviders: 'Model Providers',
    addModel: 'Add Model',
    editModel: 'Edit Model',
    addNewModel: 'Add New Model',
    modelName: 'Model Name',
    modelId: 'Model ID',
    modelNameAndIdRequired: 'Model name and model ID are required',
    modelIdExists: 'Model ID already exists. Use a different one',
    supportsImageInput: 'Supports image input',
    imageInput: 'Image',
    noModelsAvailable: 'No models available',
    addFirstModel: 'Add First Model',
    testConnection: 'Test Connection',
    testing: 'Testing...',
    connectionSuccess: 'Connection successful',
    connectionFailed: 'Connection failed',
    testConnectionAuthError: 'API Key is invalid or expired',
    testConnectionModelNotFound: 'Connected, but the model does not exist or is inaccessible',
    testConnectionRateLimited: 'Connected, but rate limited. Please try again later',
    testConnectionNetworkError: 'Network error. Check your connection or enable system proxy',
    noModelsConfigured: 'Please add a model first',
    fetchModels: 'Refresh Models',
    fetchingModels: 'Refreshing...',
    fetchModelsSuccess: 'Refreshed {count} models',
    fetchModelsFailed: 'Failed to refresh models',
    apiFormat: 'API Format',
    apiFormatNative: 'Anthropic Compatible',
    apiFormatOpenAI: 'OpenAI Compatible',
    apiFormatHint: 'Select protocol compatibility: Anthropic Compatible or OpenAI Compatible',
    zhipuCodingPlanHint: 'When enabled, uses the GLM Coding Plan dedicated API endpoint',
    zhipuCodingPlanEndpointHint: 'When using GLM Coding Plan, the system will automatically switch to the dedicated Coding endpoint',
    qwenCodingPlanHint: 'When enabled, uses the Alibaba Cloud Bailian Coding Plan dedicated API endpoint',
    qwenCodingPlanEndpointHint: 'When using Coding Plan, you need a dedicated API Key (format: sk-sp-xxxxx)',
    moonshotCodingPlanHint: 'When enabled, uses the Moonshot Coding Plan dedicated API endpoint',
    moonshotCodingPlanEndpointHint: 'When using Coding Plan, the system will automatically switch to the dedicated Coding endpoint',
    import: 'Import',
    export: 'Export',
    importProvidersFailed: 'Failed to import providers',
    exportProvidersFailed: 'Failed to export providers',
    invalidProvidersFile: 'Invalid providers file',
    decryptProvidersFailed: 'Failed to decrypt API key. Make sure the file was exported on this device.',
    decryptProvidersPartial: 'Some keys could not be decrypted. Existing keys were kept or left blank.',

    // Password related
    password: 'Password',
    confirmPassword: 'Confirm Password',
    enterPassword: 'Enter password',
    enterPasswordAgain: 'Enter password again',
    exportPasswordTitle: 'Set Export Password',
    importPasswordTitle: 'Enter Import Password',
    exportPasswordHint: 'This password encrypts your API keys. Use the same password when importing.',
    importPasswordHint: 'Enter the password you set when exporting',
    passwordRequired: 'Password is required',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 4 characters',
    wrongPassword: 'Wrong password, please try again',
    
    // Shortcuts
    keyboardShortcuts: 'Keyboard Shortcuts',
    productGroup: 'Products',
    codeProgramming: 'Code',
    appDownloadEntry: 'App Download',
    codeBetaBadge: 'Beta',
    // Code page (relay-controlled desktop)
    codeDeviceUnconnected: 'No device',
    codeNoOnlineDesktop: 'No desktop online. Sign in to BoCoder Desktop on your computer and keep it running.',
    codeCloudEnv: 'Cloud Env',
    codeCloudEnvTag: 'Cloud',
    codeGitRepoLabel: 'Start from a Git repo (required)',
    codeGitRepoPlaceholder: 'Repo URL (required)',
    codeGitBranchPlaceholder: 'Branch',
    codeGitUsernamePlaceholder: 'Username',
    codeGitPasswordPlaceholder: 'Password/Token',
    codeToastNoRepo: 'Please enter a repository address first',
    codeExecutionMode: 'Mode',
    codePermModeAuto: 'Auto',
    codePermModeDefault: 'Default',
    codePermModeAcceptEdits: 'Auto-accept edits',
    codePermModePlan: 'Plan mode',
    codePermModeBypassPermissions: 'Bypass all permissions',
    codeCloudEmptyHint: 'Describe your task — it runs in a cloud sandbox, no desktop required',
    codeToastCloudUnreachable: 'Cannot reach the cloud environment, please try again',
    codeNewSession: 'New session',
    codeNoSessions: 'No coding sessions yet — send a message to start',
    codeSelectDeviceFirst: 'Select an online desktop first',
    codeUntitledSession: 'Untitled session',
    codeNewSessionCwd: '~ new session',
    codeCwdTitle: 'Working directory',
    codeCwdUseDefault: 'Use default',
    codeCwdSelectThis: 'Select',
    codeCwdParent: 'Parent directory',
    codeCwdNoSub: 'No subdirectories',
    codeCwdTruncated: 'Showing first 200 items',
    codeCwdDefaultLabel: 'Default',
    codeCwdLoadFailed: 'Failed to load directory',
    codeRunning: 'Running',
    codeEmptyTitle: 'Start coding',
    codeSelectDesktopToStart: 'Select a desktop to start',
    codeEmptyHint: 'Messages are sent to your desktop and run by its local Code engine',
    codePermissionTool: 'Requesting tool',
    codeAllow: 'Allow',
    codeAllowAlways: 'Always allow',
    codeDeny: 'Deny',
    codeComposerPlaceholder: 'Message Code… (Enter to send, Shift+Enter for newline)',
    codeComposerDisabled: 'Select an online desktop first',
    codeStop: 'Stop',
    codeThinking: 'Thinking',
    codeJustNow: 'just now',
    codeToastDeviceUnreachable: 'Cannot reach the selected device, ensure the desktop is online',
    codeToastNoDesktop: 'No desktop device available',
    codeToastLoadSessionFailed: 'Failed to load session',
    codeToastSendFailed: 'Send failed',
    codeToastStopFailed: 'Stop failed',
    codeToastPermissionFailed: 'Permission response failed',
    codeToastModelFailed: 'Failed to switch model',
    codeToastModeFailed: 'Failed to switch mode',
    codeSearchPlaceholder: 'Search sessions',
    codeDeleteSession: 'Delete session',
    codeDeleteConfirm: 'Delete this session? This cannot be undone.',
    codeToastDeleteFailed: 'Delete failed',
    codeNoSessionMatch: 'No matching sessions',
    codeStatusIdle: 'Idle',
    codeStatusRunning: 'Running',
    codeStatusStopped: 'Stopped',
    codeStatusError: 'Error',
    codeCollapseSidebar: 'Collapse sidebar',
    codeExpandSidebar: 'Expand sidebar',
    codeAgentWorking: 'Tool calls',
    codeThinkingProcess: 'Thinking',
    codeClickExpand: 'click to expand',
    codeNoOutput: 'No output',
    codeNavSessions: 'Sessions',
    codeNavNewSession: 'New session',
    codeNavSkills: 'Skill Center',
    codeNavTasks: 'Scheduled tasks',
    codeManage: 'Manage',
    codeManageDone: 'Done',
    codePin: 'Pin',
    codeUnpin: 'Unpin',
    codeRename: 'Rename',
    codeRenamePrompt: 'Enter a new session name',
    codeMore: 'More',
    codeSelectAll: 'Select all',
    codeBatchDelete: 'Delete selected',
    codeBatchDeleteConfirm: 'Delete the selected sessions? This cannot be undone.',
    codeToastRenameFailed: 'Rename failed',
    newChat: 'New Task',
    search: 'Search Tasks',
    openSettings: 'Open Settings',
    close: 'Close',
    loginNotAvailable: 'Login is not available yet',
    collapse: 'Collapse',
    expand: 'Expand',
    downloadDesktopApp: 'Download Desktop App',
    downloadMac: 'macOS',
    downloadWin: 'Windows',
    downloadLinuxArm64: 'Linux ARM64',
    downloadLinuxX64: 'Linux x64',
    featureInDevelopment: 'In development',
    
    // Error Messages
    failedToLoadSettings: 'Failed to load settings',
    failedToSaveSettings: 'Failed to save settings',
    settingsSaveSuccess: 'Settings saved',

    // Loading State
    loading: 'Loading...',
    
    // Sidebar
    conversations: 'Conversations',
    noConversations: 'No conversations',
    createNewChat: 'New Chat',
    deleteConversation: 'Delete Conversation',
    renameConversation: 'Rename',
    moveToProject: 'Move to project',
    pinConversation: 'Pin chat',
    unpinConversation: 'Unpin chat',
    noProject: 'No project',
    noProjects: 'No projects',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete this conversation? This action cannot be undone.',
    searchChats: 'Search Chats',
    searchConversations: 'Search tasks...',
    searchNoResults: 'No matching tasks',
    projects: 'Projects',
    yourChats: 'Your Chats',
    createProject: 'New Project',
    projectNamePlaceholder: 'Project name',
    projectColorLabel: 'Color',
    projectIconLabel: 'Icon',
    project: 'Project',
    projectHistory: 'History',
    projectPrompt: 'Prompt',
    projectPromptPlaceholder: 'Add a prompt for this project',
    projectSettings: 'Project settings',
    projectNameLabel: 'Project name',
    deleteProject: 'Delete project',
    confirmDeleteProject: 'Are you sure you want to delete this project? Chats in this project will be moved to your chat list. This action cannot be undone.',
    folderIconDefault: 'Default',
    folderIconHealth: 'Health',
    folderIconStudy: 'Study',
    folderIconMath: 'Math',
    folderIconWork: 'Work',
    folderIconCode: 'Code',
    folderIconIdea: 'Ideas',
    
    // Chat Window
    sendMessage: 'Send Message',
    typeMessage: 'Type a message...',
    quickPrompt: 'Ask anything...',
    regenerateResponse: 'Regenerate Response',
    copyToClipboard: 'Copy to Clipboard',
    coworkResultHelpful: 'Helpful',
    coworkResultNotHelpful: 'Not helpful',
    coworkOpinionTitle: 'What was unsatisfactory about this answer?',
    coworkOpinionOther: 'Other',
    coworkOpinionPlaceholder: 'Describe the issue (optional)',
    coworkOpinionSubmit: 'Submit feedback',
    coworkOpinionCancelFailed: 'Could not undo the negative rating. Please retry.',
    coworkFeedbackFailed: 'Could not submit feedback. Please retry.',
    bobotCliInstall: 'BoBot CLI (Terminal)',
    bobotCliMacLinux: 'macOS / Linux',
    bobotCliWindows: 'Windows (PowerShell)',
    bobotCliNpm: 'Universal (npm)',
    bobotCliCopied: 'Copied',
    messageCopied: 'Message copied',
    clearConversation: 'Clear Conversation',
    confirmClearConversation: 'Are you sure you want to clear the current conversation? This action cannot be undone.',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: 'days ago',
    justNow: 'Just now',
    minutesAgo: 'minutes ago',
    hoursAgo: 'hours ago',
    welcomeMessage: 'How can I help you today?',
    thinking: 'Thinking...',
    reasoning: 'Reasoning',
    editMessage: 'Edit message',
    emptyMessage: 'Empty message',
    artifactOpen: 'Open',
    artifactView: 'View',
    artifactViewing: 'Viewing',
    artifactPreview: 'Preview',
    artifactCode: 'Code',
    imageLimitReached: 'Up to 10 images',
    imageReadError: 'Failed to read image',
    imageInputNotSupported: 'Current model does not support images',
    
    // Model Selection
    selectModel: 'Select Model',
    
    // Error Messages
    errorOccurred: 'An error occurred',
    tryAgain: 'Please try again',
    networkError: 'Network error',
    apiKeyRequired: 'API Key Required',
    configureApiKey: 'Please configure your API key in settings',
    
    // Initialization
    initializationError: 'Failed to initialize application. Please check your configuration.',
    apiKeyNotConfigured: 'API key not configured. Please set up your API key in settings.',
    initTitle: 'Initial Setup',
    initSubtitle: 'Enter BoCoder management backend URL',
    initUrlPlaceholder: 'http://192.168.1.100:9000',
    initVerifyBtn: 'Verify Connection',
    initVerifying: 'Verifying...',
    initSuccess: 'Connection successful',
    initFailed: 'Connection failed, please check the URL',
    initContinue: 'Continue',

    // BoCoder
    cowork: 'BoCoder',
    coworkSandbox: 'Sandbox',
    sandboxManagement: 'Sandbox Management',
    coworkSettings: 'BoCoder Settings',
    coworkHistory: 'History sessions',
    coworkNoSessions: 'No tasks yet',
    coworkPinSession: 'Pin task',
    coworkUnpinSession: 'Unpin task',
    coworkSessionActions: 'More actions',
    coworkPlaceholder: 'Assign me a task! Select skills from the skill options if needed...',
    coworkInterruptAndSend: 'Send after current task',
    coworkQueuedSummary: '{count} waiting to send',
    coworkQueuedCancel: 'Cancel queued message',
    coworkQueuedEdit: 'Edit message',
    coworkQueuedSteer: 'Steer current task',
    coworkQueuedCheck: 'Check status',
    coworkQueuedSteerUnavailable: 'This runtime does not support steering; the message will be sent after the current turn',
    coworkQueuedSteerAttachments: 'Messages with attachments stay queued for the next turn so files can be uploaded; text remains editable',
    coworkQueuedSteeringPending: 'Waiting for the current task to receive this message; unconsumed messages stay queued',
    coworkQueuedSteeringUnknown: 'Delivery is unconfirmed. Do not resend; check status to query the receipt',
    coworkQueuedUpdateFailed: 'Unable to update. The queue or task may have changed; your draft is preserved. Please retry.',
    coworkInterruptSystemInstruction: '[IMPORTANT: The user sent a new message while you were executing a task]\nDetermine the user\'s intent from context:\n- It may be a supplement or correction to the current task (e.g. adjusting details, adding requirements) — continue the original goal while incorporating the new input\n- It may be a request to stop the current task and do something else — follow the user\'s new instructions\n- If the intent is unclear, ask the user to clarify before proceeding',
    coworkWorkingDirectory: 'Working Directory',
    coworkWorkingDirectoryPlaceholder: 'Enter workspace path',
    coworkWorkingDirectoryHint: 'BoCoder will execute commands in this directory',
    coworkSystemPrompt: 'System Prompt',
    coworkSystemPromptPlaceholder: 'Set custom instructions for BoCoder...',
    coworkSystemPromptHint: 'Optional system prompt to customize BoCoder\'s behavior',
    coworkLoginRequired: 'Please log in first. You can register if you don\'t have an account. You can also go to the "Model" tab to configure providers manually.',
    coworkModelSettingsRequired: 'No available model configured. Please contact your administrator.',
    coworkModelSettingsTitle: 'Model Settings',
    coworkModelSettingsHint: 'BoCoder uses the current model and provider configuration from Model Settings.',
    coworkModelSettingsAction: 'Go to Model Settings',
    coworkApiConfigTitle: 'API Configuration',
    coworkApiConfigHint: 'Supports Anthropic-compatible and OpenAI-compatible APIs (OpenAI compatibility is bridged by a local adapter).',
    coworkExecutionMode: 'Execution Mode',
    coworkExecutionModeAuto: 'Auto Mode',
    coworkExecutionModeLocal: 'Local Mode',
    coworkExecutionModeSandbox: 'Sandbox Mode',
    coworkExecutionModeAutoHint: 'Automatically choose the best environment. Prefers sandbox isolation, falls back to local when unavailable.',
    coworkExecutionModeLocalHint: 'Run everything directly on your machine. Best for accessing local files and dev tools.',
    coworkExecutionModeSandboxHint: 'Force execution in an isolated VM for maximum security. Requires sandbox components installed.',
    coworkExecutionModeAutoTag: 'Recommended',
    coworkSandboxOnlineHint: 'For online web-based sandbox mode, visit',
    coworkSandboxOnlineLinkText: 'boclaw.ai',
    coworkSandboxOnlineHintSuffix: 'to register.',
    coworkMemoryTitle: 'Memory',
    coworkMemoryEnabled: 'Memory',
    coworkMemoryEnabledHint: 'AI remembers your preferences and key information to personalize conversations.',
    coworkMemorySimpleHint: 'Manage entries below or let AI learn automatically from conversations.',
    coworkMemoryAutoWrite: 'Auto-write memory',
    coworkMemoryCaptureEachTurn: 'Enable implicit updates',
    coworkMemoryCaptureEachTurnHint: 'When enabled, AI automatically extracts memorable facts from each conversation turn (adds minor API usage).',
    coworkMemoryGuardLevel: 'Write guard level',
    coworkMemoryGuardStrict: 'Strict',
    coworkMemoryGuardStandard: 'Standard',
    coworkMemoryGuardRelaxed: 'Relaxed',
    coworkMemoryMaxResults: 'Max injected items',
    coworkMemoryMaxResultsHint: 'Range: 1-60, recommended: 12',
    coworkMemoryMinScore: 'Minimum relevance threshold',
    coworkMemoryMaxInjectChars: 'Max injected characters',
    coworkMemoryRecallInterval: 'Auto recall interval (turns)',
    coworkMemoryRecallIntervalHint: 'Inject memory every N turns, recommended: 3',
    coworkMemoryCrudTitle: 'Managed memory entries',
    coworkMemoryManageHint: 'View, search, add, edit, and delete memory entries here.',
    coworkMemoryTotalLabel: 'Total',
    coworkMemoryActiveLabel: 'Active',
    coworkMemoryInactiveLabel: 'Inactive',
    coworkMemoryStatusActive: 'Active',
    coworkMemoryStatusInactive: 'Inactive',
    coworkMemoryStatusDeleted: 'Deleted',
    coworkMemoryUpdatedAt: 'Updated',
    coworkMemoryEditingTag: 'Editing selected memory',
    coworkMemoryRebuildIndex: 'Rebuild index',
    coworkMemoryRebuildSuccess: 'Memory index rebuilt',
    coworkMemoryRebuildFailed: 'Failed to rebuild memory index',
    coworkMemoryStatsSummary: 'Managed entries',
    coworkMemorySearchPlaceholder: 'Search memory title/content',
    coworkMemoryCategoryAll: 'All categories',
    coworkMemoryEmpty: 'No memory entries yet',
    coworkMemoryCrudTextPlaceholder: 'Enter memory text',
    coworkMemoryCrudCreate: 'Create entry',
    coworkMemoryCrudUpdate: 'Update entry',
    coworkMemoryCrudSaveFailed: 'Failed to save memory entry',
    coworkMemoryCrudDeleteFailed: 'Failed to delete memory entry',
    coworkMemoryAdvancedShow: 'Show advanced settings',
    coworkMemoryAdvancedHide: 'Hide advanced settings',
    coworkMemoryEmbeddingEnabled: 'Enable local embedding rerank',
    coworkMemoryEmbeddingEnabledHint: 'Rerank lexical hits with local vector similarity for better recall quality',
    coworkMemoryEmbeddingModel: 'Embedding model',
    coworkMemoryEmbeddingModelHint: 'Recommended: BAAI/bge-m3. You can switch to any downloaded sentence-transformers model',
    coworkMemoryEmbeddingLocalModelPath: 'Local model path (optional)',
    coworkMemoryEmbeddingLocalModelPathHint: 'If set, load model from this directory first; if empty, load by model id',
    coworkMemoryEmbeddingAutoDownload: 'Allow auto model download',
    coworkMemoryEmbeddingAutoDownloadHint: 'When disabled, you must provide a local model path',
    coworkMemoryEmbeddingDownload: 'Download / Validate model',
    coworkMemoryEmbeddingDownloading: 'Downloading...',
    coworkMemoryEmbeddingDownloadHint: 'Manually trigger model download (or validate local path). This can take a while, wait for progress to finish',
    coworkMemoryEmbeddingDownloadSuccess: 'Embedding model is ready',
    coworkMemoryEmbeddingDownloadFailed: 'Failed to download embedding model',
    coworkMemoryEmbeddingProgressPreparing: 'Preparing download task',
    coworkMemoryEmbeddingProgressInit: 'Initializing',
    coworkMemoryEmbeddingProgressDownload: 'Downloading model files',
    coworkMemoryEmbeddingProgressLoad: 'Loading model',
    coworkMemoryEmbeddingProgressEncode: 'Warming up model',
    coworkMemoryEmbeddingProgressDone: 'Completed',
    coworkMemoryEmbeddingProgressError: 'Failed',
    coworkMemoryEmbeddingWeight: 'Semantic rerank weight',
    coworkMemoryEmbeddingWeightHint: 'Range 0-1. Higher means more embedding influence. Recommended: 0.62',
    coworkSandboxProfileRequired: 'Please select a sandbox profile first.',
    coworkSandboxImageRequired: 'Please select a sandbox image first.',
    sandboxEnvVars: 'Custom Environment Variables',
    sandboxEnvVarsHint: 'Environment variables injected into the sandbox VM. Useful for API keys, proxy settings, etc. Scripts and tools executed by AI can read these variables.',
    sandboxEnvVarsAdd: 'Add Variable',
    sandboxEnvVarsKeyPlaceholder: 'Variable name',
    sandboxEnvVarsValuePlaceholder: 'Variable value',
    coworkSandboxBadge: 'Sandbox',
    modelContextWindow: 'Context window',
    coworkContextUsage: 'Context',
    coworkContextCompacting: 'Compacting',
    coworkContextPending: 'Pending',
    coworkContextUnknown: 'Unknown',
    coworkUncachedInput: 'Uncached input',
    coworkCacheWrite: 'Cache write',
    coworkCacheRead: 'Cache read',
    coworkSourceDesktop: 'Desktop',
    coworkSourceApp: 'App Remote',
    relaySendCloud: 'Start Session',
    relaySendCloudDesc: 'Execute in cloud sandbox',
    relayNoDesktopOnline: 'No desktop clients online',
    relayDesktopOffline: 'Target desktop client is offline',
    coworkViewSandboxDesktop: 'View Sandbox Desktop',
    coworkSandboxDesktopTitle: 'Sandbox Desktop',
    coworkSandboxDesktopEnlarge: 'Enlarge to floating window',
    coworkSandboxDesktopOpenInTab: 'Open in new tab',
    coworkSandboxDesktopConnecting: 'Connecting to sandbox desktop...',
    sandboxPreview: 'Sandbox Preview',
    coworkTerminalTitle: 'Terminal',
    coworkTerminalConnecting: 'Connecting to terminal...',
    coworkTerminalDisconnected: 'Terminal disconnected',
    coworkTerminalNotRunning: 'Session not running — terminal unavailable',
    coworkTerminalOpenFailed: 'Terminal connection failed. Reconnect to retry; if it still fails, check the sandbox terminal service.',
    coworkTerminalClear: 'Clear',
    coworkTerminalReconnect: 'Reconnect',
    coworkTerminalResizeHint: 'Drag to resize terminal',
    coworkDeliverablesTitle: 'Deliverables',
    coworkDeliverablesEmpty: 'No deliverables yet...',
    coworkDeliverablesSummary: 'Summary',
    coworkDeliverablesFiles: 'Files',
    coworkDeliverablesUploadedFiles: 'Uploaded Files',
    coworkDeliverablesGeneratedFiles: 'Generated Files',
    coworkDeliverablesPreview: 'Preview',
    coworkDeliverablesDownload: 'Download',
    coworkDeliverablesNoPreview: 'Preview not available',
    coworkDeliverableDownloadFailed: 'Download failed: the sandbox may have stopped, or the file is no longer readable. Continue the session and retry.',
    coworkDeliverableSandboxPaused: 'The sandbox was paused after going idle. The file is still there but not readable right now — send any message to continue this session to restore file access.',
    coworkDeliverablesFilterAll: 'All',
    coworkDeliverablesFilterDoc: 'Docs',
    coworkDeliverablesFilterCode: 'Code',
    coworkDeliverablesFilterData: 'Data',
    coworkDeliverablesFilterImage: 'Images',
    coworkDeliverablesFilterOther: 'Other',
    coworkDeliverablesFilterEmpty: 'No files in this category',
    // Sandbox profiles
    sandboxProfiles: 'Sandbox Profiles',
    sandboxProfilesAdd: 'Add Sandbox',
    sandboxProfileName: 'Profile Name',
    sandboxProfileNamePlaceholder: 'e.g. Team CubeSandbox',
    sandboxProfileDelete: 'Delete',
    sandboxProfileEdit: 'Edit',
    sandboxProfileDeleteConfirm: 'Delete this sandbox profile?',
    sandboxSelectorTitle: 'Select Sandbox',
    sandboxSelectLocal: 'Local Execution',
    sandboxManage: 'Manage Sandboxes...',
    sandboxProfileSelectTitle: 'Select Execution Environment',
    sandboxEnvUnavailable: 'Environment unavailable (template removed or disabled)',
    sandboxImageSelectTitle: 'Select Sandbox',
    sandboxImageNameLabel: 'Image Name',
    sandboxImageArchitectureLabel: 'Architecture',
    sandboxImageRuntimeLabel: 'Runtime',
    sandboxImageResourcesLabel: 'Resources',
    envSelectorCloudSandbox: 'Cloud Sandbox',
    envSelectorDesktopClient: 'Desktop Client',
    executionEnvLabel: 'Execution Environment',
    scheduledTasksDesktopEnvTitle: 'This desktop client cannot show scheduled tasks on the web',
    scheduledTasksDesktopEnvHint: 'The client version on {device} has no scheduled-task channel. Update the desktop client and try again, or switch back to Cloud Sandbox.',
    scheduledTasksDesktopEnvBanner: 'These scheduled tasks live on {device} and run on that machine\'s own scheduler. You can enable, disable, delete, run and inspect them here. Create and edit them in the desktop client.',
    scheduledTasksDesktopCreateUnsupported: 'Desktop scheduled tasks need machine-local settings such as a working directory. Create or edit them in the desktop client.',
    executionEnvUnset: 'No environment selected',
    scheduledTasksFormValidationEnvRequired: 'Pick an execution environment. The sandbox template this task used may have been disabled or removed.',
    refreshDesktopSessions: 'Refresh desktop sessions',
    desktopSessionsRefreshed: 'Desktop sessions refreshed',
    desktopSessionsRefreshFailed: 'Refresh failed — check that the desktop client is online',
    sandboxImageCores: ' cores',
    sandboxProfileEmpty: 'No sandbox profiles available. Please contact your administrator.',
    sandboxImageEmpty: 'No sandbox images available. Please contact your administrator.',
    sandboxProfileSave: 'Save',
    sandboxProfileCancel: 'Cancel',
    coworkLocalBadge: 'Local',
    coworkApiProviderModel: 'Select from provider models',
    coworkApiProviderModelCustom: 'Custom',
    coworkApiProviderModelHint: 'Only shows enabled providers with configured API key and base URL.',
    coworkApiBaseUrl: 'API Base URL',
    coworkApiKey: 'API Key',
    coworkApiModel: 'Model Name',
    coworkApiKeyRequired: 'API key is required',
    coworkApiBaseUrlRequired: 'Base URL is required',
    coworkApiModelRequired: 'Model name is required',
    coworkApiBaseUrlInvalid: 'Invalid Base URL format',
    coworkApiConfigSaveFailed: 'Failed to save API configuration',
    coworkApiConfigLoadFailed: 'Failed to load API configuration',
    coworkStatusIdle: 'Idle',
    coworkStatusRunning: 'Running',
    coworkThinking: 'Thinking',
    coworkActivityAwaitingModel: 'Waiting for the model to start responding',
    coworkStatusCompleted: 'Completed',
    turnStatus_completed: 'Completed',
    turnStatus_incomplete: 'Incomplete',
    turnStatus_failed: 'Failed',
    turnStatus_stopped: 'Stopped',
    turnStatus_interrupted: 'Interrupted',
    turnDuration: 'Duration',
    showThinkingProcess: 'Show thinking process',
    secretaryPreference_warmHint: 'Friendly and patient, without filler',
    secretaryPreference_conciseHint: 'Lead with the answer',
    secretaryPreference_naturalHint: 'Like a familiar long-term partner',
    secretaryPreference_briefHint: 'Only the essentials',
    secretaryPreference_balancedHint: 'Answer, rationale, and next step',
    secretaryPreference_detailedHint: 'Background, risks, and steps',
    secretaryPreference_noneHint: 'Do not initiate humor',
    secretaryPreference_lightHint: 'Light humor without losing focus',
    secretaryPreference_playfulHint: 'More lively outside serious topics',
    secretaryPreference_responsiveHint: 'Stay on the current question',
    secretaryPreference_moderateHint: 'Flag gaps, risks, and next steps',
    secretaryPreference_proactiveHint: 'Suggest related actions and tasks',
    secretaryPreference_avatar: 'Avatar color',
    secretaryPreference_blue: 'Blue',
    secretaryPreference_violet: 'Violet',
    secretaryPreference_teal: 'Teal',
    secretaryPreference_amber: 'Amber',
    secretaryPreference_rose: 'Rose',
    secretaryPreference_loading: 'Loading assistant preferences…',
    conversationHistory: 'Question navigation',
    secretaryPreference_title: 'Secretary identity and style',
    secretaryPreference_hint: 'Saved separately from free-form Soul below. Saved preferences apply to the next secretary turn without interrupting a running turn. Resetting Soul preserves these settings.',
    secretaryPreference_error: 'Could not load or save. Reopen settings to retry.',
    secretaryPreference_saved: 'Saved',
    secretaryPreference_saveIdentity: 'Save identity',
    secretaryPreference_saveStyle: 'Save style',
    secretaryPreference_assistantDisplayName: 'Assistant name',
    secretaryPreference_preferredUserName: 'Your preferred name',
    secretaryPreference_workDomain: 'Work domain',
    secretaryPreference_assistantIntroduction: 'Assistant introduction',
    secretaryPreference_speechStyle: 'Speech style',
    secretaryPreference_responseDetail: 'Response detail',
    secretaryPreference_humorLevel: 'Humor',
    secretaryPreference_initiativeLevel: 'Initiative',
    secretaryPreference_warm: 'Warm',
    secretaryPreference_concise: 'Concise',
    secretaryPreference_natural: 'Natural',
    secretaryPreference_brief: 'Brief',
    secretaryPreference_balanced: 'Balanced',
    secretaryPreference_detailed: 'Detailed',
    secretaryPreference_none: 'None',
    secretaryPreference_light: 'Light',
    secretaryPreference_playful: 'Playful',
    secretaryPreference_responsive: 'Responsive',
    secretaryPreference_moderate: 'Moderate',
    secretaryPreference_proactive: 'Proactive',
    conversationLatest: 'Jump to latest',
    conversationSearch: 'Search conversation',
    conversationSearchHint: 'Search content; leave empty to browse questions',
    conversationPrevious: 'Previous match',
    conversationNext: 'Next match',
    creditSessionUsage: 'Session credits',
    creditTurnUsage: 'Turn credits',
    creditLatestTurnUsage: 'Latest turn credits',
    coworkCloudPermissionTitle: 'Run within sandbox',
    coworkCloudPermissionHint: 'Tools run automatically inside the cloud sandbox; interactive questions still wait for your answer. This template does not support desktop permission modes. Desktop tasks use the connected client’s permission settings.',
    creditTurnSimulated: 'Simulated turn cost',
    creditSessionSimulated: 'Simulated session cost',
    creditTurnConsumed: 'Turn cost',
    creditSessionTotal: 'Session total',
    creditPendingSettlement: 'Pending',
    creditTurnBreakdownUnavailable: 'Turn breakdown unavailable',
    creditTurnBreakdownUnavailableHint: 'The platform did not return per-turn details. Refer to the session total.',
    creditShadowShort: 'Shadow billing',
    creditStaleShort: 'Refresh pending',
    creditRecordedUsageHint: 'Recorded charges; later settlement may update them. Unassigned historical charges are included only in the session total.',
    creditFree: 'Free',
    creditPerCall: 'credits/call',
    creditInput: 'Input',
    creditOutput: 'Output',
    creditPer1k: 'credits/1K tokens',
    creditMeterPrices: 'Tool and sandbox prices',
    creditMetersEmpty: 'No public prices available. This does not mean free.',
    creditMeterConfirmation: 'Confirmation required',
    connectorEditFailed: 'Could not load or update the connector. Refresh and retry.',
    connectorToolsTitle: 'Inspect tools',
    connectorToolsHint: 'Connect to the authorized MCP and list tools. No business tool is executed.',
    connectorToolsLoading: 'Connecting and discovering tools…',
    connectorToolsUnavailable: 'No tools discovered. Check the service address and authorization, then retry.',
    connectorToolsRetry: 'Check again',
    connectorEdit: 'Edit',
    connectorDelete: 'Delete',
    connectorAdd: 'Add',
    connectorDeleteConfirm: 'Delete this custom connector and its authorization?',
    connectorEditTokenHint: 'Tokens are never shown. Blank keeps the token only if the URL is unchanged. Changing the URL clears the old token unless you enter a new one.',
    subscriptionHistory: 'Order history',
    subscriptionAddons: 'Add-on credits',
    subscriptionAddonEmpty: 'No eligible add-on or payment method is available.',
    subscriptionHistoryEmpty: 'No orders yet',
    subscriptionPrevious: 'Previous',
    subscriptionNext: 'Next',
    subscriptionWechat: 'WeChat Pay',
    subscriptionAlipay: 'Alipay',
    subscriptionPayLink: 'Open payment page',
    subscriptionRefresh: 'Refresh status',
    subscriptionDays: 'days',
    subscriptionCredits: 'credits',
    subscriptionCnyOnly: 'This checkout supports CNY plans.',
    subscriptionResumeMissing: 'Payment code is unavailable after refresh. Check your payment app and refresh the order status before purchasing again.',
    subscriptionTitle: 'Subscription plans',
    subscriptionDuration: 'Plan duration',
    subscriptionDuration_year: 'year(s)', subscriptionDuration_month: 'month(s)', subscriptionDuration_day: 'day(s)', subscriptionDuration_hour: 'hour(s)',
    subscriptionUnavailable: 'Plans or orders are unavailable. Return later to retry.',
    subscriptionLoading: 'Loading plans…',
    subscriptionEmpty: 'No plans available',
    subscriptionBase: 'Base credits',
    subscriptionBonus: 'Bonus credits',
    subscriptionBuy: 'Purchase and create payment code',
    subscriptionViewOrder: 'View order',
    subscriptionOrder: 'Order',
    subscriptionAmount: 'Payment amount',
    subscriptionSuccess: 'Payment confirmed; refreshing credits',
    subscriptionPending: 'Awaiting payment confirmation from the platform',
    subscriptionExpired: 'Order expired',
    subscriptionUnknown: 'Check order status on the platform',
    subscriptionExpires: 'Payment code expires',
    subscriptionClose: 'Collapse (keeps order)',

    coworkStatusError: 'Error',
    coworkPermissionRequired: 'Permission Required',
    coworkPermissionDescription: 'BoCoder is requesting to perform the following action',
    coworkToolName: 'Tool Name',
    coworkToolInput: 'Tool Input',
    coworkToolResult: 'Result',
    coworkToolRunning: 'Running...',
    coworkDocumentExtractStop: 'Stop',
    coworkExecutionProcess: 'Execution',
    coworkToolSequenceCount: '{count} operations',
    coworkToolActionSearch: 'Search',
    coworkToolActionView: 'View',
    coworkToolActionRun: 'Run',
    coworkToolActionRead: 'Read',
    coworkToolActionWrite: 'Write',
    coworkToolActionEdit: 'Edit',
    coworkToolActionFind: 'Find',
    coworkToolActionDelegate: 'Handle',
    coworkToolActionPlan: 'Update execution plan',
    coworkToolActionSkill: 'Load skill',
    coworkTodosTitle: 'Todos',
    coworkTodoItems: 'items',
    coworkTodoCompleted: 'completed',
    coworkTodoInProgress: 'in progress',
    coworkTodoPending: 'pending',
    coworkTodoUntitled: 'Untitled todo',
    coworkTodoUnknownStatus: 'Unknown status',
    coworkTodoPanelTitle: 'Execution Plan',
    coworkTodoPanelProgress: 'Progress',
    coworkTodoPanelAllDone: 'All tasks completed',
    coworkDangerousOperation: 'Warning: This operation may modify files or execute system commands. Please review carefully.',
    coworkApprove: 'Approve',
    coworkDeny: 'Deny',
    coworkPermissionModeLabel: 'Permissions',
    coworkPermissionModeDefault: 'Ask every time',
    coworkPermissionModeAuto: 'Auto approve',
    coworkPermissionModeBypass: 'Skip approval',
    coworkPermissionModeDefaultHint: 'Confirm every action with side effects',
    coworkPermissionModeAutoHint: 'Allow by default, ask on risky actions',
    coworkPermissionModeBypassHint: 'No approval at all, fully automatic',
    coworkConfirmSelection: 'Submit selection',
    coworkDenyRequest: 'Deny request',
    coworkPauseTimer: 'Pause',
    coworkResumeTimer: 'Resume',
    coworkQuestionWizardTitle: 'Confirmation Needed',
    coworkQuestionWizardSkip: 'Skip',
    coworkQuestionWizardPrevious: 'Previous',
    coworkQuestionWizardNext: 'Next',
    coworkQuestionWizardSubmit: 'Submit',
    coworkQuestionWizardOther: 'Other',
    coworkQuestionWizardOtherPlaceholder: 'Enter custom answer...',
    coworkQuestionWizardSelectAtLeastOne: 'Please select at least one option',
    coworkQuestionWizardAnswerRequired: 'Please select or enter an answer',
    coworkWelcome: 'Hello, I\'m {orgCode}',
    coworkDescription: '{orgName} Agent {orgCode} helps you process documents, operate devices, and do deep research — your 24/7 AI assistant',
    coworkSkillsHint: 'More skills are available in the Skill Center',
    coworkNewSession: 'New Session',
    coworkContinuePlaceholder: 'Continue the conversation...',
    updateAvailablePill: 'Update available',
    updateAvailableTitle: 'New version available',
    updateAvailableMessage: 'A new version is available. Please download it from the official website and install over the current version.',
    updateAvailableConfirm: 'OK',
    updateAvailableCancel: 'Cancel',
    updateOpenFailed: 'Failed to open download page',
    checkForUpdates: 'Check for Updates',
    checkingForUpdates: 'Checking...',
    upToDate: 'Already up to date',
    downloadUpdate: 'Download Update',
    currentVersionPrefix: 'Current version',
    coworkStartingSession: 'Starting session...',
    coworkPreparingEnvironment: 'Preparing environment, please wait',
    coworkAddFile: 'Add File',
    coworkDropFileHint: 'Drop files here, or paste files directly',
    coworkAddImage: 'Add Image',
    coworkInputFileLabel: 'Input file',
    coworkAttachmentRemove: 'Remove',
    coworkFile: 'file',
    coworkShareSession: 'Share',
    coworkExportImageInProgress: 'Exporting image...',
    coworkExportImageSuccess: 'Image exported successfully',
    coworkExportImageFailed: 'Failed to export image',
    coworkExportImageTooLarge: 'This conversation is too large for one complete image. Reduce its size and try again.',
    coworkExportImageResourceFailed: 'Images or fonts could not load. No incomplete image was exported. Please try again.',
    deleteSession: 'Delete Task',
    batchManage: 'Manage',
    batchDone: 'Done',
    batchSelectAll: 'Select All',
    batchDeselectAll: 'Deselect All',
    batchDelete: 'Delete',
    batchDeleteConfirmTitle: 'Confirm Batch Deletion',
    batchDeleteConfirmMessage: 'This action cannot be undone. The selected {count} tasks and all their messages will be permanently deleted.',
    deleteTaskConfirmTitle: 'Confirm Deletion',
    deleteTaskConfirmMessage: 'This action cannot be undone. All messages in this task will be permanently deleted.',
    back: 'Back',
    browse: 'Browse',
    addFolder: 'Add Folder',
    recentFolders: 'Recent Folders',
    noFolderSelected: 'No folder selected',
    coworkSelectFolderFirst: 'Please select a task folder before submitting',
    noRecentFolders: 'No recent folders',
    coworkOpenFolder: 'Open folder',

    // Skills
    appSettings: 'App Settings',
    skills: 'Skill Center',
    searchSkills: 'Search skills',
    manageSkills: 'Manage Skills',
    officialSkills: 'Official Skills',
    addSkill: 'Add',
    uploadSkillZip: 'Upload .zip',
    uploadSkillFolder: 'Upload folder',
    skillImportPackaging: 'Packing {source}',
    skillImportUploading: 'Uploading {source}',
    skillImportValidating: 'Validating {source}',
    skillImportExtracting: 'Extracting {source}',
    skillImportDiscovering: 'Finding skills in {source}',
    skillImportInstalling: 'Importing {source}: {processed}/{total} processed, {installed} installed',
    skillImportProgressLabel: 'Skill import progress',
    skillDuplicatesConfirm: 'These skills are already installed',
    skillSkipDuplicates: 'Skip duplicates',
    skillOverwriteDuplicates: 'Overwrite all',
    skillFolderUploadResult: 'Folder upload complete: {installed} installed, {skipped} skipped, {failed} failed',
    skillBatchUploadResult: 'Batch upload complete: {installed} installed, {skipped} skipped, {failed} failed',
    skillImportMissingManifest: 'No SKILL.md found',
    skillImportPackageTooLarge: 'Skill package exceeds the size or file limit',
    skillImportTooManyFiles: 'Skill package contains too many files',
    skillImportUnsafeSource: 'Skill package contains an unsafe path or link',
    skillImportFailed: 'Skill import failed',
    importFromGithub: 'Import from GitHub',
    githubImportTitle: 'Import from GitHub',
    githubImportDescription: 'Supports both repository and subdirectory links. If a repo contains multiple skills, all will be imported.',
    githubImportUrlLabel: 'URL',
    githubSkillPlaceholder: 'e.g. owner/repo or a GitHub tree/blob URL',
    githubImportExamples: 'Examples: owner/repo; https://github.com/owner/repo/tree/main/SKILLs/my-skill',
    importSkill: 'Import',
    importingSkill: 'Importing...',
    official: 'Official',
    noSkillsAvailable: 'No skills available',
    skillsDescription: 'Pre-packaged best practices and tools for your AI agent',
    allCategories: 'All',
    uncategorized: 'Other',
    categoryDocuments: 'Documents',
    categorySearch: 'Search & Info',
    categoryDesign: 'Design & Creation',
    categoryTools: 'Productivity',
    categoryWriting: 'Writing',
    categoryDev: 'Dev & Integration',
    categoryWebAutomation: 'Web Automation',
    categoryCommunication: 'Communication',
    categorySystem: 'System',
    skillsOnlineNoResults: 'No matching community skills',
    skillDetailsOpen: 'View skill details',
    skillsFeaturedDetailTryAsking: 'Try asking me',
    skillsFeaturedDetailOutputArtifacts: 'Expected deliverables',
    skillsFeaturedDetailPreviewHint: 'Install and enable this skill to add an example to your conversation draft.',
    skillsFeaturedDetailUseSkill: 'Use this skill',
    skillsFeaturedDetailFallbackQuestion1: 'What tasks is “{name}” best suited for, and how should I get started?',
    skillsFeaturedDetailFallbackQuestion2: 'Use “{name}” to analyze the material I provide and identify missing information.',
    skillsFeaturedDetailFallbackQuestion3: 'Use “{name}” to give me an actionable plan for this task.',
    skillsFeaturedDetailDraftHint: 'Opens a new conversation draft and preserves existing text and attachments. Review it before sending.',
    skillLaunchUnavailable: 'This skill is disabled, removed, or your account has changed. Refresh and try again.',
    skillDetailsDescription: 'About this skill',
    skillDetailsCategory: 'Category',
    skillDetailsUpdated: 'Updated',
    skillDetailsLocation: 'Location',
    skillDetailsBuiltIn: 'Built in',
    skillDetailsLocal: 'Local skill',
    scenarioSkillPrepareTitle: 'This scenario needs these skills',
    scenarioSkillPrepareDesc: 'These skills are not ready yet. Install or enable them so the scenario works as intended.',
    scenarioSkillPrepareInstall: 'Install and enter',
    scenarioSkillPrepareEnable: 'Enable and enter',
    scenarioSkillPrepareCancel: 'Cancel',
    scenarioSkillPrepareInstalling: 'Installing…',
    scenarioSkillPrepareRetry: 'Retry',
    scenarioSkillPrepareSkip: 'Skip and enter',
    scenarioSkillPrepareFailedHint: 'Some skills failed to install. Retry, or enter anyway — the missing ones just will not apply this time.',
    scenarioSkillPrepareContinue: 'Got it, enter anyway',
    scenarioSkillStateReady: 'Ready',
    scenarioSkillStateMissing: 'Not installed',
    scenarioSkillStateDisabled: 'Disabled',
    scenarioSkillStateUnavailable: 'Delisted',
    scenarioSkillStateFailed: 'Install failed',
    coworkPromptModeLabel: 'Session mode',
    coworkMoreTools: 'More tools',
    coworkInputShortcutHint: 'Enter to send · {shortcut} for newline',
    coworkDraftSendFailed: 'Message could not be sent. Your draft was kept.',
    coworkDraftAttachmentsLost: 'Unsaved attachments cannot be restored after a refresh. Please add them again.',
    coworkCopyLink: 'Copy session link',
    coworkLinkCopied: 'Session link copied',
    coworkLinkCopyFailed: 'Could not copy. Check clipboard permission.',
    coworkAiDisclaimer: 'AI-generated content may be inaccurate. Please verify carefully.',
    coworkPromptModeCollab: 'Collaborate',
    coworkPromptModeQuick: 'Quick',
    coworkPromptModeChat: 'Chat',
    coworkPromptModeWork: 'Work',
    coworkPromptModeCollabHint: 'Full agent: tools, skills and sandbox execution',
    coworkPromptModeSwitchBusy: 'Stop the running turn before switching mode',
    coworkPromptModeQuickHint: 'Light chat: memory only, no tools, skills or sandbox — faster responses',
    coworkPromptModeSwitchToQuick: 'Switch to quick chat (no sandbox)',
    coworkPromptModeSwitchToCollab: 'Switch to collaboration (starts the sandbox, tools and skills available)',
    coworkPromptModeSwitchFailed: 'Failed to switch session mode',
    coworkPromptModeLocked: 'Conversation mode cannot be changed after the task starts',
    coworkQuickPlaceholder: 'What would you like to talk about?',
    coworkToolScenario: 'Scenario',
    secretaryEntry: 'BoMate',
    scenariosNoResults: 'No matching scenarios',
    scenariosAuthFailed: 'Platform sign-in expired',
    scenariosAuthFailedHint: 'Sign out and sign in again to load your scenario apps',
    scenariosFeaturedTitle: 'Featured scenarios',
    scenariosBrowseTitle: 'All scenarios',
    scenariosHotBadge: 'Popular',
    scenariosRecommendedBadge: 'Recommended',
    secretaryMemoryTitle: 'BoMate Long-term Memory',
    secretaryMemoryActive: 'Active',
    secretaryMemoryArchived: 'Archived',
    secretaryMemoryIndexUsage: 'Index',
    secretaryMemoryLastDream: 'Last consolidation',
    secretaryMemorySearchPlaceholder: 'Search long-term memory...',
    secretaryMemoryEmpty: 'No long-term memory yet — it builds up as you chat with BoMate',
    secretaryMemoryForget: 'Forget',
    secretarySoulEdit: 'Persona',
    secretarySoulHint: 'Defines how BoMate presents itself and interacts (no business facts). Takes effect for new sessions.',
    secretarySoulReset: 'Reset to default',
    secretarySoulSavedToast: 'Persona saved',
    setCategory: 'Set Category',
    clearCategory: 'Clear Category',
    skillsRoot: 'Skills folder',
    skillSourcePlaceholder: 'Git URL or local path',
    downloadSkill: 'Download Skill',
    downloadingSkill: 'Downloading...',
    deleteSkill: 'Delete Skill',
    skillEditTags: 'Edit tags',
    skillNewTagPlaceholder: 'New tag',
    skillAddTag: 'Add',
    skillDeleteConfirm: 'Delete skill \"{name}\"?',
    skillDeleteFailed: 'Failed to delete skill',
    skillBuiltInCannotDelete: 'Built-in skills cannot be deleted',
    skillDownloadFailed: 'Failed to download skill',
    skillUpdateFailed: 'Failed to update skill',
    activeSkill: 'Active Skill',
    clearSkill: 'Clear Skill',
    clearAll: 'Clear All',
    clearAllSkills: 'Clear all selected skills',
    skillsLocalTab: 'Local Skills',
    skillsFeaturedTab: 'Featured Skills',
    skillsOnlineTab: 'Community Skills',
    skillsPersonalTab: 'Personal Skills',
    skillsBuiltinTab: 'Featured Skills',
    skillsCommunityTab: 'Community Skills',
    skillsFeaturedSubtitle: 'Curated top-quality skills, install with one click',
    skillsFeaturedSearch: 'Search featured skills...',
    skillsFeaturedEmpty: 'No featured skills available',
    skillsFeaturedError: 'Failed to load, please try again later',
    skillsFeaturedSource: 'Skills listed below are from ',
    skillsFeaturedSourceSuffix: ' Featured Picks',
    skillsOnlineSubtitle: 'Explore community skills and install with one click',
    skillsOnlineSearch: 'Search skill name or description...',
    skillsOnlineInstall: 'Install',
    skillsOnlineInstalling: 'Installing...',
    skillsOnlineInstalled: 'Installed',
    skillsOnlineLoadMore: 'Load More',
    skillsOnlineEmpty: 'No online skills available',
    skillsOnlineError: 'Failed to load, please try again later',
    skillsOnlineSource: 'Skills listed below are from ',
    skillsOnlineSourceSuffix: ' Skill Store',
    skillsOnlineSortDownloads: 'Downloads',
    skillsOnlineSortStars: 'Stars',
    skillsOnlineSortUpdated: 'Recently Updated',

    // Email Skill Config
    emailTab: 'Email',
    emailConfig: 'Email Configuration',
    emailConfigHint: 'Requires the Email skill to be installed',
    emailProvider: 'Email Provider',
    emailSelectProvider: 'Select email provider',
    emailCustomProvider: 'Custom',
    emailAddress: 'Email Address',
    emailPassword: 'Password / Auth Code',
    emailPasswordPlaceholder: 'Password or app-specific password',
    emailAdvancedSettings: 'Advanced Settings',
    emailMailbox: 'Default Mailbox',
    emailConfigSaved: 'Email configuration saved',
    emailConfigError: 'Failed to save configuration',
    emailHintGmail: 'If 2FA is enabled, use an App Password instead of your account password',
    emailHint163: 'Use an authorization code, not your account password. Enable IMAP/SMTP in web settings first',
    emailHintQQ: 'Use an authorization code, not your account password. Enable IMAP/SMTP in web settings first',

    // File operations
    openFile: 'Open File',
    openFolder: 'Open Folder',
    showInFolder: 'Show in Folder',
    outputFiles: 'Output Files',
    openFileFailed: 'Failed to open file',
    fileCreated: 'File created',

    // IM Bot
    imBot: 'IM Tools',
    dingtalk: 'DingTalk',
    feishu: 'Feishu',
    telegram: 'Telegram',
    discord: 'Discord',
    wechatwork: 'WeCom',
    connected: 'Connected',
    disconnected: 'Disconnected',
    imConfigGuide: 'Setup Guide',
    imToggleNeedTest: 'Please fill in the config and pass the connectivity test before enabling',
    starting: 'Starting',
    start: 'Start',
    stop: 'Stop',
    messageType: 'Message Type',
    domain: 'Domain',
    feishuChina: 'Feishu (China)',
    renderMode: 'Render Mode',
    textMode: 'Text',
    cardMode: 'Card',
    chatSettings: 'Chat Settings',
    enableSkills: 'Enable Skills',
    systemPrompt: 'System Prompt',
    systemPromptPlaceholder: 'Set custom instructions for IM bot...',
    saveConfig: 'Save Config',
    imConnectivitySectionTitle: 'Connectivity Diagnostics',
    imConnectivityTest: 'Test Connectivity',
    imConnectivityRetest: 'Retest',
    imConnectivityTesting: 'Testing...',
    imConnectivityNoResult: 'No diagnostics yet. Test after enabling the gateway.',
    imConnectivityLastChecked: 'Last checked',
    imConnectivitySuggestion: 'Suggestion',
    imConnectivityVerdict_pass: 'Ready',
    imConnectivityVerdict_warn: 'Attention Needed',
    imConnectivityVerdict_fail: 'Unavailable',
    imConnectivityCheckTitle_missing_credentials: 'Missing Credentials',
    imConnectivityCheckTitle_auth_check: 'Credential Authentication',
    imConnectivityCheckTitle_gateway_running: 'IM Channel Enablement',
    imConnectivityCheckTitle_inbound_activity: 'Inbound Message Activity',
    imConnectivityCheckTitle_outbound_activity: 'Outbound Message Activity',
    imConnectivityCheckTitle_platform_last_error: 'Recent Platform Error',
    imConnectivityCheckTitle_feishu_group_requires_mention: 'Feishu Group Trigger Rule',
    imConnectivityCheckTitle_feishu_event_subscription_required: 'Feishu Event Subscription Requirement',
    imConnectivityCheckTitle_discord_group_requires_mention: 'Discord Group Trigger Rule',
    imConnectivityCheckTitle_telegram_privacy_mode_hint: 'Telegram Privacy Mode',
    imConnectivityCheckTitle_dingtalk_bot_membership_hint: 'DingTalk Conversation Permission',
    imConnectivityCheckTitle_wechatwork_http_callback_hint: 'WeCom HTTP Callback Setup',
    imConnectivityCheckSuggestion_missing_credentials: 'Fill required credentials and test again.',
    imConnectivityCheckSuggestion_auth_check: 'Verify credentials, permissions, and app release status.',
    imConnectivityCheckSuggestion_gateway_running: 'If disabled, click the IM channel pill to enable it, then verify platform endpoints are reachable.',
    imConnectivityCheckSuggestion_inbound_activity: 'Send a test message to the bot; mention it in group chats.',
    imConnectivityCheckSuggestion_outbound_activity: 'Check bot send permissions and conversation reply scope.',
    imConnectivityCheckSuggestion_platform_last_error: 'Fix the reported error and run diagnostics again.',
    imConnectivityCheckSuggestion_feishu_group_requires_mention: 'Use @bot plus your message in group chats.',
    imConnectivityCheckSuggestion_feishu_event_subscription_required: 'Enable im.message.receive_v1 and publish app version.',
    imConnectivityCheckSuggestion_discord_group_requires_mention: 'Use @bot plus your message in channels.',
    imConnectivityCheckSuggestion_telegram_privacy_mode_hint: 'Review Privacy Mode in @BotFather settings.',
    imConnectivityCheckSuggestion_dingtalk_bot_membership_hint: 'Ensure the bot is in the target conversation with send/receive rights.',
    imConnectivityCheckSuggestion_wechatwork_http_callback_hint: 'Set a publicly accessible callback URL in the WeCom backend, forwarding traffic to the local port.',

    // General Settings
    autoLaunch: 'Launch at Login',
    autoLaunchDescription: 'Automatically start the app when you log in',

    // Scheduled Tasks
    scheduledTasks: 'Scheduled Tasks',
    scheduledTasksTitle: 'Scheduled Tasks',
    scheduledTasksNewTask: 'New Task',
    scheduledTasksEmptyState: 'No scheduled tasks',
    scheduledTasksEmptyHint: 'Create scheduled tasks to automate AI execution on a schedule',
    scheduledTasksListColTitle: 'Title',
    scheduledTasksListColSchedule: 'Scheduled For',
    scheduledTasksListColStatus: 'Status',
    scheduledTasksListColMore: 'More',
    scheduledTasksTabTasks: 'Tasks',
    scheduledTasksTabHistory: 'History',
    scheduledTasksHistoryEmpty: 'No run history',
    scheduledTasksHistoryColTitle: 'Title',
    scheduledTasksHistoryColTime: 'Run Time',
    scheduledTasksHistoryColStatus: 'Status',
    scheduledTasksClearHistory: 'Clear History',
    scheduledTasksClearHistoryConfirmTitle: 'Clear Run History',
    scheduledTasksClearHistoryConfirmMessage: 'Completed and failed records for the current account will be cleared. Running records and linked conversations will be kept. This action cannot be undone.',
    scheduledTasksClearingHistory: 'Clearing...',
    scheduledTasksClearHistoryFailed: 'Failed to clear history. Please try again.',
    scheduledTasksFormName: 'Title',
    scheduledTasksFormNamePlaceholder: 'Enter task title',
    scheduledTasksFormDescription: 'Description',
    scheduledTasksFormDescriptionPlaceholder: 'Optional task description',
    scheduledTasksFormScheduleType: 'Plan',
    scheduledTasksFormScheduleModeOnce: 'Once',
    scheduledTasksFormScheduleModeDaily: 'Daily',
    scheduledTasksFormScheduleModeWeekly: 'Weekly',
    scheduledTasksFormScheduleModeMonthly: 'Monthly',
    scheduledTasksFormWeekSun: 'Sunday',
    scheduledTasksFormWeekMon: 'Monday',
    scheduledTasksFormWeekTue: 'Tuesday',
    scheduledTasksFormWeekWed: 'Wednesday',
    scheduledTasksFormWeekThu: 'Thursday',
    scheduledTasksFormWeekFri: 'Friday',
    scheduledTasksFormWeekSat: 'Saturday',
    scheduledTasksFormValidationTimeRequired: 'Please select a time',
    scheduledTasksFormValidationWorkingDirectoryRequired: 'Task working directory is required',
    scheduledTasksFormMonthDaySuffix: '',
    scheduledTasksFormScheduleAt: 'One-time',
    scheduledTasksFormScheduleAtHint: 'Run once at a specified time',
    scheduledTasksFormScheduleInterval: 'Interval',
    scheduledTasksFormScheduleIntervalHint: 'Repeat at fixed intervals',
    scheduledTasksFormScheduleCron: 'Cron Expression',
    scheduledTasksFormScheduleCronHint: 'Define complex schedules with Cron',
    scheduledTasksFormDatetime: 'Execution Time',
    scheduledTasksFormInterval: 'Interval',
    scheduledTasksFormIntervalMinutes: 'minutes',
    scheduledTasksFormIntervalHours: 'hours',
    scheduledTasksFormIntervalDays: 'days',
    scheduledTasksFormCronExpression: 'Cron Expression',
    scheduledTasksFormCronPlaceholder: 'e.g. */5 * * * * (every 5 minutes)',
    scheduledTasksFormCronHelp: 'Format: min hour day month weekday (5 fields)',
    scheduledTasksFormPrompt: 'Execution Prompt',
    scheduledTasksFormPromptPlaceholder: 'Enter the prompt to execute...',
    scheduledTasksFormWorkingDirectory: 'Working Directory',
    scheduledTasksFormWorkingDirectoryPlaceholder: 'Enter workspace path',
    scheduledTasksFormSystemPrompt: 'System Prompt',
    scheduledTasksFormSystemPromptPlaceholder: 'Optional system prompt...',
    scheduledTasksFormExecutionMode: 'Execution Mode',
    scheduledTasksFormExecutionModeAuto: 'Auto',
    scheduledTasksFormExecutionModeLocal: 'Local',
    scheduledTasksFormExecutionModeSandbox: 'Sandbox',
    scheduledTasksFormModel: 'Model',
    scheduledTasksFormModelDefault: 'Use default model',
    scheduledTasksFormDatePlaceholder: 'mm/dd/yyyy',
    scheduledTasksFormCalendarLabel: 'Choose date',
    scheduledTasksFormCalendarPreviousMonth: 'Previous month',
    scheduledTasksFormCalendarNextMonth: 'Next month',
    scheduledTasksFormEnabled: 'Enable Task',
    scheduledTasksFormCreate: 'Create Task',
    scheduledTasksFormUpdate: 'Update Task',
    scheduledTasksFormValidationNameRequired: 'Task title is required',
    scheduledTasksFormValidationPromptRequired: 'Execution prompt is required',
    scheduledTasksFormValidationDatetimeFuture: 'Execution time must be in the future',
    scheduledTasksFormValidationIntervalPositive: 'Interval must be greater than 0',
    scheduledTasksFormValidationCronRequired: 'Cron expression is required',
    scheduledTasksEdit: 'Edit',
    scheduledTasksDelete: 'Delete',
    scheduledTasksDeleteConfirm: 'Are you sure you want to delete task "{name}"? This cannot be undone.',
    scheduledTasksRun: 'Run Now',
    scheduledTasksStop: 'Stop',
    scheduledTasksEnabled: 'Enabled',
    scheduledTasksDisabled: 'Disabled',
    scheduledTasksDetail: 'Task Detail',
    scheduledTasksConfiguration: 'Configuration',
    scheduledTasksSchedule: 'Plan',
    scheduledTasksPrompt: 'Prompt',
    scheduledTasksWorkingDirectory: 'Working Directory',
    scheduledTasksSystemPrompt: 'System Prompt',
    scheduledTasksExecutionMode: 'Execution Mode',
    scheduledTasksStatus: 'Status',
    scheduledTasksNextRun: 'Next Run',
    scheduledTasksLastRun: 'Last Run',
    scheduledTasksLastDuration: 'Last Duration',
    scheduledTasksLastError: 'Last Error',
    scheduledTasksConsecutiveErrors: 'Consecutive Errors',
    scheduledTasksRunHistory: 'Run History',
    scheduledTasksNoRuns: 'No runs yet',
    scheduledTasksLoadMore: 'Load More',
    scheduledTasksManual: 'Manual',
    scheduledTasksScheduled: 'Scheduled',
    scheduledTasksViewSession: 'View Session',
    scheduledTasksStatusSuccess: 'Success',
    scheduledTasksStatusError: 'Failed',
    scheduledTasksStatusRunning: 'Running',
    scheduledTasksStatusIdle: 'Idle',
    scheduledTasksNotSet: 'Not set',
    scheduledTasksNone: 'None',
    scheduledTasksScheduleAtLabel: 'One-time',
    scheduledTasksScheduleIntervalLabel: 'Interval',
    scheduledTasksScheduleCronLabel: 'Cron',
    scheduledTasksScheduleEvery: 'Every',
    scheduledTasksAutoDisabledErrors: 'Task auto-disabled due to too many consecutive errors',
    scheduledTasksCreateFailed: 'Failed to create task',
    scheduledTasksUpdateFailed: 'Failed to update task',
    scheduledTasksDeleteFailed: 'Failed to delete task',
    scheduledTasksRunFailed: 'Failed to run task',
    scheduledTasksStopFailed: 'Failed to stop task',
    scheduledTasksFormExpiresAt: 'Expiration Date',
    scheduledTasksFormOptional: '(Optional)',
    scheduledTasksFormExpiresAtHint: 'Optional. Task will stop running after this date',
    scheduledTasksFormExpiresAtClear: 'Clear',
    scheduledTasksFormExpiresAtNone: 'Never expires',
    scheduledTasksDetailExpiresAt: 'Expiration Date',
    scheduledTasksFormNotify: 'Notification',
    scheduledTasksFormNotifyHint: 'Optional. Send task results via IM after completion',
    scheduledTasksFormNotifyDingtalk: 'DingTalk',
    scheduledTasksFormNotifyFeishu: 'Feishu',
    scheduledTasksFormNotifyTelegram: 'Telegram',
    scheduledTasksFormNotifyDiscord: 'Discord',
    scheduledTasksFormNotifyNone: 'None',
    scheduledTasksFormSandboxProfile: 'Sandbox Environment',
    scheduledTasksFormSandboxImage: 'Image',
    scheduledTasksFormSandboxProfileDefault: 'Use default',
    scheduledTasksFormSandboxImageDefault: 'Use default',
    scheduledTasksDetailNotify: 'Notification',
    scheduledTasksToggleWarningAtPast: 'The execution time of this task has passed. It will not run after enabling',
    scheduledTasksToggleWarningExpired: 'This task has expired. It will not run after enabling',

    // Scenarios
    scenarios: 'Scenarios',
    scenariosTitle: 'Scenarios',
    scenariosEmpty: 'No scenarios available',
    scenariosLoadFailed: 'Unable to load scenarios. Check your connection and retry.',
    scenarioApplyToConversation: 'Apply to this conversation',
    scenariosRecentlyUsed: 'Recently used',
    scenariosShuffle: 'Next suggestions',
    scenariosViewAll: 'View all',
    scenariosUsedAt: 'Used {time}',
    scenariosEmptyHint: 'Contact your admin to assign scenarios',
    scenariosStartChat: 'Start Chat',
    scenarioDetailsLoadFailed: 'Unable to check scenario skills. Please retry.',
    scenarioDetailsNoSkills: 'No additional skills required.',
    scenarioDetailsReadOnlyHint: 'Skills are prepared only after confirmation. No message is sent automatically.',
    scenarioDetailsRecommendedModel: 'Recommended model: {model} (global model settings stay unchanged)',
    scenariosHot: 'Hot',
    scenariosRecommended: 'Recommended',
    scenariosUsageCount: '{count} uses',
    scenariosRefresh: 'Refresh',
    scenariosLinkedSkills: 'Linked Skills',
    scenariosDismiss: 'Dismiss',
    scenariosServeYou: ' at your service',
    scenariosServeHint: 'Tell me what you need help with',
    scenariosWorkflow: 'Workflow',
    scenariosAll: 'All',

    // Connectors
    connectors: 'Connectors',
    connectorsDescription: 'Browse and authorize platform connectors. Connected tools become available to Cowork.',
    connectorSearchPlaceholder: 'Search connectors (name / description / provider)',
    connectorFilterAll: 'All',
    connectorFilterMcp: 'MCP',
    connectorIMPurpose: 'Messaging channel: configure and enable a bot to start tasks and receive results from your chat app.',
    connectorIMUnavailable: 'This channel is not supported by Web bot settings; this listing does not indicate an active connection.',
    connectorIMUnsupported: 'Not supported on Web',
    connectorFilterIm: 'Messaging channels',
    connectorConnect: 'Connect',
    connectorReauthRequired: 'Authorization expired',
    connectorReauthorize: 'Reauthorize',
    connectorClientUpgradeRequired: 'Update Web to {version} to connect',
    connectorDesktopOnly: 'This connector requires a desktop connection',
    connectorConfigIncomplete: 'Connector configuration is incomplete. Contact your administrator.',

    connectorConfigure: 'Configure',
    connectorDisconnect: 'Disconnect',
    connectorConnectFailed: 'Connection failed',
    connectorDisconnectFailed: 'Disconnect failed',
    connectorCredentialHint: 'Credentials are stored securely by the platform and are not saved in this browser.',
    connectorEmpty: 'No matching connectors',
    refresh: 'Refresh',
    scenariosSearchPlaceholder: 'Search scenarios by name or description...',
    scenariosNoMatches: 'No matching scenarios found',
    scenariosPreviousPage: 'Previous',
    scenariosNextPage: 'Next',
    scenariosPopularTitle: 'Popular Scenarios',
    scenariosRankingHint: 'Ranked by usage frequency',

    // Tool List
    toolList: 'Tool List',
    toolListDesc: 'Tools configured by administrators on the management platform. AI can call their APIs directly.',
    toolListEmpty: 'No tools available',
    toolListEmptyHint: 'No tools have been configured on the management platform. Please contact your administrator.',
    toolListStatusEnabled: 'Enabled',
    toolListStatusDisabled: 'Disabled',
    toolListRefresh: 'Refresh',
    toolIntegration: 'Tool Integration',
    toolIntegrationDesc: 'Seamlessly connect your AI assistant with enterprise tools — configure credentials to let AI call their APIs directly',
    toolIntegrationDescHint: 'This feature works with corresponding business system skills. For enterprise integration needs, please contact',
    toolIntegrationAdd: 'Add Tool',
    toolIntegrationEdit: 'Edit Tool',
    toolIntegrationDelete: 'Delete Tool',
    toolIntegrationName: 'Tool Name',
    toolIntegrationUrl: 'API URL',
    toolIntegrationAuthType: 'Auth Type',
    toolIntegrationCredentialHint: 'All credentials are encrypted and stored locally on your device, never uploaded to any server',
    toolIntegrationToken: 'Token',
    toolIntegrationUsername: 'Username',
    toolIntegrationPassword: 'Password',
    toolIntegrationLogo: 'Logo',
    toolIntegrationEnabled: 'Enabled',
    toolIntegrationEmpty: 'No tools configured',
    toolIntegrationEmptyHint: 'After adding enterprise systems, AI can use your credentials to call their APIs',
    toolIntegrationConnected: 'Connected tools below — I can query data, submit tickets, and operate these systems for you',
    toolIntegrationDeleteConfirm: 'Delete this tool?',
    toolIntegrationSaved: 'Tool configuration saved',
    toolIntegrationNamePlaceholder: 'e.g. Jira, GitLab',
    toolIntegrationUrlPlaceholder: 'e.g. https://jira.example.com',
    toolIntegrationTestConnection: 'Test Connection',
    toolIntegrationTestingConnection: 'Testing...',
    toolIntegrationConnectionSuccess: 'Connected',
    toolIntegrationConnectionFailed: 'Connection failed, please check the URL',
    toolIntegrationTokenPlaceholder: 'Enter token',
    toolIntegrationUsernamePlaceholder: 'Enter username',
    toolIntegrationPasswordPlaceholder: 'Enter password',
    toolIntegrationSkills: 'Applicable Skills',
    toolIntegrationSkillsHint: 'Select skills for this tool — credentials will be injected automatically',
    toolIntegrationSkillsPlaceholder: 'Search skills…',
    toolIntegrationEnvVarsTitle: 'The following env vars will be injected (readable by skill scripts)',
    toolIntegrationEnvVarsRule: 'Naming rule: skill ID uppercased with - replaced by _, e.g. folib-artifact → FOLIB_ARTIFACT_BASE_URL / FOLIB_ARTIFACT_TOKEN',
    toolIntegrationInjectBtn: 'Inject credentials into skills',
    toolIntegrationInjectSuccess: 'Injected successfully',
    toolIntegrationInjectError: 'Injection failed, please retry',
    toolQuickTasks: 'Quick Tasks',
    toolQuickTasksHint: 'Describe your scenario — add it directly or let AI generate a detailed instruction',
    toolQuickTasksInputPlaceholder: 'e.g. Role: developer, Scenario: check my backlog, Requirements: sorted by priority...',
    toolQuickTasksGenerate: 'Generate',
    toolQuickTasksGenerating: 'Generating...',
    toolQuickTasksAddDirect: 'Add Directly',
    toolQuickTasksSuggestionsTitle: 'Click to add to quick tasks:',
    toolQuickTasksEmptyHint: 'No quick tasks yet — enter a description and click Generate',
    toolQuickTasksClickToUse: 'Click to start a task',

    // Mirror Management
    mirrorManagement: 'Mirror Management',
    mirrorManagementDesc: 'Select one active registry mirror per type for sandbox package management',
    mirrorManagementRefresh: 'Refresh',
    mirrorManagementRefreshing: 'Refreshing...',
    mirrorManagementEmpty: 'No mirrors available',
    mirrorManagementEmptyHint: 'Add registry mirrors in the platform admin panel',
    mirrorManagementSelected: 'Selected',
    mirrorManagementDefault: 'Default',
    mirrorManagementNoSelection: 'No mirror selected',
    mirrorManagementFetchError: 'Failed to fetch mirror list',
    mirrorManagementNpm: 'NPM Mirrors',
    mirrorManagementPypi: 'PyPI Mirrors',
    mirrorManagementApk: 'APK Mirrors',

    // Widget (Generative UI)
    widgetShowCode: 'Show code',
    widgetHideCode: 'Hide code',
    widgetLoading: 'Generating visualization...',
  }
};

class I18nService {
  private currentLanguage: LanguageType = 'zh';
  private listeners = new Set<() => void>();
  
  constructor() {
    // 默认使用中文
    this.currentLanguage = 'zh';
  }
  
  // 初始化语言设置
  async initialize(isLoggedIn = false): Promise<void> {
    try {
      const config = configService.getConfig();

      // 未登录用户优先使用已保存的语言设置，避免退出登录后又恢复为浏览器默认语言。
      if (!isLoggedIn) {
        if (config.language && (config.language === 'zh' || config.language === 'zh-TW' || config.language === 'en')) {
          this.currentLanguage = config.language;
          return;
        }

        const browserLocale = navigator.language;
        const detectedLanguage = this.inferLanguageFromLocale(browserLocale);
        console.log(`[i18n] Not logged in. Browser locale: ${browserLocale}, language: ${detectedLanguage}`);
        this.currentLanguage = detectedLanguage;
        return;
      }

      // 已登录用户：检查是否已经初始化过语言设置
      const languageInitialized = config.language_initialized;

      if (languageInitialized !== true) {
        // 首次登录：检测浏览器语言并持久化
        const browserLocale = navigator.language;
        const defaultLanguage = this.inferLanguageFromLocale(browserLocale);

        console.log(`[i18n] First run for user. Browser locale: ${browserLocale}, default language: ${defaultLanguage}`);

        this.currentLanguage = defaultLanguage;

        configService.updateConfig({
          ...config,
          language: defaultLanguage,
          language_initialized: true
        });
      } else {
        // 非首次登录：使用已保存的语言配置
        if (config.language && (config.language === 'zh' || config.language === 'zh-TW' || config.language === 'en')) {
          this.currentLanguage = config.language;
        } else {
          this.currentLanguage = 'zh';
          configService.updateConfig({
            ...config,
            language: 'zh'
          });
        }
      }
    } catch (error) {
      console.error('Failed to initialize language:', error);
      this.currentLanguage = 'zh';
    }
  }

  // 根据系统语言推断应用语言
  private inferLanguageFromLocale(systemLocale: string): LanguageType {
    // 明确的英文 locale 使用英文
    if (systemLocale.startsWith('en')) {
      return 'en';
    }
    // 港澳台繁体中文 locale 使用繁体中文
    const lower = systemLocale.toLowerCase();
    if (lower.startsWith('zh-tw') || lower.startsWith('zh-hk') || lower.startsWith('zh-mo') || lower.startsWith('zh-hant')) {
      return 'zh-TW';
    }
    return 'zh'; // 默认简体中文
  }
  
  // 设置语言
  setLanguage(language: LanguageType, options: { persist?: boolean } = {}): void {
    const { persist = true } = options;
    const hasChanged = this.currentLanguage !== language;
    this.currentLanguage = language;

    if (hasChanged) {
      this.listeners.forEach((listener) => listener());
    }

    if (!persist) {
      return;
    }

    // 更新配置
    try {
      const config = configService.getConfig();
      configService.updateConfig({
        ...config,
        language
      });
    } catch (error) {
      console.error('Failed to save language setting:', error);
    }
  }
  
  // 获取当前语言
  getLanguage(): LanguageType {
    return this.currentLanguage;
  }
  
  // 获取翻译文本
  t(key: string): string {
    const translation = translations[this.currentLanguage][key];
    if (!translation) {
      console.warn(`Translation missing for key: ${key} in language: ${this.currentLanguage}`);
      // 依次尝试从其他语言获取（zh-TW 优先回退到 zh，再回退到 en）
      const fallbackLangs: LanguageType[] = ['zh', 'en', 'zh-TW'];
      for (const lang of fallbackLangs) {
        if (lang === this.currentLanguage) continue;
        const fallbackTranslation = translations[lang][key];
        if (fallbackTranslation) return fallbackTranslation;
      }
      return key;
    }
    return translation;
  }

  subscribe(listener: () => void): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const i18nService = new I18nService(); 
